'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
var exclamationMark = require('./exclamation-mark-02f43bf2.js');
require('./pill-89b3b361.js');
require('./form-field-8601b6d9.js');
require('./asterisk-436ee6b3.js');
var fieldLabel = require('./field-label-4ed9b7f8.js');
var _commonjsHelpers = require('./_commonjsHelpers-1b94f6bc.js');
require('./field-hint-cc714695.js');
require('./messages-f8f39369.js');
require('./loader-8f6b1e8c.js');
require('./select-6c9d108c.js');
require('./select-item-7fd13c43.js');
require('./select-title-65885e9f.js');
require('./styles-a9f2fe66.js');
require('./calendar-date.styles-9072cd1e.js');
require('./styles-20009c57.js');
require('./index.esm-c41adfff.js');
var index$4 = require('./index-c25ba35c.js');
require('./fa-icon-d6ca067a.js');
require('./field.styles-a36bbd7b.js');
require('./styles-424066e0.js');
require('./overlay-878554b6.js');
require('./paper-e6cfe656.js');
require('./style-0cb3d1f5.js');
require('./styles-558f9987.js');
require('./native-select.styles-3602a739.js');
require('./select-wrapper.styles-0104a777.js');
require('./device.context-f96381a3.js');
require('./mobile-detect-2421ba00.js');
require('./styles-38df6401.js');
require('./styles-f287cb5d.js');
require('./status-indicator-57cc71fd.js');
require('./styles-6fa8f6cf.js');
require('./text-break-b3fca248.js');
require('./tooltip-8d9d80ea.js');
var styleInject_es = require('./style-inject.es-dcee06b6.js');

var css_248z = "/* CSS variables. */\r\n:root {\r\n\t--PhoneInput-color--focus: #03b2cb;\r\n\t--PhoneInputInternationalIconPhone-opacity: 0.8;\r\n\t--PhoneInputInternationalIconGlobe-opacity: 0.65;\r\n\t--PhoneInputCountrySelect-marginRight: 0.35em;\r\n\t--PhoneInputCountrySelectArrow-width: 0.3em;\r\n\t--PhoneInputCountrySelectArrow-marginLeft: var(--PhoneInputCountrySelect-marginRight);\r\n\t--PhoneInputCountrySelectArrow-borderWidth: 1px;\r\n\t--PhoneInputCountrySelectArrow-opacity: 0.45;\r\n\t--PhoneInputCountrySelectArrow-color: inherit;\r\n\t--PhoneInputCountrySelectArrow-color--focus: var(--PhoneInput-color--focus);\r\n\t--PhoneInputCountrySelectArrow-transform: rotate(45deg);\r\n\t--PhoneInputCountryFlag-aspectRatio: 1.5;\r\n\t--PhoneInputCountryFlag-height: 1em;\r\n\t--PhoneInputCountryFlag-borderWidth: 1px;\r\n\t--PhoneInputCountryFlag-borderColor: rgba(0,0,0,0.5);\r\n\t--PhoneInputCountryFlag-borderColor--focus: var(--PhoneInput-color--focus);\r\n\t--PhoneInputCountryFlag-backgroundColor--loading: rgba(0,0,0,0.1);\r\n}\r\n\r\n.PhoneInput {\r\n\t/* This is done to stretch the contents of this component. */\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n}\r\n\r\n.PhoneInputInput {\r\n\t/* The phone number input stretches to fill all empty space */\r\n\tflex: 1;\r\n\t/* The phone number input should shrink\r\n\t   to make room for the extension input */\r\n\tmin-width: 0;\r\n}\r\n\r\n.PhoneInputCountryIcon {\r\n\twidth: calc(var(--PhoneInputCountryFlag-height) * var(--PhoneInputCountryFlag-aspectRatio));\r\n\theight: var(--PhoneInputCountryFlag-height);\r\n}\r\n\r\n.PhoneInputCountryIcon--square {\r\n\twidth: var(--PhoneInputCountryFlag-height);\r\n}\r\n\r\n.PhoneInputCountryIcon--border {\r\n\t/* Removed `background-color` because when an `<img/>` was still loading\r\n\t   it would show a dark gray rectangle. */\r\n\t/* For some reason the `<img/>` is not stretched to 100% width and height\r\n\t   and sometime there can be seen white pixels of the background at top and bottom. */\r\n\tbackground-color: var(--PhoneInputCountryFlag-backgroundColor--loading);\r\n\t/* Border is added via `box-shadow` because `border` interferes with `width`/`height`. */\r\n\t/* For some reason the `<img/>` is not stretched to 100% width and height\r\n\t   and sometime there can be seen white pixels of the background at top and bottom,\r\n\t   so an additional \"inset\" border is added. */\r\n\tbox-shadow: 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor),\r\n\t\tinset 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor);\r\n}\r\n\r\n.PhoneInputCountryIconImg {\r\n\t/* Fixes weird vertical space above the flag icon. */\r\n\t/* https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/7#note_348586559 */\r\n\tdisplay: block;\r\n\t/* 3rd party <SVG/> flag icons won't stretch if they have `width` and `height`.\r\n\t   Also, if an <SVG/> icon's aspect ratio was different, it wouldn't fit too. */\r\n\twidth: 100%;\r\n\theight: 100%;\r\n}\r\n\r\n.PhoneInputInternationalIconPhone {\r\n\topacity: var(--PhoneInputInternationalIconPhone-opacity);\r\n}\r\n\r\n.PhoneInputInternationalIconGlobe {\r\n\topacity: var(--PhoneInputInternationalIconGlobe-opacity);\r\n}\r\n\r\n/* Styling native country `<select/>`. */\r\n\r\n.PhoneInputCountry {\r\n\tposition: relative;\r\n\talign-self: stretch;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tmargin-right: var(--PhoneInputCountrySelect-marginRight);\r\n}\r\n\r\n.PhoneInputCountrySelect {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\theight: 100%;\r\n\twidth: 100%;\r\n\tz-index: 1;\r\n\tborder: 0;\r\n\topacity: 0;\r\n\tcursor: pointer;\r\n}\r\n\r\n.PhoneInputCountrySelect[disabled] {\r\n\tcursor: default;\r\n}\r\n\r\n.PhoneInputCountrySelectArrow {\r\n\tdisplay: block;\r\n\tcontent: '';\r\n\twidth: var(--PhoneInputCountrySelectArrow-width);\r\n\theight: var(--PhoneInputCountrySelectArrow-width);\r\n\tmargin-left: var(--PhoneInputCountrySelectArrow-marginLeft);\r\n\tborder-style: solid;\r\n\tborder-color: var(--PhoneInputCountrySelectArrow-color);\r\n\tborder-top-width: 0;\r\n\tborder-bottom-width: var(--PhoneInputCountrySelectArrow-borderWidth);\r\n\tborder-left-width: 0;\r\n\tborder-right-width: var(--PhoneInputCountrySelectArrow-borderWidth);\r\n\ttransform: var(--PhoneInputCountrySelectArrow-transform);\r\n\topacity: var(--PhoneInputCountrySelectArrow-opacity);\r\n}\r\n\r\n.PhoneInputCountrySelect:focus + .PhoneInputCountryIcon + .PhoneInputCountrySelectArrow {\r\n\topacity: 1;\r\n\tcolor: var(--PhoneInputCountrySelectArrow-color--focus);\r\n}\r\n\r\n.PhoneInputCountrySelect:focus + .PhoneInputCountryIcon--border {\r\n\tbox-shadow: 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor--focus),\r\n\t\tinset 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor--focus);\r\n}\r\n\r\n.PhoneInputCountrySelect:focus + .PhoneInputCountryIcon .PhoneInputInternationalIconGlobe {\r\n\topacity: 1;\r\n\tcolor: var(--PhoneInputCountrySelectArrow-color--focus);\r\n}";
styleInject_es.styleInject(css_248z);

var version = 4;
var country_calling_codes = {
	"1": [
		"US",
		"AG",
		"AI",
		"AS",
		"BB",
		"BM",
		"BS",
		"CA",
		"DM",
		"DO",
		"GD",
		"GU",
		"JM",
		"KN",
		"KY",
		"LC",
		"MP",
		"MS",
		"PR",
		"SX",
		"TC",
		"TT",
		"VC",
		"VG",
		"VI"
	],
	"7": [
		"RU",
		"KZ"
	],
	"20": [
		"EG"
	],
	"27": [
		"ZA"
	],
	"30": [
		"GR"
	],
	"31": [
		"NL"
	],
	"32": [
		"BE"
	],
	"33": [
		"FR"
	],
	"34": [
		"ES"
	],
	"36": [
		"HU"
	],
	"39": [
		"IT",
		"VA"
	],
	"40": [
		"RO"
	],
	"41": [
		"CH"
	],
	"43": [
		"AT"
	],
	"44": [
		"GB",
		"GG",
		"IM",
		"JE"
	],
	"45": [
		"DK"
	],
	"46": [
		"SE"
	],
	"47": [
		"NO",
		"SJ"
	],
	"48": [
		"PL"
	],
	"49": [
		"DE"
	],
	"51": [
		"PE"
	],
	"52": [
		"MX"
	],
	"53": [
		"CU"
	],
	"54": [
		"AR"
	],
	"55": [
		"BR"
	],
	"56": [
		"CL"
	],
	"57": [
		"CO"
	],
	"58": [
		"VE"
	],
	"60": [
		"MY"
	],
	"61": [
		"AU",
		"CC",
		"CX"
	],
	"62": [
		"ID"
	],
	"63": [
		"PH"
	],
	"64": [
		"NZ"
	],
	"65": [
		"SG"
	],
	"66": [
		"TH"
	],
	"81": [
		"JP"
	],
	"82": [
		"KR"
	],
	"84": [
		"VN"
	],
	"86": [
		"CN"
	],
	"90": [
		"TR"
	],
	"91": [
		"IN"
	],
	"92": [
		"PK"
	],
	"93": [
		"AF"
	],
	"94": [
		"LK"
	],
	"95": [
		"MM"
	],
	"98": [
		"IR"
	],
	"211": [
		"SS"
	],
	"212": [
		"MA",
		"EH"
	],
	"213": [
		"DZ"
	],
	"216": [
		"TN"
	],
	"218": [
		"LY"
	],
	"220": [
		"GM"
	],
	"221": [
		"SN"
	],
	"222": [
		"MR"
	],
	"223": [
		"ML"
	],
	"224": [
		"GN"
	],
	"225": [
		"CI"
	],
	"226": [
		"BF"
	],
	"227": [
		"NE"
	],
	"228": [
		"TG"
	],
	"229": [
		"BJ"
	],
	"230": [
		"MU"
	],
	"231": [
		"LR"
	],
	"232": [
		"SL"
	],
	"233": [
		"GH"
	],
	"234": [
		"NG"
	],
	"235": [
		"TD"
	],
	"236": [
		"CF"
	],
	"237": [
		"CM"
	],
	"238": [
		"CV"
	],
	"239": [
		"ST"
	],
	"240": [
		"GQ"
	],
	"241": [
		"GA"
	],
	"242": [
		"CG"
	],
	"243": [
		"CD"
	],
	"244": [
		"AO"
	],
	"245": [
		"GW"
	],
	"246": [
		"IO"
	],
	"247": [
		"AC"
	],
	"248": [
		"SC"
	],
	"249": [
		"SD"
	],
	"250": [
		"RW"
	],
	"251": [
		"ET"
	],
	"252": [
		"SO"
	],
	"253": [
		"DJ"
	],
	"254": [
		"KE"
	],
	"255": [
		"TZ"
	],
	"256": [
		"UG"
	],
	"257": [
		"BI"
	],
	"258": [
		"MZ"
	],
	"260": [
		"ZM"
	],
	"261": [
		"MG"
	],
	"262": [
		"RE",
		"YT"
	],
	"263": [
		"ZW"
	],
	"264": [
		"NA"
	],
	"265": [
		"MW"
	],
	"266": [
		"LS"
	],
	"267": [
		"BW"
	],
	"268": [
		"SZ"
	],
	"269": [
		"KM"
	],
	"290": [
		"SH",
		"TA"
	],
	"291": [
		"ER"
	],
	"297": [
		"AW"
	],
	"298": [
		"FO"
	],
	"299": [
		"GL"
	],
	"350": [
		"GI"
	],
	"351": [
		"PT"
	],
	"352": [
		"LU"
	],
	"353": [
		"IE"
	],
	"354": [
		"IS"
	],
	"355": [
		"AL"
	],
	"356": [
		"MT"
	],
	"357": [
		"CY"
	],
	"358": [
		"FI",
		"AX"
	],
	"359": [
		"BG"
	],
	"370": [
		"LT"
	],
	"371": [
		"LV"
	],
	"372": [
		"EE"
	],
	"373": [
		"MD"
	],
	"374": [
		"AM"
	],
	"375": [
		"BY"
	],
	"376": [
		"AD"
	],
	"377": [
		"MC"
	],
	"378": [
		"SM"
	],
	"380": [
		"UA"
	],
	"381": [
		"RS"
	],
	"382": [
		"ME"
	],
	"383": [
		"XK"
	],
	"385": [
		"HR"
	],
	"386": [
		"SI"
	],
	"387": [
		"BA"
	],
	"389": [
		"MK"
	],
	"420": [
		"CZ"
	],
	"421": [
		"SK"
	],
	"423": [
		"LI"
	],
	"500": [
		"FK"
	],
	"501": [
		"BZ"
	],
	"502": [
		"GT"
	],
	"503": [
		"SV"
	],
	"504": [
		"HN"
	],
	"505": [
		"NI"
	],
	"506": [
		"CR"
	],
	"507": [
		"PA"
	],
	"508": [
		"PM"
	],
	"509": [
		"HT"
	],
	"590": [
		"GP",
		"BL",
		"MF"
	],
	"591": [
		"BO"
	],
	"592": [
		"GY"
	],
	"593": [
		"EC"
	],
	"594": [
		"GF"
	],
	"595": [
		"PY"
	],
	"596": [
		"MQ"
	],
	"597": [
		"SR"
	],
	"598": [
		"UY"
	],
	"599": [
		"CW",
		"BQ"
	],
	"670": [
		"TL"
	],
	"672": [
		"NF"
	],
	"673": [
		"BN"
	],
	"674": [
		"NR"
	],
	"675": [
		"PG"
	],
	"676": [
		"TO"
	],
	"677": [
		"SB"
	],
	"678": [
		"VU"
	],
	"679": [
		"FJ"
	],
	"680": [
		"PW"
	],
	"681": [
		"WF"
	],
	"682": [
		"CK"
	],
	"683": [
		"NU"
	],
	"685": [
		"WS"
	],
	"686": [
		"KI"
	],
	"687": [
		"NC"
	],
	"688": [
		"TV"
	],
	"689": [
		"PF"
	],
	"690": [
		"TK"
	],
	"691": [
		"FM"
	],
	"692": [
		"MH"
	],
	"850": [
		"KP"
	],
	"852": [
		"HK"
	],
	"853": [
		"MO"
	],
	"855": [
		"KH"
	],
	"856": [
		"LA"
	],
	"880": [
		"BD"
	],
	"886": [
		"TW"
	],
	"960": [
		"MV"
	],
	"961": [
		"LB"
	],
	"962": [
		"JO"
	],
	"963": [
		"SY"
	],
	"964": [
		"IQ"
	],
	"965": [
		"KW"
	],
	"966": [
		"SA"
	],
	"967": [
		"YE"
	],
	"968": [
		"OM"
	],
	"970": [
		"PS"
	],
	"971": [
		"AE"
	],
	"972": [
		"IL"
	],
	"973": [
		"BH"
	],
	"974": [
		"QA"
	],
	"975": [
		"BT"
	],
	"976": [
		"MN"
	],
	"977": [
		"NP"
	],
	"992": [
		"TJ"
	],
	"993": [
		"TM"
	],
	"994": [
		"AZ"
	],
	"995": [
		"GE"
	],
	"996": [
		"KG"
	],
	"998": [
		"UZ"
	]
};
var countries = {
	AC: [
		"247",
		"00",
		"(?:[01589]\\d|[46])\\d{4}",
		[
			5,
			6
		]
	],
	AD: [
		"376",
		"00",
		"(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
		[
			6,
			8,
			9
		],
		[
			[
				"(\\d{3})(\\d{3})",
				"$1 $2",
				[
					"[135-9]"
				]
			],
			[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				[
					"1"
				]
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"6"
				]
			]
		]
	],
	AE: [
		"971",
		"00",
		"(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
		[
			5,
			6,
			7,
			8,
			9,
			10,
			11,
			12
		],
		[
			[
				"(\\d{3})(\\d{2,9})",
				"$1 $2",
				[
					"60|8"
				]
			],
			[
				"(\\d)(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"[236]|[479][2-8]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d)(\\d{5})",
				"$1 $2 $3",
				[
					"[479]"
				]
			],
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"5"
				],
				"0$1"
			]
		],
		"0"
	],
	AF: [
		"93",
		"00",
		"[2-7]\\d{8}",
		[
			9
		],
		[
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"[2-7]"
				],
				"0$1"
			]
		],
		"0"
	],
	AG: [
		"1",
		"011",
		"(?:268|[58]\\d\\d|900)\\d{7}",
		[
			10
		],
		0,
		"1",
		0,
		"1|([457]\\d{6})$",
		"268$1",
		0,
		"268"
	],
	AI: [
		"1",
		"011",
		"(?:264|[58]\\d\\d|900)\\d{7}",
		[
			10
		],
		0,
		"1",
		0,
		"1|([2457]\\d{6})$",
		"264$1",
		0,
		"264"
	],
	AL: [
		"355",
		"00",
		"(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
		[
			6,
			7,
			8,
			9
		],
		[
			[
				"(\\d{3})(\\d{3,4})",
				"$1 $2",
				[
					"80|9"
				],
				"0$1"
			],
			[
				"(\\d)(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"4[2-6]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[2358][2-5]|4"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{5})",
				"$1 $2",
				[
					"[23578]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"6"
				],
				"0$1"
			]
		],
		"0"
	],
	AM: [
		"374",
		"00",
		"(?:[1-489]\\d|55|60|77)\\d{6}",
		[
			8
		],
		[
			[
				"(\\d{3})(\\d{2})(\\d{3})",
				"$1 $2 $3",
				[
					"[89]0"
				],
				"0 $1"
			],
			[
				"(\\d{3})(\\d{5})",
				"$1 $2",
				[
					"2|3[12]"
				],
				"(0$1)"
			],
			[
				"(\\d{2})(\\d{6})",
				"$1 $2",
				[
					"1|47"
				],
				"(0$1)"
			],
			[
				"(\\d{2})(\\d{6})",
				"$1 $2",
				[
					"[3-9]"
				],
				"0$1"
			]
		],
		"0"
	],
	AO: [
		"244",
		"00",
		"[29]\\d{8}",
		[
			9
		],
		[
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[29]"
				]
			]
		]
	],
	AR: [
		"54",
		"00",
		"(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
		[
			10,
			11
		],
		[
			[
				"(\\d{4})(\\d{2})(\\d{4})",
				"$1 $2-$3",
				[
					"2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
					"2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
					"2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
					"2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
				],
				"0$1",
				1
			],
			[
				"(\\d{2})(\\d{4})(\\d{4})",
				"$1 $2-$3",
				[
					"1"
				],
				"0$1",
				1
			],
			[
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1-$2-$3",
				[
					"[68]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1 $2-$3",
				[
					"[23]"
				],
				"0$1",
				1
			],
			[
				"(\\d)(\\d{4})(\\d{2})(\\d{4})",
				"$2 15-$3-$4",
				[
					"9(?:2[2-469]|3[3-578])",
					"9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
					"9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
					"9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
					"9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
				],
				"0$1",
				0,
				"$1 $2 $3-$4"
			],
			[
				"(\\d)(\\d{2})(\\d{4})(\\d{4})",
				"$2 15-$3-$4",
				[
					"91"
				],
				"0$1",
				0,
				"$1 $2 $3-$4"
			],
			[
				"(\\d{3})(\\d{3})(\\d{5})",
				"$1-$2-$3",
				[
					"8"
				],
				"0$1"
			],
			[
				"(\\d)(\\d{3})(\\d{3})(\\d{4})",
				"$2 15-$3-$4",
				[
					"9"
				],
				"0$1",
				0,
				"$1 $2 $3-$4"
			]
		],
		"0",
		0,
		"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
		"9$1"
	],
	AS: [
		"1",
		"011",
		"(?:[58]\\d\\d|684|900)\\d{7}",
		[
			10
		],
		0,
		"1",
		0,
		"1|([267]\\d{6})$",
		"684$1",
		0,
		"684"
	],
	AT: [
		"43",
		"00",
		"1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
		[
			4,
			5,
			6,
			7,
			8,
			9,
			10,
			11,
			12,
			13
		],
		[
			[
				"(\\d)(\\d{3,12})",
				"$1 $2",
				[
					"1(?:11|[2-9])"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{2})",
				"$1 $2",
				[
					"517"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3,5})",
				"$1 $2",
				[
					"5[079]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3,10})",
				"$1 $2",
				[
					"(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
				],
				"0$1"
			],
			[
				"(\\d{4})(\\d{3,9})",
				"$1 $2",
				[
					"[2-467]|5[2-6]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"5"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{4})(\\d{4,7})",
				"$1 $2 $3",
				[
					"5"
				],
				"0$1"
			]
		],
		"0"
	],
	AU: [
		"61",
		"001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
		"1(?:[0-79]\\d{7,8}|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
		[
			5,
			6,
			7,
			8,
			9,
			10
		],
		[
			[
				"(\\d{2})(\\d{3,4})",
				"$1 $2",
				[
					"16"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{2,4})",
				"$1 $2 $3",
				[
					"16"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"14|4"
				],
				"0$1"
			],
			[
				"(\\d)(\\d{4})(\\d{4})",
				"$1 $2 $3",
				[
					"[2378]"
				],
				"(0$1)"
			],
			[
				"(\\d{4})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"1(?:30|[89])"
				]
			]
		],
		"0",
		0,
		"0|(183[12])",
		0,
		0,
		0,
		[
			[
				"(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
				[
					9
				]
			],
			[
				"4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",
				[
					9
				]
			],
			[
				"180(?:0\\d{3}|2)\\d{3}",
				[
					7,
					10
				]
			],
			[
				"190[0-26]\\d{6}",
				[
					10
				]
			],
			0,
			0,
			0,
			[
				"163\\d{2,6}",
				[
					5,
					6,
					7,
					8,
					9
				]
			],
			[
				"14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
				[
					9
				]
			],
			[
				"13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",
				[
					6,
					8,
					10
				]
			]
		],
		"0011"
	],
	AW: [
		"297",
		"00",
		"(?:[25-79]\\d\\d|800)\\d{4}",
		[
			7
		],
		[
			[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				[
					"[25-9]"
				]
			]
		]
	],
	AX: [
		"358",
		"00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
		"2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
		[
			5,
			6,
			7,
			8,
			9,
			10,
			11,
			12
		],
		0,
		"0",
		0,
		0,
		0,
		0,
		"18",
		0,
		"00"
	],
	AZ: [
		"994",
		"00",
		"365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
		[
			9
		],
		[
			[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"90"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"1[28]|2|365|46",
					"1[28]|2|365|46",
					"1[28]|2|365(?:[0-46-9]|5[0-35-9])|46"
				],
				"(0$1)"
			],
			[
				"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[13-9]"
				],
				"0$1"
			]
		],
		"0"
	],
	BA: [
		"387",
		"00",
		"6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
		[
			8,
			9
		],
		[
			[
				"(\\d{2})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"6[1-3]|[7-9]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{3})",
				"$1 $2-$3",
				[
					"[3-5]|6[56]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
				"$1 $2 $3 $4",
				[
					"6"
				],
				"0$1"
			]
		],
		"0"
	],
	BB: [
		"1",
		"011",
		"(?:246|[58]\\d\\d|900)\\d{7}",
		[
			10
		],
		0,
		"1",
		0,
		"1|([2-9]\\d{6})$",
		"246$1",
		0,
		"246"
	],
	BD: [
		"880",
		"00",
		"1\\d{9}|2\\d{7,8}|88\\d{4,6}|(?:8[0-79]|9\\d)\\d{4,8}|(?:[346]\\d|[57])\\d{5,8}",
		[
			6,
			7,
			8,
			9,
			10
		],
		[
			[
				"(\\d{2})(\\d{4,6})",
				"$1-$2",
				[
					"31[5-8]|[459]1"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3,7})",
				"$1-$2",
				[
					"3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
				],
				"0$1"
			],
			[
				"(\\d{4})(\\d{3,6})",
				"$1-$2",
				[
					"[13-9]"
				],
				"0$1"
			],
			[
				"(\\d)(\\d{7,8})",
				"$1-$2",
				[
					"2"
				],
				"0$1"
			]
		],
		"0"
	],
	BE: [
		"32",
		"00",
		"4\\d{8}|[1-9]\\d{7}",
		[
			8,
			9
		],
		[
			[
				"(\\d{3})(\\d{2})(\\d{3})",
				"$1 $2 $3",
				[
					"(?:80|9)0"
				],
				"0$1"
			],
			[
				"(\\d)(\\d{3})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[239]|4[23]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[15-8]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"4"
				],
				"0$1"
			]
		],
		"0"
	],
	BF: [
		"226",
		"00",
		"[025-7]\\d{7}",
		[
			8
		],
		[
			[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[025-7]"
				]
			]
		]
	],
	BG: [
		"359",
		"00",
		"[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
		[
			6,
			7,
			8,
			9
		],
		[
			[
				"(\\d)(\\d)(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"2"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				[
					"43[1-6]|70[1-9]"
				],
				"0$1"
			],
			[
				"(\\d)(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"2"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{2,3})",
				"$1 $2 $3",
				[
					"[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{2})(\\d{3})",
				"$1 $2 $3",
				[
					"(?:70|8)0"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{2})",
				"$1 $2 $3",
				[
					"43[1-7]|7"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"[48]|9[08]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"9"
				],
				"0$1"
			]
		],
		"0"
	],
	BH: [
		"973",
		"00",
		"[136-9]\\d{7}",
		[
			8
		],
		[
			[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				[
					"[13679]|8[047]"
				]
			]
		]
	],
	BI: [
		"257",
		"00",
		"(?:[267]\\d|31)\\d{6}",
		[
			8
		],
		[
			[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[2367]"
				]
			]
		]
	],
	BJ: [
		"229",
		"00",
		"[25689]\\d{7}",
		[
			8
		],
		[
			[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[25689]"
				]
			]
		]
	],
	BL: [
		"590",
		"00",
		"(?:590|(?:69|80)\\d|976)\\d{6}",
		[
			9
		],
		0,
		"0",
		0,
		0,
		0,
		0,
		0,
		[
			[
				"590(?:2[7-9]|5[12]|87)\\d{4}"
			],
			[
				"69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
			],
			[
				"80[0-5]\\d{6}"
			],
			0,
			0,
			0,
			0,
			0,
			[
				"976[01]\\d{5}"
			]
		]
	],
	BM: [
		"1",
		"011",
		"(?:441|[58]\\d\\d|900)\\d{7}",
		[
			10
		],
		0,
		"1",
		0,
		"1|([2-8]\\d{6})$",
		"441$1",
		0,
		"441"
	],
	BN: [
		"673",
		"00",
		"[2-578]\\d{6}",
		[
			7
		],
		[
			[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				[
					"[2-578]"
				]
			]
		]
	],
	BO: [
		"591",
		"00(?:1\\d)?",
		"(?:[2-467]\\d\\d|8001)\\d{5}",
		[
			8,
			9
		],
		[
			[
				"(\\d)(\\d{7})",
				"$1 $2",
				[
					"[23]|4[46]"
				]
			],
			[
				"(\\d{8})",
				"$1",
				[
					"[67]"
				]
			],
			[
				"(\\d{3})(\\d{2})(\\d{4})",
				"$1 $2 $3",
				[
					"8"
				]
			]
		],
		"0",
		0,
		"0(1\\d)?"
	],
	BQ: [
		"599",
		"00",
		"(?:[34]1|7\\d)\\d{5}",
		[
			7
		],
		0,
		0,
		0,
		0,
		0,
		0,
		"[347]"
	],
	BR: [
		"55",
		"00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
		"(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-24679]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
		[
			8,
			9,
			10,
			11
		],
		[
			[
				"(\\d{4})(\\d{4})",
				"$1-$2",
				[
					"300|4(?:0[02]|37)",
					"4(?:02|37)0|[34]00"
				]
			],
			[
				"(\\d{3})(\\d{2,3})(\\d{4})",
				"$1 $2 $3",
				[
					"(?:[358]|90)0"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{4})(\\d{4})",
				"$1 $2-$3",
				[
					"(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
				],
				"($1)"
			],
			[
				"(\\d{2})(\\d{5})(\\d{4})",
				"$1 $2-$3",
				[
					"[16][1-9]|[2-57-9]"
				],
				"($1)"
			]
		],
		"0",
		0,
		"(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
		"$2"
	],
	BS: [
		"1",
		"011",
		"(?:242|[58]\\d\\d|900)\\d{7}",
		[
			10
		],
		0,
		"1",
		0,
		"1|([3-8]\\d{6})$",
		"242$1",
		0,
		"242"
	],
	BT: [
		"975",
		"00",
		"[17]\\d{7}|[2-8]\\d{6}",
		[
			7,
			8
		],
		[
			[
				"(\\d)(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[2-68]|7[246]"
				]
			],
			[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"1[67]|7"
				]
			]
		]
	],
	BW: [
		"267",
		"00",
		"(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
		[
			7,
			8,
			10
		],
		[
			[
				"(\\d{2})(\\d{5})",
				"$1 $2",
				[
					"90"
				]
			],
			[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				[
					"[24-6]|3[15-79]"
				]
			],
			[
				"(\\d{2})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[37]"
				]
			],
			[
				"(\\d{4})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"0"
				]
			],
			[
				"(\\d{3})(\\d{4})(\\d{3})",
				"$1 $2 $3",
				[
					"8"
				]
			]
		]
	],
	BY: [
		"375",
		"810",
		"(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
		[
			6,
			7,
			8,
			9,
			10,
			11
		],
		[
			[
				"(\\d{3})(\\d{3})",
				"$1 $2",
				[
					"800"
				],
				"8 $1"
			],
			[
				"(\\d{3})(\\d{2})(\\d{2,4})",
				"$1 $2 $3",
				[
					"800"
				],
				"8 $1"
			],
			[
				"(\\d{4})(\\d{2})(\\d{3})",
				"$1 $2-$3",
				[
					"1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
					"1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
				],
				"8 0$1"
			],
			[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2-$3-$4",
				[
					"1(?:[56]|7[467])|2[1-3]"
				],
				"8 0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
				"$1 $2-$3-$4",
				[
					"[1-4]"
				],
				"8 0$1"
			],
			[
				"(\\d{3})(\\d{3,4})(\\d{4})",
				"$1 $2 $3",
				[
					"[89]"
				],
				"8 $1"
			]
		],
		"8",
		0,
		"0|80?",
		0,
		0,
		0,
		0,
		"8~10"
	],
	BZ: [
		"501",
		"00",
		"(?:0800\\d|[2-8])\\d{6}",
		[
			7,
			11
		],
		[
			[
				"(\\d{3})(\\d{4})",
				"$1-$2",
				[
					"[2-8]"
				]
			],
			[
				"(\\d)(\\d{3})(\\d{4})(\\d{3})",
				"$1-$2-$3-$4",
				[
					"0"
				]
			]
		]
	],
	CA: [
		"1",
		"011",
		"(?:[2-8]\\d|90)\\d{8}",
		[
			10
		],
		0,
		"1",
		0,
		0,
		0,
		0,
		0,
		[
			[
				"(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[578])|4(?:03|1[68]|3[178]|50|74)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}"
			],
			[
				""
			],
			[
				"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
			],
			[
				"900[2-9]\\d{6}"
			],
			[
				"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[12]|33|44|66|77|88)|622)[2-9]\\d{6}"
			],
			0,
			0,
			0,
			[
				"600[2-9]\\d{6}"
			]
		]
	],
	CC: [
		"61",
		"001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
		"1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}",
		[
			6,
			7,
			8,
			9,
			10
		],
		0,
		"0",
		0,
		"0|([59]\\d{7})$",
		"8$1",
		0,
		0,
		[
			[
				"8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
				[
					9
				]
			],
			[
				"4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",
				[
					9
				]
			],
			[
				"180(?:0\\d{3}|2)\\d{3}",
				[
					7,
					10
				]
			],
			[
				"190[0-26]\\d{6}",
				[
					10
				]
			],
			0,
			0,
			0,
			0,
			[
				"14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
				[
					9
				]
			],
			[
				"13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",
				[
					6,
					8,
					10
				]
			]
		],
		"0011"
	],
	CD: [
		"243",
		"00",
		"[189]\\d{8}|[1-68]\\d{6}",
		[
			7,
			9
		],
		[
			[
				"(\\d{2})(\\d{2})(\\d{3})",
				"$1 $2 $3",
				[
					"88"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{5})",
				"$1 $2",
				[
					"[1-6]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"1"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[89]"
				],
				"0$1"
			]
		],
		"0"
	],
	CF: [
		"236",
		"00",
		"(?:[27]\\d{3}|8776)\\d{4}",
		[
			8
		],
		[
			[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[278]"
				]
			]
		]
	],
	CG: [
		"242",
		"00",
		"222\\d{6}|(?:0\\d|80)\\d{7}",
		[
			9
		],
		[
			[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"801"
				]
			],
			[
				"(\\d)(\\d{4})(\\d{4})",
				"$1 $2 $3",
				[
					"8"
				]
			],
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"[02]"
				]
			]
		]
	],
	CH: [
		"41",
		"00",
		"8\\d{11}|[2-9]\\d{8}",
		[
			9
		],
		[
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"8[047]|90"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[2-79]|81"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4 $5",
				[
					"8"
				],
				"0$1"
			]
		],
		"0"
	],
	CI: [
		"225",
		"00",
		"[02]\\d{9}",
		[
			10
		],
		[
			[
				"(\\d{2})(\\d{2})(\\d)(\\d{5})",
				"$1 $2 $3 $4",
				[
					"2"
				]
			],
			[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
				"$1 $2 $3 $4",
				[
					"0"
				]
			]
		]
	],
	CK: [
		"682",
		"00",
		"[2-578]\\d{4}",
		[
			5
		],
		[
			[
				"(\\d{2})(\\d{3})",
				"$1 $2",
				[
					"[2-578]"
				]
			]
		]
	],
	CL: [
		"56",
		"(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
		"12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
		[
			9,
			10,
			11
		],
		[
			[
				"(\\d{5})(\\d{4})",
				"$1 $2",
				[
					"219",
					"2196"
				],
				"($1)"
			],
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"44"
				]
			],
			[
				"(\\d)(\\d{4})(\\d{4})",
				"$1 $2 $3",
				[
					"2[1-3]"
				],
				"($1)"
			],
			[
				"(\\d)(\\d{4})(\\d{4})",
				"$1 $2 $3",
				[
					"9[2-9]"
				]
			],
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
				],
				"($1)"
			],
			[
				"(\\d{3})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"60|8"
				]
			],
			[
				"(\\d{4})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"1"
				]
			],
			[
				"(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
				"$1 $2 $3 $4",
				[
					"60"
				]
			]
		]
	],
	CM: [
		"237",
		"00",
		"[26]\\d{8}|88\\d{6,7}",
		[
			8,
			9
		],
		[
			[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"88"
				]
			],
			[
				"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4 $5",
				[
					"[26]|88"
				]
			]
		]
	],
	CN: [
		"86",
		"00|1(?:[12]\\d|79)\\d\\d00",
		"1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",
		[
			7,
			8,
			9,
			10,
			11,
			12
		],
		[
			[
				"(\\d{2})(\\d{5,6})",
				"$1 $2",
				[
					"(?:10|2[0-57-9])[19]",
					"(?:10|2[0-57-9])(?:10|9[56])",
					"(?:10|2[0-57-9])(?:100|9[56])"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{5,6})",
				"$1 $2",
				[
					"3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
					"(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
					"85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
					"85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"(?:4|80)0"
				]
			],
			[
				"(\\d{2})(\\d{4})(\\d{4})",
				"$1 $2 $3",
				[
					"10|2(?:[02-57-9]|1[1-9])",
					"10|2(?:[02-57-9]|1[1-9])",
					"10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
				],
				"0$1",
				1
			],
			[
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
				],
				"0$1",
				1
			],
			[
				"(\\d{3})(\\d{7,8})",
				"$1 $2",
				[
					"9"
				]
			],
			[
				"(\\d{4})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"80"
				],
				"0$1",
				1
			],
			[
				"(\\d{3})(\\d{4})(\\d{4})",
				"$1 $2 $3",
				[
					"[3-578]"
				],
				"0$1",
				1
			],
			[
				"(\\d{3})(\\d{4})(\\d{4})",
				"$1 $2 $3",
				[
					"1[3-9]"
				]
			],
			[
				"(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
				"$1 $2 $3 $4",
				[
					"[12]"
				],
				"0$1",
				1
			]
		],
		"0",
		0,
		"0|(1(?:[12]\\d|79)\\d\\d)",
		0,
		0,
		0,
		0,
		"00"
	],
	CO: [
		"57",
		"00(?:4(?:[14]4|56)|[579])",
		"(?:(?:1\\d|[36])\\d{3}|9101)\\d{6}|[124-8]\\d{7}",
		[
			8,
			10,
			11
		],
		[
			[
				"(\\d)(\\d{7})",
				"$1 $2",
				[
					"[146][2-9]|[2578]"
				],
				"($1)"
			],
			[
				"(\\d{3})(\\d{7})",
				"$1 $2",
				[
					"6"
				],
				"($1)"
			],
			[
				"(\\d{3})(\\d{7})",
				"$1 $2",
				[
					"[39]"
				]
			],
			[
				"(\\d)(\\d{3})(\\d{7})",
				"$1-$2-$3",
				[
					"1"
				],
				"0$1",
				0,
				"$1 $2 $3"
			]
		],
		"0",
		0,
		"0([3579]|4(?:[14]4|56))?"
	],
	CR: [
		"506",
		"00",
		"(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
		[
			8,
			10
		],
		[
			[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				[
					"[2-7]|8[3-9]"
				]
			],
			[
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1-$2-$3",
				[
					"[89]"
				]
			]
		],
		0,
		0,
		"(19(?:0[0-2468]|1[09]|20|66|77|99))"
	],
	CU: [
		"53",
		"119",
		"[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}",
		[
			6,
			7,
			8,
			10
		],
		[
			[
				"(\\d{2})(\\d{4,6})",
				"$1 $2",
				[
					"2[1-4]|[34]"
				],
				"(0$1)"
			],
			[
				"(\\d)(\\d{6,7})",
				"$1 $2",
				[
					"7"
				],
				"(0$1)"
			],
			[
				"(\\d)(\\d{7})",
				"$1 $2",
				[
					"5"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{7})",
				"$1 $2",
				[
					"8"
				],
				"0$1"
			]
		],
		"0"
	],
	CV: [
		"238",
		"0",
		"(?:[2-59]\\d\\d|800)\\d{4}",
		[
			7
		],
		[
			[
				"(\\d{3})(\\d{2})(\\d{2})",
				"$1 $2 $3",
				[
					"[2-589]"
				]
			]
		]
	],
	CW: [
		"599",
		"00",
		"(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
		[
			7,
			8
		],
		[
			[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				[
					"[3467]"
				]
			],
			[
				"(\\d)(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"9[4-8]"
				]
			]
		],
		0,
		0,
		0,
		0,
		0,
		"[69]"
	],
	CX: [
		"61",
		"001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
		"1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}",
		[
			6,
			7,
			8,
			9,
			10
		],
		0,
		"0",
		0,
		"0|([59]\\d{7})$",
		"8$1",
		0,
		0,
		[
			[
				"8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
				[
					9
				]
			],
			[
				"4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",
				[
					9
				]
			],
			[
				"180(?:0\\d{3}|2)\\d{3}",
				[
					7,
					10
				]
			],
			[
				"190[0-26]\\d{6}",
				[
					10
				]
			],
			0,
			0,
			0,
			0,
			[
				"14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
				[
					9
				]
			],
			[
				"13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",
				[
					6,
					8,
					10
				]
			]
		],
		"0011"
	],
	CY: [
		"357",
		"00",
		"(?:[279]\\d|[58]0)\\d{6}",
		[
			8
		],
		[
			[
				"(\\d{2})(\\d{6})",
				"$1 $2",
				[
					"[257-9]"
				]
			]
		]
	],
	CZ: [
		"420",
		"00",
		"(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
		[
			9
		],
		[
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[2-8]|9[015-7]"
				]
			],
			[
				"(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3 $4",
				[
					"9"
				]
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3 $4",
				[
					"9"
				]
			]
		]
	],
	DE: [
		"49",
		"00",
		"[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:[12]\\d|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[05]\\d|31|[46][1-8])\\d{1,9}",
		[
			4,
			5,
			6,
			7,
			8,
			9,
			10,
			11,
			12,
			13,
			14,
			15
		],
		[
			[
				"(\\d{2})(\\d{3,13})",
				"$1 $2",
				[
					"3[02]|40|[68]9"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3,12})",
				"$1 $2",
				[
					"2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
					"2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
				],
				"0$1"
			],
			[
				"(\\d{4})(\\d{2,11})",
				"$1 $2",
				[
					"[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
					"[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				[
					"138"
				],
				"0$1"
			],
			[
				"(\\d{5})(\\d{2,10})",
				"$1 $2",
				[
					"3"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{5,11})",
				"$1 $2",
				[
					"181"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d)(\\d{4,10})",
				"$1 $2 $3",
				[
					"1(?:3|80)|9"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{7,8})",
				"$1 $2",
				[
					"1[67]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{7,12})",
				"$1 $2",
				[
					"8"
				],
				"0$1"
			],
			[
				"(\\d{5})(\\d{6})",
				"$1 $2",
				[
					"185",
					"1850",
					"18500"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{4})(\\d{4})",
				"$1 $2 $3",
				[
					"7"
				],
				"0$1"
			],
			[
				"(\\d{4})(\\d{7})",
				"$1 $2",
				[
					"18[68]"
				],
				"0$1"
			],
			[
				"(\\d{5})(\\d{6})",
				"$1 $2",
				[
					"15[0568]"
				],
				"0$1"
			],
			[
				"(\\d{4})(\\d{7})",
				"$1 $2",
				[
					"15[1279]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{8})",
				"$1 $2",
				[
					"18"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{2})(\\d{7,8})",
				"$1 $2 $3",
				[
					"1(?:6[023]|7)"
				],
				"0$1"
			],
			[
				"(\\d{4})(\\d{2})(\\d{7})",
				"$1 $2 $3",
				[
					"15[279]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{2})(\\d{8})",
				"$1 $2 $3",
				[
					"15"
				],
				"0$1"
			]
		],
		"0"
	],
	DJ: [
		"253",
		"00",
		"(?:2\\d|77)\\d{6}",
		[
			8
		],
		[
			[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[27]"
				]
			]
		]
	],
	DK: [
		"45",
		"00",
		"[2-9]\\d{7}",
		[
			8
		],
		[
			[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[2-9]"
				]
			]
		]
	],
	DM: [
		"1",
		"011",
		"(?:[58]\\d\\d|767|900)\\d{7}",
		[
			10
		],
		0,
		"1",
		0,
		"1|([2-7]\\d{6})$",
		"767$1",
		0,
		"767"
	],
	DO: [
		"1",
		"011",
		"(?:[58]\\d\\d|900)\\d{7}",
		[
			10
		],
		0,
		"1",
		0,
		0,
		0,
		0,
		"8001|8[024]9"
	],
	DZ: [
		"213",
		"00",
		"(?:[1-4]|[5-79]\\d|80)\\d{7}",
		[
			8,
			9
		],
		[
			[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[1-4]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"9"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[5-8]"
				],
				"0$1"
			]
		],
		"0"
	],
	EC: [
		"593",
		"00",
		"1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
		[
			8,
			9,
			10,
			11
		],
		[
			[
				"(\\d)(\\d{3})(\\d{4})",
				"$1 $2-$3",
				[
					"[2-7]"
				],
				"(0$1)",
				0,
				"$1-$2-$3"
			],
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"9"
				],
				"0$1"
			],
			[
				"(\\d{4})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"1"
				]
			]
		],
		"0"
	],
	EE: [
		"372",
		"00",
		"8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
		[
			7,
			8,
			10
		],
		[
			[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				[
					"[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
					"[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
				]
			],
			[
				"(\\d{4})(\\d{3,4})",
				"$1 $2",
				[
					"[45]|8(?:00|[1-49])",
					"[45]|8(?:00[1-9]|[1-49])"
				]
			],
			[
				"(\\d{2})(\\d{2})(\\d{4})",
				"$1 $2 $3",
				[
					"7"
				]
			],
			[
				"(\\d{4})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"8"
				]
			]
		]
	],
	EG: [
		"20",
		"00",
		"[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
		[
			8,
			9,
			10
		],
		[
			[
				"(\\d)(\\d{7,8})",
				"$1 $2",
				[
					"[23]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{6,7})",
				"$1 $2",
				[
					"1[35]|[4-6]|8[2468]|9[235-7]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"[189]"
				],
				"0$1"
			]
		],
		"0"
	],
	EH: [
		"212",
		"00",
		"[5-8]\\d{8}",
		[
			9
		],
		0,
		"0",
		0,
		0,
		0,
		0,
		"528[89]"
	],
	ER: [
		"291",
		"00",
		"[178]\\d{6}",
		[
			7
		],
		[
			[
				"(\\d)(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[178]"
				],
				"0$1"
			]
		],
		"0"
	],
	ES: [
		"34",
		"00",
		"[5-9]\\d{8}",
		[
			9
		],
		[
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[89]00"
				]
			],
			[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[5-9]"
				]
			]
		]
	],
	ET: [
		"251",
		"00",
		"(?:11|[2-59]\\d)\\d{7}",
		[
			9
		],
		[
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"[1-59]"
				],
				"0$1"
			]
		],
		"0"
	],
	FI: [
		"358",
		"00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
		"[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
		[
			5,
			6,
			7,
			8,
			9,
			10,
			11,
			12
		],
		[
			[
				"(\\d)(\\d{4,9})",
				"$1 $2",
				[
					"[2568][1-8]|3(?:0[1-9]|[1-9])|9"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3,7})",
				"$1 $2",
				[
					"[12]00|[368]|70[07-9]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{4,8})",
				"$1 $2",
				[
					"[1245]|7[135]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{6,10})",
				"$1 $2",
				[
					"7"
				],
				"0$1"
			]
		],
		"0",
		0,
		0,
		0,
		0,
		"1[03-79]|[2-9]",
		0,
		"00"
	],
	FJ: [
		"679",
		"0(?:0|52)",
		"45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
		[
			7,
			11
		],
		[
			[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				[
					"[235-9]|45"
				]
			],
			[
				"(\\d{4})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"0"
				]
			]
		],
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		"00"
	],
	FK: [
		"500",
		"00",
		"[2-7]\\d{4}",
		[
			5
		]
	],
	FM: [
		"691",
		"00",
		"(?:[39]\\d\\d|820)\\d{4}",
		[
			7
		],
		[
			[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				[
					"[389]"
				]
			]
		]
	],
	FO: [
		"298",
		"00",
		"[2-9]\\d{5}",
		[
			6
		],
		[
			[
				"(\\d{6})",
				"$1",
				[
					"[2-9]"
				]
			]
		],
		0,
		0,
		"(10(?:01|[12]0|88))"
	],
	FR: [
		"33",
		"00",
		"[1-9]\\d{8}",
		[
			9
		],
		[
			[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"8"
				],
				"0 $1"
			],
			[
				"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4 $5",
				[
					"[1-79]"
				],
				"0$1"
			]
		],
		"0"
	],
	GA: [
		"241",
		"00",
		"(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
		[
			7,
			8
		],
		[
			[
				"(\\d)(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[2-7]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"11|[67]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"0"
				]
			]
		],
		0,
		0,
		"0(11\\d{6}|6[256]\\d{6}|7[47]\\d{6})",
		"$1"
	],
	GB: [
		"44",
		"00",
		"[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
		[
			7,
			9,
			10
		],
		[
			[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				[
					"800",
					"8001",
					"80011",
					"800111",
					"8001111"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{2})(\\d{2})",
				"$1 $2 $3",
				[
					"845",
					"8454",
					"84546",
					"845464"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{6})",
				"$1 $2",
				[
					"800"
				],
				"0$1"
			],
			[
				"(\\d{5})(\\d{4,5})",
				"$1 $2",
				[
					"1(?:38|5[23]|69|76|94)",
					"1(?:(?:38|69)7|5(?:24|39)|768|946)",
					"1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
				],
				"0$1"
			],
			[
				"(\\d{4})(\\d{5,6})",
				"$1 $2",
				[
					"1(?:[2-69][02-9]|[78])"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{4})(\\d{4})",
				"$1 $2 $3",
				[
					"[25]|7(?:0|6[02-9])",
					"[25]|7(?:0|6(?:[03-9]|2[356]))"
				],
				"0$1"
			],
			[
				"(\\d{4})(\\d{6})",
				"$1 $2",
				[
					"7"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"[1389]"
				],
				"0$1"
			]
		],
		"0",
		0,
		0,
		0,
		0,
		0,
		[
			[
				"(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0359])|(?:5[0-26-9]|[78][0-49])\\d\\d|6(?:[0-4]\\d\\d|50[02459]))|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|8(?:[02]\\d|1[0-278])))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
				[
					9,
					10
				]
			],
			[
				"7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
				[
					10
				]
			],
			[
				"80[08]\\d{7}|800\\d{6}|8001111"
			],
			[
				"(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
				[
					7,
					10
				]
			],
			[
				"70\\d{8}",
				[
					10
				]
			],
			0,
			[
				"(?:3[0347]|55)\\d{8}",
				[
					10
				]
			],
			[
				"76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",
				[
					10
				]
			],
			[
				"56\\d{8}",
				[
					10
				]
			]
		],
		0,
		" x"
	],
	GD: [
		"1",
		"011",
		"(?:473|[58]\\d\\d|900)\\d{7}",
		[
			10
		],
		0,
		"1",
		0,
		"1|([2-9]\\d{6})$",
		"473$1",
		0,
		"473"
	],
	GE: [
		"995",
		"00",
		"(?:[3-57]\\d\\d|800)\\d{6}",
		[
			9
		],
		[
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"70"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"32"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[57]"
				]
			],
			[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[348]"
				],
				"0$1"
			]
		],
		"0"
	],
	GF: [
		"594",
		"00",
		"(?:[56]94|80\\d|976)\\d{6}",
		[
			9
		],
		[
			[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[569]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"8"
				],
				"0$1"
			]
		],
		"0"
	],
	GG: [
		"44",
		"00",
		"(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
		[
			7,
			9,
			10
		],
		0,
		"0",
		0,
		"0|([25-9]\\d{5})$",
		"1481$1",
		0,
		0,
		[
			[
				"1481[25-9]\\d{5}",
				[
					10
				]
			],
			[
				"7(?:(?:781|839)\\d|911[17])\\d{5}",
				[
					10
				]
			],
			[
				"80[08]\\d{7}|800\\d{6}|8001111"
			],
			[
				"(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
				[
					7,
					10
				]
			],
			[
				"70\\d{8}",
				[
					10
				]
			],
			0,
			[
				"(?:3[0347]|55)\\d{8}",
				[
					10
				]
			],
			[
				"76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",
				[
					10
				]
			],
			[
				"56\\d{8}",
				[
					10
				]
			]
		]
	],
	GH: [
		"233",
		"00",
		"(?:[235]\\d{3}|800)\\d{5}",
		[
			8,
			9
		],
		[
			[
				"(\\d{3})(\\d{5})",
				"$1 $2",
				[
					"8"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"[235]"
				],
				"0$1"
			]
		],
		"0"
	],
	GI: [
		"350",
		"00",
		"(?:[25]\\d\\d|606)\\d{5}",
		[
			8
		],
		[
			[
				"(\\d{3})(\\d{5})",
				"$1 $2",
				[
					"2"
				]
			]
		]
	],
	GL: [
		"299",
		"00",
		"(?:19|[2-689]\\d|70)\\d{4}",
		[
			6
		],
		[
			[
				"(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3",
				[
					"19|[2-9]"
				]
			]
		]
	],
	GM: [
		"220",
		"00",
		"[2-9]\\d{6}",
		[
			7
		],
		[
			[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				[
					"[2-9]"
				]
			]
		]
	],
	GN: [
		"224",
		"00",
		"722\\d{6}|(?:3|6\\d)\\d{7}",
		[
			8,
			9
		],
		[
			[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"3"
				]
			],
			[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[67]"
				]
			]
		]
	],
	GP: [
		"590",
		"00",
		"(?:590|(?:69|80)\\d|976)\\d{6}",
		[
			9
		],
		[
			[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[569]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"8"
				],
				"0$1"
			]
		],
		"0",
		0,
		0,
		0,
		0,
		0,
		[
			[
				"590(?:0[1-68]|1[0-2]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}"
			],
			[
				"69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
			],
			[
				"80[0-5]\\d{6}"
			],
			0,
			0,
			0,
			0,
			0,
			[
				"976[01]\\d{5}"
			]
		]
	],
	GQ: [
		"240",
		"00",
		"222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
		[
			9
		],
		[
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[235]"
				]
			],
			[
				"(\\d{3})(\\d{6})",
				"$1 $2",
				[
					"[89]"
				]
			]
		]
	],
	GR: [
		"30",
		"00",
		"5005000\\d{3}|8\\d{9,10}|(?:[269]\\d|70)\\d{8}",
		[
			10,
			11
		],
		[
			[
				"(\\d{2})(\\d{4})(\\d{4})",
				"$1 $2 $3",
				[
					"21|7"
				]
			],
			[
				"(\\d{4})(\\d{6})",
				"$1 $2",
				[
					"2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
				]
			],
			[
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"[2689]"
				]
			],
			[
				"(\\d{3})(\\d{3})(\\d{5})",
				"$1 $2 $3",
				[
					"8"
				]
			]
		]
	],
	GT: [
		"502",
		"00",
		"(?:1\\d{3}|[2-7])\\d{7}",
		[
			8,
			11
		],
		[
			[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				[
					"[2-7]"
				]
			],
			[
				"(\\d{4})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"1"
				]
			]
		]
	],
	GU: [
		"1",
		"011",
		"(?:[58]\\d\\d|671|900)\\d{7}",
		[
			10
		],
		0,
		"1",
		0,
		"1|([3-9]\\d{6})$",
		"671$1",
		0,
		"671"
	],
	GW: [
		"245",
		"00",
		"[49]\\d{8}|4\\d{6}",
		[
			7,
			9
		],
		[
			[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				[
					"40"
				]
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[49]"
				]
			]
		]
	],
	GY: [
		"592",
		"001",
		"(?:862\\d|9008)\\d{3}|(?:[2-46]\\d|77)\\d{5}",
		[
			7
		],
		[
			[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				[
					"[2-46-9]"
				]
			]
		]
	],
	HK: [
		"852",
		"00(?:30|5[09]|[126-9]?)",
		"8[0-46-9]\\d{6,7}|9\\d{4}(?:\\d(?:\\d(?:\\d{4})?)?)?|(?:[235-79]\\d|46)\\d{6}",
		[
			5,
			6,
			7,
			8,
			9,
			11
		],
		[
			[
				"(\\d{3})(\\d{2,5})",
				"$1 $2",
				[
					"900",
					"9003"
				]
			],
			[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				[
					"[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
				]
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"8"
				]
			],
			[
				"(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
				"$1 $2 $3 $4",
				[
					"9"
				]
			]
		],
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		"00"
	],
	HN: [
		"504",
		"00",
		"8\\d{10}|[237-9]\\d{7}",
		[
			8,
			11
		],
		[
			[
				"(\\d{4})(\\d{4})",
				"$1-$2",
				[
					"[237-9]"
				]
			]
		]
	],
	HR: [
		"385",
		"00",
		"(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
		[
			6,
			7,
			8,
			9
		],
		[
			[
				"(\\d{2})(\\d{2})(\\d{2,3})",
				"$1 $2 $3",
				[
					"6[01]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{2})(\\d{2,3})",
				"$1 $2 $3",
				[
					"8"
				],
				"0$1"
			],
			[
				"(\\d)(\\d{4})(\\d{3})",
				"$1 $2 $3",
				[
					"1"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"[67]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"9"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"[2-5]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"8"
				],
				"0$1"
			]
		],
		"0"
	],
	HT: [
		"509",
		"00",
		"[2-489]\\d{7}",
		[
			8
		],
		[
			[
				"(\\d{2})(\\d{2})(\\d{4})",
				"$1 $2 $3",
				[
					"[2-489]"
				]
			]
		]
	],
	HU: [
		"36",
		"00",
		"[235-7]\\d{8}|[1-9]\\d{7}",
		[
			8,
			9
		],
		[
			[
				"(\\d)(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"1"
				],
				"(06 $1)"
			],
			[
				"(\\d{2})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
				],
				"(06 $1)"
			],
			[
				"(\\d{2})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"[2-9]"
				],
				"06 $1"
			]
		],
		"06"
	],
	ID: [
		"62",
		"00[89]",
		"(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
		[
			7,
			8,
			9,
			10,
			11,
			12,
			13
		],
		[
			[
				"(\\d)(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"15"
				]
			],
			[
				"(\\d{2})(\\d{5,9})",
				"$1 $2",
				[
					"2[124]|[36]1"
				],
				"(0$1)"
			],
			[
				"(\\d{3})(\\d{5,7})",
				"$1 $2",
				[
					"800"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{5,8})",
				"$1 $2",
				[
					"[2-79]"
				],
				"(0$1)"
			],
			[
				"(\\d{3})(\\d{3,4})(\\d{3})",
				"$1-$2-$3",
				[
					"8[1-35-9]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{6,8})",
				"$1 $2",
				[
					"1"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"804"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d)(\\d{3})(\\d{3})",
				"$1 $2 $3 $4",
				[
					"80"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{4})(\\d{4,5})",
				"$1-$2-$3",
				[
					"8"
				],
				"0$1"
			]
		],
		"0"
	],
	IE: [
		"353",
		"00",
		"(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
		[
			7,
			8,
			9,
			10
		],
		[
			[
				"(\\d{2})(\\d{5})",
				"$1 $2",
				[
					"2[24-9]|47|58|6[237-9]|9[35-9]"
				],
				"(0$1)"
			],
			[
				"(\\d{3})(\\d{5})",
				"$1 $2",
				[
					"[45]0"
				],
				"(0$1)"
			],
			[
				"(\\d)(\\d{3,4})(\\d{4})",
				"$1 $2 $3",
				[
					"1"
				],
				"(0$1)"
			],
			[
				"(\\d{2})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"[2569]|4[1-69]|7[14]"
				],
				"(0$1)"
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"70"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"81"
				],
				"(0$1)"
			],
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"[78]"
				],
				"0$1"
			],
			[
				"(\\d{4})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"1"
				]
			],
			[
				"(\\d{2})(\\d{4})(\\d{4})",
				"$1 $2 $3",
				[
					"4"
				],
				"(0$1)"
			],
			[
				"(\\d{2})(\\d)(\\d{3})(\\d{4})",
				"$1 $2 $3 $4",
				[
					"8"
				],
				"0$1"
			]
		],
		"0"
	],
	IL: [
		"972",
		"0(?:0|1[2-9])",
		"1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
		[
			7,
			8,
			9,
			10,
			11,
			12
		],
		[
			[
				"(\\d{4})(\\d{3})",
				"$1-$2",
				[
					"125"
				]
			],
			[
				"(\\d{4})(\\d{2})(\\d{2})",
				"$1-$2-$3",
				[
					"121"
				]
			],
			[
				"(\\d)(\\d{3})(\\d{4})",
				"$1-$2-$3",
				[
					"[2-489]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1-$2-$3",
				[
					"[57]"
				],
				"0$1"
			],
			[
				"(\\d{4})(\\d{3})(\\d{3})",
				"$1-$2-$3",
				[
					"12"
				]
			],
			[
				"(\\d{4})(\\d{6})",
				"$1-$2",
				[
					"159"
				]
			],
			[
				"(\\d)(\\d{3})(\\d{3})(\\d{3})",
				"$1-$2-$3-$4",
				[
					"1[7-9]"
				]
			],
			[
				"(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
				"$1-$2 $3-$4",
				[
					"15"
				]
			]
		],
		"0"
	],
	IM: [
		"44",
		"00",
		"1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
		[
			10
		],
		0,
		"0",
		0,
		"0|([25-8]\\d{5})$",
		"1624$1",
		0,
		"74576|(?:16|7[56])24"
	],
	IN: [
		"91",
		"00",
		"(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
		[
			8,
			9,
			10,
			11,
			12,
			13
		],
		[
			[
				"(\\d{8})",
				"$1",
				[
					"5(?:0|2[23]|3[03]|[67]1|88)",
					"5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
					"5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
				],
				0,
				1
			],
			[
				"(\\d{4})(\\d{4,5})",
				"$1 $2",
				[
					"180",
					"1800"
				],
				0,
				1
			],
			[
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"140"
				],
				0,
				1
			],
			[
				"(\\d{2})(\\d{4})(\\d{4})",
				"$1 $2 $3",
				[
					"11|2[02]|33|4[04]|79[1-7]|80[2-46]",
					"11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
					"11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
				],
				"0$1",
				1
			],
			[
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
					"1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
					"1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
				],
				"0$1",
				1
			],
			[
				"(\\d{4})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
					"1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
					"1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
				],
				"0$1",
				1
			],
			[
				"(\\d{5})(\\d{5})",
				"$1 $2",
				[
					"[6-9]"
				],
				"0$1",
				1
			],
			[
				"(\\d{4})(\\d{2,4})(\\d{4})",
				"$1 $2 $3",
				[
					"1(?:6|8[06])",
					"1(?:6|8[06]0)"
				],
				0,
				1
			],
			[
				"(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3 $4",
				[
					"18"
				],
				0,
				1
			]
		],
		"0"
	],
	IO: [
		"246",
		"00",
		"3\\d{6}",
		[
			7
		],
		[
			[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				[
					"3"
				]
			]
		]
	],
	IQ: [
		"964",
		"00",
		"(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
		[
			8,
			9,
			10
		],
		[
			[
				"(\\d)(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"1"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"[2-6]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"7"
				],
				"0$1"
			]
		],
		"0"
	],
	IR: [
		"98",
		"00",
		"[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
		[
			4,
			5,
			6,
			7,
			10
		],
		[
			[
				"(\\d{4,5})",
				"$1",
				[
					"96"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{4,5})",
				"$1 $2",
				[
					"(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"9"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{4})(\\d{4})",
				"$1 $2 $3",
				[
					"[1-8]"
				],
				"0$1"
			]
		],
		"0"
	],
	IS: [
		"354",
		"00|1(?:0(?:01|[12]0)|100)",
		"(?:38\\d|[4-9])\\d{6}",
		[
			7,
			9
		],
		[
			[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				[
					"[4-9]"
				]
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"3"
				]
			]
		],
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		"00"
	],
	IT: [
		"39",
		"00",
		"0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
		[
			6,
			7,
			8,
			9,
			10,
			11
		],
		[
			[
				"(\\d{2})(\\d{4,6})",
				"$1 $2",
				[
					"0[26]"
				]
			],
			[
				"(\\d{3})(\\d{3,6})",
				"$1 $2",
				[
					"0[13-57-9][0159]|8(?:03|4[17]|9[245])",
					"0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"
				]
			],
			[
				"(\\d{4})(\\d{2,6})",
				"$1 $2",
				[
					"0(?:[13-579][2-46-8]|8[236-8])"
				]
			],
			[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				[
					"894"
				]
			],
			[
				"(\\d{2})(\\d{3,4})(\\d{4})",
				"$1 $2 $3",
				[
					"0[26]|5"
				]
			],
			[
				"(\\d{3})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"1[4679]|[38]"
				]
			],
			[
				"(\\d{3})(\\d{3,4})(\\d{4})",
				"$1 $2 $3",
				[
					"0[13-57-9][0159]"
				]
			],
			[
				"(\\d{2})(\\d{4})(\\d{5})",
				"$1 $2 $3",
				[
					"0[26]"
				]
			],
			[
				"(\\d{4})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"0"
				]
			],
			[
				"(\\d{3})(\\d{4})(\\d{4,5})",
				"$1 $2 $3",
				[
					"3"
				]
			]
		],
		0,
		0,
		0,
		0,
		0,
		0,
		[
			[
				"0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"
			],
			[
				"3[1-9]\\d{8}|3[2-9]\\d{7}",
				[
					9,
					10
				]
			],
			[
				"80(?:0\\d{3}|3)\\d{3}",
				[
					6,
					9
				]
			],
			[
				"(?:0878\\d\\d|89(?:2|4[5-9]\\d))\\d{3}|89[45][0-4]\\d\\d|(?:1(?:44|6[346])|89(?:5[5-9]|9))\\d{6}",
				[
					6,
					8,
					9,
					10
				]
			],
			[
				"1(?:78\\d|99)\\d{6}",
				[
					9,
					10
				]
			],
			0,
			0,
			0,
			[
				"55\\d{8}",
				[
					10
				]
			],
			[
				"84(?:[08]\\d{3}|[17])\\d{3}",
				[
					6,
					9
				]
			]
		]
	],
	JE: [
		"44",
		"00",
		"1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
		[
			10
		],
		0,
		"0",
		0,
		"0|([0-24-8]\\d{5})$",
		"1534$1",
		0,
		0,
		[
			[
				"1534[0-24-8]\\d{5}"
			],
			[
				"7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"
			],
			[
				"80(?:07(?:35|81)|8901)\\d{4}"
			],
			[
				"(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"
			],
			[
				"701511\\d{4}"
			],
			0,
			[
				"(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"
			],
			[
				"76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}"
			],
			[
				"56\\d{8}"
			]
		]
	],
	JM: [
		"1",
		"011",
		"(?:[58]\\d\\d|658|900)\\d{7}",
		[
			10
		],
		0,
		"1",
		0,
		0,
		0,
		0,
		"658|876"
	],
	JO: [
		"962",
		"00",
		"(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
		[
			8,
			9
		],
		[
			[
				"(\\d)(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"[2356]|87"
				],
				"(0$1)"
			],
			[
				"(\\d{3})(\\d{5,6})",
				"$1 $2",
				[
					"[89]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{7})",
				"$1 $2",
				[
					"70"
				],
				"0$1"
			],
			[
				"(\\d)(\\d{4})(\\d{4})",
				"$1 $2 $3",
				[
					"7"
				],
				"0$1"
			]
		],
		"0"
	],
	JP: [
		"81",
		"010",
		"00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
		[
			8,
			9,
			10,
			11,
			12,
			13,
			14,
			15,
			16,
			17
		],
		[
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1-$2-$3",
				[
					"(?:12|57|99)0"
				],
				"0$1"
			],
			[
				"(\\d{4})(\\d)(\\d{4})",
				"$1-$2-$3",
				[
					"1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])",
					"1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]",
					"1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1-$2-$3",
				[
					"60"
				],
				"0$1"
			],
			[
				"(\\d)(\\d{4})(\\d{4})",
				"$1-$2-$3",
				[
					"[36]|4(?:2[09]|7[01])",
					"[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1-$2-$3",
				[
					"1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
					"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
					"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]",
					"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{2})(\\d{4})",
				"$1-$2-$3",
				[
					"[14]|[289][2-9]|5[3-9]|7[2-4679]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1-$2-$3",
				[
					"800"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{4})(\\d{4})",
				"$1-$2-$3",
				[
					"[257-9]"
				],
				"0$1"
			]
		],
		"0"
	],
	KE: [
		"254",
		"000",
		"(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
		[
			7,
			8,
			9,
			10
		],
		[
			[
				"(\\d{2})(\\d{5,7})",
				"$1 $2",
				[
					"[24-6]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{6})",
				"$1 $2",
				[
					"[17]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"[89]"
				],
				"0$1"
			]
		],
		"0"
	],
	KG: [
		"996",
		"00",
		"8\\d{9}|(?:[235-8]\\d|99)\\d{7}",
		[
			9,
			10
		],
		[
			[
				"(\\d{4})(\\d{5})",
				"$1 $2",
				[
					"3(?:1[346]|[24-79])"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[235-79]|88"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
				"$1 $2 $3 $4",
				[
					"8"
				],
				"0$1"
			]
		],
		"0"
	],
	KH: [
		"855",
		"00[14-9]",
		"1\\d{9}|[1-9]\\d{7,8}",
		[
			8,
			9,
			10
		],
		[
			[
				"(\\d{2})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"[1-9]"
				],
				"0$1"
			],
			[
				"(\\d{4})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"1"
				]
			]
		],
		"0"
	],
	KI: [
		"686",
		"00",
		"(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
		[
			5,
			8
		],
		0,
		"0"
	],
	KM: [
		"269",
		"00",
		"[3478]\\d{6}",
		[
			7
		],
		[
			[
				"(\\d{3})(\\d{2})(\\d{2})",
				"$1 $2 $3",
				[
					"[3478]"
				]
			]
		]
	],
	KN: [
		"1",
		"011",
		"(?:[58]\\d\\d|900)\\d{7}",
		[
			10
		],
		0,
		"1",
		0,
		"1|([2-7]\\d{6})$",
		"869$1",
		0,
		"869"
	],
	KP: [
		"850",
		"00|99",
		"85\\d{6}|(?:19\\d|[2-7])\\d{7}",
		[
			8,
			10
		],
		[
			[
				"(\\d{2})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"8"
				],
				"0$1"
			],
			[
				"(\\d)(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"[2-7]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"1"
				],
				"0$1"
			]
		],
		"0"
	],
	KR: [
		"82",
		"00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
		"00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
		[
			5,
			6,
			8,
			9,
			10,
			11,
			12,
			13,
			14
		],
		[
			[
				"(\\d{2})(\\d{3,4})",
				"$1-$2",
				[
					"(?:3[1-3]|[46][1-4]|5[1-5])1"
				],
				"0$1"
			],
			[
				"(\\d{4})(\\d{4})",
				"$1-$2",
				[
					"1"
				]
			],
			[
				"(\\d)(\\d{3,4})(\\d{4})",
				"$1-$2-$3",
				[
					"2"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1-$2-$3",
				[
					"60|8"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3,4})(\\d{4})",
				"$1-$2-$3",
				[
					"[1346]|5[1-5]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{4})(\\d{4})",
				"$1-$2-$3",
				[
					"[57]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{5})(\\d{4})",
				"$1-$2-$3",
				[
					"5"
				],
				"0$1"
			]
		],
		"0",
		0,
		"0(8(?:[1-46-8]|5\\d\\d))?"
	],
	KW: [
		"965",
		"00",
		"(?:18|[2569]\\d\\d)\\d{5}",
		[
			7,
			8
		],
		[
			[
				"(\\d{4})(\\d{3,4})",
				"$1 $2",
				[
					"[169]|2(?:[235]|4[1-35-9])|52"
				]
			],
			[
				"(\\d{3})(\\d{5})",
				"$1 $2",
				[
					"[25]"
				]
			]
		]
	],
	KY: [
		"1",
		"011",
		"(?:345|[58]\\d\\d|900)\\d{7}",
		[
			10
		],
		0,
		"1",
		0,
		"1|([2-9]\\d{6})$",
		"345$1",
		0,
		"345"
	],
	KZ: [
		"7",
		"810",
		"(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
		[
			10,
			14
		],
		0,
		"8",
		0,
		0,
		0,
		0,
		"33|7",
		0,
		"8~10"
	],
	LA: [
		"856",
		"00",
		"[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
		[
			8,
			9,
			10
		],
		[
			[
				"(\\d{2})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"2[13]|3[14]|[4-8]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
				"$1 $2 $3 $4",
				[
					"30[013-9]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
				"$1 $2 $3 $4",
				[
					"[23]"
				],
				"0$1"
			]
		],
		"0"
	],
	LB: [
		"961",
		"00",
		"[27-9]\\d{7}|[13-9]\\d{6}",
		[
			7,
			8
		],
		[
			[
				"(\\d)(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[27-9]"
				]
			]
		],
		"0"
	],
	LC: [
		"1",
		"011",
		"(?:[58]\\d\\d|758|900)\\d{7}",
		[
			10
		],
		0,
		"1",
		0,
		"1|([2-8]\\d{6})$",
		"758$1",
		0,
		"758"
	],
	LI: [
		"423",
		"00",
		"90\\d{5}|(?:[2378]|6\\d\\d)\\d{6}",
		[
			7,
			9
		],
		[
			[
				"(\\d{3})(\\d{2})(\\d{2})",
				"$1 $2 $3",
				[
					"[237-9]"
				]
			],
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"69"
				]
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"6"
				]
			]
		],
		"0",
		0,
		"0|(1001)"
	],
	LK: [
		"94",
		"00",
		"[1-9]\\d{8}",
		[
			9
		],
		[
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"7"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[1-689]"
				],
				"0$1"
			]
		],
		"0"
	],
	LR: [
		"231",
		"00",
		"(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}",
		[
			7,
			8,
			9
		],
		[
			[
				"(\\d)(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[4-6]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"2"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"[3578]"
				],
				"0$1"
			]
		],
		"0"
	],
	LS: [
		"266",
		"00",
		"(?:[256]\\d\\d|800)\\d{5}",
		[
			8
		],
		[
			[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				[
					"[2568]"
				]
			]
		]
	],
	LT: [
		"370",
		"00",
		"(?:[3469]\\d|52|[78]0)\\d{6}",
		[
			8
		],
		[
			[
				"(\\d)(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"52[0-7]"
				],
				"(8-$1)",
				1
			],
			[
				"(\\d{3})(\\d{2})(\\d{3})",
				"$1 $2 $3",
				[
					"[7-9]"
				],
				"8 $1",
				1
			],
			[
				"(\\d{2})(\\d{6})",
				"$1 $2",
				[
					"37|4(?:[15]|6[1-8])"
				],
				"(8-$1)",
				1
			],
			[
				"(\\d{3})(\\d{5})",
				"$1 $2",
				[
					"[3-6]"
				],
				"(8-$1)",
				1
			]
		],
		"8",
		0,
		"[08]"
	],
	LU: [
		"352",
		"00",
		"35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
		[
			4,
			5,
			6,
			7,
			8,
			9,
			10,
			11
		],
		[
			[
				"(\\d{2})(\\d{3})",
				"$1 $2",
				[
					"2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
				]
			],
			[
				"(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3",
				[
					"2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
				]
			],
			[
				"(\\d{2})(\\d{2})(\\d{3})",
				"$1 $2 $3",
				[
					"20[2-689]"
				]
			],
			[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
				"$1 $2 $3 $4",
				[
					"2(?:[0367]|4[3-8])"
				]
			],
			[
				"(\\d{3})(\\d{2})(\\d{3})",
				"$1 $2 $3",
				[
					"80[01]|90[015]"
				]
			],
			[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
				"$1 $2 $3 $4",
				[
					"20"
				]
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"6"
				]
			],
			[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
				"$1 $2 $3 $4 $5",
				[
					"2(?:[0367]|4[3-8])"
				]
			],
			[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
				"$1 $2 $3 $4",
				[
					"[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
				]
			]
		],
		0,
		0,
		"(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"
	],
	LV: [
		"371",
		"00",
		"(?:[268]\\d|90)\\d{6}",
		[
			8
		],
		[
			[
				"(\\d{2})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[269]|8[01]"
				]
			]
		]
	],
	LY: [
		"218",
		"00",
		"[2-9]\\d{8}",
		[
			9
		],
		[
			[
				"(\\d{2})(\\d{7})",
				"$1-$2",
				[
					"[2-9]"
				],
				"0$1"
			]
		],
		"0"
	],
	MA: [
		"212",
		"00",
		"[5-8]\\d{8}",
		[
			9
		],
		[
			[
				"(\\d{5})(\\d{4})",
				"$1-$2",
				[
					"5(?:29|38)",
					"5(?:29|38)[89]",
					"5(?:29|38)[89]0"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"5[45]"
				],
				"0$1"
			],
			[
				"(\\d{4})(\\d{5})",
				"$1-$2",
				[
					"5(?:2[2-489]|3[5-9]|9)|892",
					"5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{7})",
				"$1-$2",
				[
					"8"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{6})",
				"$1-$2",
				[
					"[5-7]"
				],
				"0$1"
			]
		],
		"0",
		0,
		0,
		0,
		0,
		0,
		[
			[
				"5(?:29(?:[189][05]|2[29]|3[01])|38[89][05])\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|90)|3(?:[0-47]\\d|5[02-9]|6[02-8]|80|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"
			],
			[
				"(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0\\d|1[0-3]|6[1267]|7[0-57]))\\d{6}"
			],
			[
				"80\\d{7}"
			],
			[
				"89\\d{7}"
			],
			0,
			0,
			0,
			0,
			[
				"592(?:4[0-2]|93)\\d{4}"
			]
		]
	],
	MC: [
		"377",
		"00",
		"(?:[3489]|6\\d)\\d{7}",
		[
			8,
			9
		],
		[
			[
				"(\\d{2})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"4"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[389]"
				]
			],
			[
				"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4 $5",
				[
					"6"
				],
				"0$1"
			]
		],
		"0"
	],
	MD: [
		"373",
		"00",
		"(?:[235-7]\\d|[89]0)\\d{6}",
		[
			8
		],
		[
			[
				"(\\d{3})(\\d{5})",
				"$1 $2",
				[
					"[89]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"22|3"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{2})(\\d{3})",
				"$1 $2 $3",
				[
					"[25-7]"
				],
				"0$1"
			]
		],
		"0"
	],
	ME: [
		"382",
		"00",
		"(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
		[
			8,
			9
		],
		[
			[
				"(\\d{2})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"[2-9]"
				],
				"0$1"
			]
		],
		"0"
	],
	MF: [
		"590",
		"00",
		"(?:590|(?:69|80)\\d|976)\\d{6}",
		[
			9
		],
		0,
		"0",
		0,
		0,
		0,
		0,
		0,
		[
			[
				"590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}"
			],
			[
				"69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
			],
			[
				"80[0-5]\\d{6}"
			],
			0,
			0,
			0,
			0,
			0,
			[
				"976[01]\\d{5}"
			]
		]
	],
	MG: [
		"261",
		"00",
		"[23]\\d{8}",
		[
			9
		],
		[
			[
				"(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[23]"
				],
				"0$1"
			]
		],
		"0",
		0,
		"0|([24-9]\\d{6})$",
		"20$1"
	],
	MH: [
		"692",
		"011",
		"329\\d{4}|(?:[256]\\d|45)\\d{5}",
		[
			7
		],
		[
			[
				"(\\d{3})(\\d{4})",
				"$1-$2",
				[
					"[2-6]"
				]
			]
		],
		"1"
	],
	MK: [
		"389",
		"00",
		"[2-578]\\d{7}",
		[
			8
		],
		[
			[
				"(\\d)(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"2"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[347]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d)(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[58]"
				],
				"0$1"
			]
		],
		"0"
	],
	ML: [
		"223",
		"00",
		"[24-9]\\d{7}",
		[
			8
		],
		[
			[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[24-9]"
				]
			]
		]
	],
	MM: [
		"95",
		"00",
		"1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
		[
			6,
			7,
			8,
			9,
			10
		],
		[
			[
				"(\\d)(\\d{2})(\\d{3})",
				"$1 $2 $3",
				[
					"16|2"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{2})(\\d{3})",
				"$1 $2 $3",
				[
					"[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"
				],
				"0$1"
			],
			[
				"(\\d)(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"[12]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"[4-7]|8[1-35]"
				],
				"0$1"
			],
			[
				"(\\d)(\\d{3})(\\d{4,6})",
				"$1 $2 $3",
				[
					"9(?:2[0-4]|[35-9]|4[137-9])"
				],
				"0$1"
			],
			[
				"(\\d)(\\d{4})(\\d{4})",
				"$1 $2 $3",
				[
					"2"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"8"
				],
				"0$1"
			],
			[
				"(\\d)(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3 $4",
				[
					"92"
				],
				"0$1"
			],
			[
				"(\\d)(\\d{5})(\\d{4})",
				"$1 $2 $3",
				[
					"9"
				],
				"0$1"
			]
		],
		"0"
	],
	MN: [
		"976",
		"001",
		"[12]\\d{7,9}|[57-9]\\d{7}",
		[
			8,
			9,
			10
		],
		[
			[
				"(\\d{2})(\\d{2})(\\d{4})",
				"$1 $2 $3",
				[
					"[12]1"
				],
				"0$1"
			],
			[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				[
					"[57-9]"
				]
			],
			[
				"(\\d{3})(\\d{5,6})",
				"$1 $2",
				[
					"[12]2[1-3]"
				],
				"0$1"
			],
			[
				"(\\d{4})(\\d{5,6})",
				"$1 $2",
				[
					"[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
					"[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
				],
				"0$1"
			],
			[
				"(\\d{5})(\\d{4,5})",
				"$1 $2",
				[
					"[12]"
				],
				"0$1"
			]
		],
		"0"
	],
	MO: [
		"853",
		"00",
		"0800\\d{3}|(?:28|[68]\\d)\\d{6}",
		[
			7,
			8
		],
		[
			[
				"(\\d{4})(\\d{3})",
				"$1 $2",
				[
					"0"
				]
			],
			[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				[
					"[268]"
				]
			]
		]
	],
	MP: [
		"1",
		"011",
		"[58]\\d{9}|(?:67|90)0\\d{7}",
		[
			10
		],
		0,
		"1",
		0,
		"1|([2-9]\\d{6})$",
		"670$1",
		0,
		"670"
	],
	MQ: [
		"596",
		"00",
		"(?:69|80)\\d{7}|(?:59|97)6\\d{6}",
		[
			9
		],
		[
			[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[569]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"8"
				],
				"0$1"
			]
		],
		"0"
	],
	MR: [
		"222",
		"00",
		"(?:[2-4]\\d\\d|800)\\d{5}",
		[
			8
		],
		[
			[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[2-48]"
				]
			]
		]
	],
	MS: [
		"1",
		"011",
		"(?:[58]\\d\\d|664|900)\\d{7}",
		[
			10
		],
		0,
		"1",
		0,
		"1|([34]\\d{6})$",
		"664$1",
		0,
		"664"
	],
	MT: [
		"356",
		"00",
		"3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
		[
			8
		],
		[
			[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				[
					"[2357-9]"
				]
			]
		]
	],
	MU: [
		"230",
		"0(?:0|[24-7]0|3[03])",
		"(?:5|8\\d\\d)\\d{7}|[2-468]\\d{6}",
		[
			7,
			8,
			10
		],
		[
			[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				[
					"[2-46]|8[013]"
				]
			],
			[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				[
					"5"
				]
			],
			[
				"(\\d{5})(\\d{5})",
				"$1 $2",
				[
					"8"
				]
			]
		],
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		"020"
	],
	MV: [
		"960",
		"0(?:0|19)",
		"(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
		[
			7,
			10
		],
		[
			[
				"(\\d{3})(\\d{4})",
				"$1-$2",
				[
					"[3467]|9[13-9]"
				]
			],
			[
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"[89]"
				]
			]
		],
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		"00"
	],
	MW: [
		"265",
		"00",
		"(?:[19]\\d|[23]1|77|88)\\d{7}|1\\d{6}",
		[
			7,
			9
		],
		[
			[
				"(\\d)(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"1[2-9]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"2"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[137-9]"
				],
				"0$1"
			]
		],
		"0"
	],
	MX: [
		"52",
		"0[09]",
		"1(?:65[0-689]|99[1-9])\\d{7}|(?:1(?:[0147]\\d|[235][1-9]|6[0-46-9]|8[1-79]|9[1-8])|[2-9]\\d)\\d{8}",
		[
			10,
			11
		],
		[
			[
				"(\\d{2})(\\d{4})(\\d{4})",
				"$1 $2 $3",
				[
					"33|5[56]|81"
				],
				0,
				1
			],
			[
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"[2-9]"
				],
				0,
				1
			],
			[
				"(\\d)(\\d{2})(\\d{4})(\\d{4})",
				"$2 $3 $4",
				[
					"1(?:33|5[56]|81)"
				],
				0,
				1
			],
			[
				"(\\d)(\\d{3})(\\d{3})(\\d{4})",
				"$2 $3 $4",
				[
					"1"
				],
				0,
				1
			]
		],
		"01",
		0,
		"0(?:[12]|4[45])|1",
		0,
		0,
		0,
		0,
		"00"
	],
	MY: [
		"60",
		"00",
		"1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
		[
			8,
			9,
			10
		],
		[
			[
				"(\\d)(\\d{3})(\\d{4})",
				"$1-$2 $3",
				[
					"[4-79]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{3,4})",
				"$1-$2 $3",
				[
					"1(?:[02469]|[378][1-9])|8"
				],
				"0$1"
			],
			[
				"(\\d)(\\d{4})(\\d{4})",
				"$1-$2 $3",
				[
					"3"
				],
				"0$1"
			],
			[
				"(\\d)(\\d{3})(\\d{2})(\\d{4})",
				"$1-$2-$3-$4",
				[
					"1[36-8]"
				]
			],
			[
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1-$2 $3",
				[
					"15"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{4})(\\d{4})",
				"$1-$2 $3",
				[
					"1"
				],
				"0$1"
			]
		],
		"0"
	],
	MZ: [
		"258",
		"00",
		"(?:2|8\\d)\\d{7}",
		[
			8,
			9
		],
		[
			[
				"(\\d{2})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"2|8[2-79]"
				]
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"8"
				]
			]
		]
	],
	NA: [
		"264",
		"00",
		"[68]\\d{7,8}",
		[
			8,
			9
		],
		[
			[
				"(\\d{2})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"88"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"6"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"87"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"8"
				],
				"0$1"
			]
		],
		"0"
	],
	NC: [
		"687",
		"00",
		"[2-57-9]\\d{5}",
		[
			6
		],
		[
			[
				"(\\d{2})(\\d{2})(\\d{2})",
				"$1.$2.$3",
				[
					"[2-57-9]"
				]
			]
		]
	],
	NE: [
		"227",
		"00",
		"[027-9]\\d{7}",
		[
			8
		],
		[
			[
				"(\\d{2})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"08"
				]
			],
			[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[089]|2[013]|7[04]"
				]
			]
		]
	],
	NF: [
		"672",
		"00",
		"[13]\\d{5}",
		[
			6
		],
		[
			[
				"(\\d{2})(\\d{4})",
				"$1 $2",
				[
					"1[0-3]"
				]
			],
			[
				"(\\d)(\\d{5})",
				"$1 $2",
				[
					"[13]"
				]
			]
		],
		0,
		0,
		"([0-258]\\d{4})$",
		"3$1"
	],
	NG: [
		"234",
		"009",
		"(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",
		[
			7,
			8,
			10,
			11,
			12,
			13,
			14
		],
		[
			[
				"(\\d{2})(\\d{2})(\\d{3})",
				"$1 $2 $3",
				[
					"78"
				],
				"0$1"
			],
			[
				"(\\d)(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"[12]|9(?:0[3-9]|[1-9])"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{2,3})",
				"$1 $2 $3",
				[
					"[3-7]|8[2-9]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"[7-9]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{4})(\\d{4,5})",
				"$1 $2 $3",
				[
					"[78]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{5})(\\d{5,6})",
				"$1 $2 $3",
				[
					"[78]"
				],
				"0$1"
			]
		],
		"0"
	],
	NI: [
		"505",
		"00",
		"(?:1800|[25-8]\\d{3})\\d{4}",
		[
			8
		],
		[
			[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				[
					"[125-8]"
				]
			]
		]
	],
	NL: [
		"31",
		"00",
		"(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|[89]\\d{6,9}|1\\d{4,5}",
		[
			5,
			6,
			7,
			8,
			9,
			10
		],
		[
			[
				"(\\d{3})(\\d{4,7})",
				"$1 $2",
				[
					"[89]0"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{7})",
				"$1 $2",
				[
					"66"
				],
				"0$1"
			],
			[
				"(\\d)(\\d{8})",
				"$1 $2",
				[
					"6"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"[1-57-9]"
				],
				"0$1"
			]
		],
		"0"
	],
	NO: [
		"47",
		"00",
		"(?:0|[2-9]\\d{3})\\d{4}",
		[
			5,
			8
		],
		[
			[
				"(\\d{3})(\\d{2})(\\d{3})",
				"$1 $2 $3",
				[
					"[489]|59"
				]
			],
			[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[235-7]"
				]
			]
		],
		0,
		0,
		0,
		0,
		0,
		"[02-689]|7[0-8]"
	],
	NP: [
		"977",
		"00",
		"(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
		[
			8,
			10,
			11
		],
		[
			[
				"(\\d)(\\d{7})",
				"$1-$2",
				[
					"1[2-6]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{6})",
				"$1-$2",
				[
					"1[01]|[2-8]|9(?:[1-579]|6[2-6])"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{7})",
				"$1-$2",
				[
					"9"
				]
			]
		],
		"0"
	],
	NR: [
		"674",
		"00",
		"(?:444|(?:55|8\\d)\\d|666)\\d{4}",
		[
			7
		],
		[
			[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				[
					"[4-68]"
				]
			]
		]
	],
	NU: [
		"683",
		"00",
		"(?:[47]|888\\d)\\d{3}",
		[
			4,
			7
		],
		[
			[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				[
					"8"
				]
			]
		]
	],
	NZ: [
		"64",
		"0(?:0|161)",
		"[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}",
		[
			5,
			6,
			7,
			8,
			9,
			10
		],
		[
			[
				"(\\d{2})(\\d{3,8})",
				"$1 $2",
				[
					"8[1-579]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{2})(\\d{2,3})",
				"$1 $2 $3",
				[
					"50[036-8]|[89]0",
					"50(?:[0367]|88)|[89]0"
				],
				"0$1"
			],
			[
				"(\\d)(\\d{3})(\\d{4})",
				"$1-$2 $3",
				[
					"24|[346]|7[2-57-9]|9[2-9]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"2(?:10|74)|[59]|80"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3,4})(\\d{4})",
				"$1 $2 $3",
				[
					"1|2[028]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{3,5})",
				"$1 $2 $3",
				[
					"2(?:[169]|7[0-35-9])|7|86"
				],
				"0$1"
			]
		],
		"0",
		0,
		0,
		0,
		0,
		0,
		0,
		"00"
	],
	OM: [
		"968",
		"00",
		"(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
		[
			7,
			8,
			9
		],
		[
			[
				"(\\d{3})(\\d{4,6})",
				"$1 $2",
				[
					"[58]"
				]
			],
			[
				"(\\d{2})(\\d{6})",
				"$1 $2",
				[
					"2"
				]
			],
			[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				[
					"[179]"
				]
			]
		]
	],
	PA: [
		"507",
		"00",
		"8\\d{9}|[68]\\d{7}|[1-57-9]\\d{6}",
		[
			7,
			8,
			10
		],
		[
			[
				"(\\d{3})(\\d{4})",
				"$1-$2",
				[
					"[1-57-9]"
				]
			],
			[
				"(\\d{4})(\\d{4})",
				"$1-$2",
				[
					"[68]"
				]
			],
			[
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"8"
				]
			]
		]
	],
	PE: [
		"51",
		"19(?:1[124]|77|90)00",
		"(?:[14-8]|9\\d)\\d{7}",
		[
			8,
			9
		],
		[
			[
				"(\\d{3})(\\d{5})",
				"$1 $2",
				[
					"80"
				],
				"(0$1)"
			],
			[
				"(\\d)(\\d{7})",
				"$1 $2",
				[
					"1"
				],
				"(0$1)"
			],
			[
				"(\\d{2})(\\d{6})",
				"$1 $2",
				[
					"[4-8]"
				],
				"(0$1)"
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"9"
				]
			]
		],
		"0",
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		" Anexo "
	],
	PF: [
		"689",
		"00",
		"4\\d{5}(?:\\d{2})?|8\\d{7,8}",
		[
			6,
			8,
			9
		],
		[
			[
				"(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3",
				[
					"44"
				]
			],
			[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"4|8[7-9]"
				]
			],
			[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"8"
				]
			]
		]
	],
	PG: [
		"675",
		"00|140[1-3]",
		"(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
		[
			7,
			8
		],
		[
			[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				[
					"18|[2-69]|85"
				]
			],
			[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				[
					"[78]"
				]
			]
		],
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		"00"
	],
	PH: [
		"63",
		"00",
		"(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
		[
			6,
			8,
			9,
			10,
			11,
			12,
			13
		],
		[
			[
				"(\\d)(\\d{5})",
				"$1 $2",
				[
					"2"
				],
				"(0$1)"
			],
			[
				"(\\d{4})(\\d{4,6})",
				"$1 $2",
				[
					"3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
					"3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
				],
				"(0$1)"
			],
			[
				"(\\d{5})(\\d{4})",
				"$1 $2",
				[
					"346|4(?:27|9[35])|883",
					"3469|4(?:279|9(?:30|56))|8834"
				],
				"(0$1)"
			],
			[
				"(\\d)(\\d{4})(\\d{4})",
				"$1 $2 $3",
				[
					"2"
				],
				"(0$1)"
			],
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"[3-7]|8[2-8]"
				],
				"(0$1)"
			],
			[
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"[89]"
				],
				"0$1"
			],
			[
				"(\\d{4})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"1"
				]
			],
			[
				"(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
				"$1 $2 $3 $4",
				[
					"1"
				]
			]
		],
		"0"
	],
	PK: [
		"92",
		"00",
		"122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
		[
			8,
			9,
			10,
			11,
			12
		],
		[
			[
				"(\\d{3})(\\d{3})(\\d{2,7})",
				"$1 $2 $3",
				[
					"[89]0"
				],
				"0$1"
			],
			[
				"(\\d{4})(\\d{5})",
				"$1 $2",
				[
					"1"
				]
			],
			[
				"(\\d{3})(\\d{6,7})",
				"$1 $2",
				[
					"2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
					"9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
				],
				"(0$1)"
			],
			[
				"(\\d{2})(\\d{7,8})",
				"$1 $2",
				[
					"(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
				],
				"(0$1)"
			],
			[
				"(\\d{5})(\\d{5})",
				"$1 $2",
				[
					"58"
				],
				"(0$1)"
			],
			[
				"(\\d{3})(\\d{7})",
				"$1 $2",
				[
					"3"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3 $4",
				[
					"2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
				],
				"(0$1)"
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3 $4",
				[
					"[24-9]"
				],
				"(0$1)"
			]
		],
		"0"
	],
	PL: [
		"48",
		"00",
		"6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?",
		[
			6,
			7,
			8,
			9,
			10
		],
		[
			[
				"(\\d{5})",
				"$1",
				[
					"19"
				]
			],
			[
				"(\\d{3})(\\d{3})",
				"$1 $2",
				[
					"11|64"
				]
			],
			[
				"(\\d{2})(\\d{2})(\\d{3})",
				"$1 $2 $3",
				[
					"(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
					"(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
				]
			],
			[
				"(\\d{3})(\\d{2})(\\d{2,3})",
				"$1 $2 $3",
				[
					"64"
				]
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
				]
			],
			[
				"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"1[2-8]|[2-7]|8[1-79]|9[145]"
				]
			],
			[
				"(\\d{3})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"8"
				]
			]
		]
	],
	PM: [
		"508",
		"00",
		"(?:[45]|80\\d\\d)\\d{5}",
		[
			6,
			9
		],
		[
			[
				"(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3",
				[
					"[45]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"8"
				],
				"0$1"
			]
		],
		"0"
	],
	PR: [
		"1",
		"011",
		"(?:[589]\\d\\d|787)\\d{7}",
		[
			10
		],
		0,
		"1",
		0,
		0,
		0,
		0,
		"787|939"
	],
	PS: [
		"970",
		"00",
		"[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
		[
			8,
			9,
			10
		],
		[
			[
				"(\\d)(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"[2489]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"5"
				],
				"0$1"
			],
			[
				"(\\d{4})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"1"
				]
			]
		],
		"0"
	],
	PT: [
		"351",
		"00",
		"1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
		[
			9
		],
		[
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"2[12]"
				]
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"16|[236-9]"
				]
			]
		]
	],
	PW: [
		"680",
		"01[12]",
		"(?:[24-8]\\d\\d|345|900)\\d{4}",
		[
			7
		],
		[
			[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				[
					"[2-9]"
				]
			]
		]
	],
	PY: [
		"595",
		"00",
		"59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
		[
			6,
			7,
			8,
			9,
			10,
			11
		],
		[
			[
				"(\\d{3})(\\d{3,6})",
				"$1 $2",
				[
					"[2-9]0"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{5})",
				"$1 $2",
				[
					"[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
				],
				"(0$1)"
			],
			[
				"(\\d{3})(\\d{4,5})",
				"$1 $2",
				[
					"2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
				],
				"(0$1)"
			],
			[
				"(\\d{2})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
				],
				"(0$1)"
			],
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"87"
				]
			],
			[
				"(\\d{3})(\\d{6})",
				"$1 $2",
				[
					"9(?:[5-79]|8[1-6])"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[2-8]"
				],
				"0$1"
			],
			[
				"(\\d{4})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"9"
				]
			]
		],
		"0"
	],
	QA: [
		"974",
		"00",
		"[2-7]\\d{7}|800\\d{4}(?:\\d{2})?|2\\d{6}",
		[
			7,
			8,
			9
		],
		[
			[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				[
					"2[126]|8"
				]
			],
			[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				[
					"[2-7]"
				]
			]
		]
	],
	RE: [
		"262",
		"00",
		"9769\\d{5}|(?:26|[68]\\d)\\d{7}",
		[
			9
		],
		[
			[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[2689]"
				],
				"0$1"
			]
		],
		"0",
		0,
		0,
		0,
		0,
		"26[23]|69|[89]"
	],
	RO: [
		"40",
		"00",
		"(?:[237]\\d|[89]0)\\d{7}|[23]\\d{5}",
		[
			6,
			9
		],
		[
			[
				"(\\d{3})(\\d{3})",
				"$1 $2",
				[
					"2[3-6]",
					"2[3-6]\\d9"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{4})",
				"$1 $2",
				[
					"219|31"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"[23]1"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[237-9]"
				],
				"0$1"
			]
		],
		"0",
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		" int "
	],
	RS: [
		"381",
		"00",
		"38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
		[
			6,
			7,
			8,
			9,
			10,
			11,
			12
		],
		[
			[
				"(\\d{3})(\\d{3,9})",
				"$1 $2",
				[
					"(?:2[389]|39)0|[7-9]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{5,10})",
				"$1 $2",
				[
					"[1-36]"
				],
				"0$1"
			]
		],
		"0"
	],
	RU: [
		"7",
		"810",
		"8\\d{13}|[347-9]\\d{9}",
		[
			10,
			14
		],
		[
			[
				"(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"7(?:1[0-8]|2[1-9])",
					"7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))",
					"7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
				],
				"8 ($1)",
				1
			],
			[
				"(\\d{5})(\\d)(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"7(?:1[0-68]|2[1-9])",
					"7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
					"7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
				],
				"8 ($1)",
				1
			],
			[
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"7"
				],
				"8 ($1)",
				1
			],
			[
				"(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
				"$1 $2-$3-$4",
				[
					"[349]|8(?:[02-7]|1[1-8])"
				],
				"8 ($1)",
				1
			],
			[
				"(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
				"$1 $2 $3 $4",
				[
					"8"
				],
				"8 ($1)"
			]
		],
		"8",
		0,
		0,
		0,
		0,
		"3[04-689]|[489]",
		0,
		"8~10"
	],
	RW: [
		"250",
		"00",
		"(?:06|[27]\\d\\d|[89]00)\\d{6}",
		[
			8,
			9
		],
		[
			[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"0"
				]
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[7-9]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"2"
				]
			]
		],
		"0"
	],
	SA: [
		"966",
		"00",
		"92\\d{7}|(?:[15]|8\\d)\\d{8}",
		[
			9,
			10
		],
		[
			[
				"(\\d{4})(\\d{5})",
				"$1 $2",
				[
					"9"
				]
			],
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"1"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"5"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"81"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"8"
				]
			]
		],
		"0"
	],
	SB: [
		"677",
		"0[01]",
		"(?:[1-6]|[7-9]\\d\\d)\\d{4}",
		[
			5,
			7
		],
		[
			[
				"(\\d{2})(\\d{5})",
				"$1 $2",
				[
					"7|8[4-9]|9(?:[1-8]|9[0-8])"
				]
			]
		]
	],
	SC: [
		"248",
		"010|0[0-2]",
		"8000\\d{3}|(?:[249]\\d|64)\\d{5}",
		[
			7
		],
		[
			[
				"(\\d)(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[246]|9[57]"
				]
			]
		],
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		"00"
	],
	SD: [
		"249",
		"00",
		"[19]\\d{8}",
		[
			9
		],
		[
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"[19]"
				],
				"0$1"
			]
		],
		"0"
	],
	SE: [
		"46",
		"00",
		"(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
		[
			6,
			7,
			8,
			9,
			10
		],
		[
			[
				"(\\d{2})(\\d{2,3})(\\d{2})",
				"$1-$2 $3",
				[
					"20"
				],
				"0$1",
				0,
				"$1 $2 $3"
			],
			[
				"(\\d{3})(\\d{4})",
				"$1-$2",
				[
					"9(?:00|39|44)"
				],
				"0$1",
				0,
				"$1 $2"
			],
			[
				"(\\d{2})(\\d{3})(\\d{2})",
				"$1-$2 $3",
				[
					"[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
				],
				"0$1",
				0,
				"$1 $2 $3"
			],
			[
				"(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
				"$1-$2 $3 $4",
				[
					"8"
				],
				"0$1",
				0,
				"$1 $2 $3 $4"
			],
			[
				"(\\d{3})(\\d{2,3})(\\d{2})",
				"$1-$2 $3",
				[
					"1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
				],
				"0$1",
				0,
				"$1 $2 $3"
			],
			[
				"(\\d{3})(\\d{2,3})(\\d{3})",
				"$1-$2 $3",
				[
					"9(?:00|39|44)"
				],
				"0$1",
				0,
				"$1 $2 $3"
			],
			[
				"(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
				"$1-$2 $3 $4",
				[
					"1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
				],
				"0$1",
				0,
				"$1 $2 $3 $4"
			],
			[
				"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
				"$1-$2 $3 $4",
				[
					"10|7"
				],
				"0$1",
				0,
				"$1 $2 $3 $4"
			],
			[
				"(\\d)(\\d{3})(\\d{3})(\\d{2})",
				"$1-$2 $3 $4",
				[
					"8"
				],
				"0$1",
				0,
				"$1 $2 $3 $4"
			],
			[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1-$2 $3 $4",
				[
					"[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
				],
				"0$1",
				0,
				"$1 $2 $3 $4"
			],
			[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
				"$1-$2 $3 $4",
				[
					"9"
				],
				"0$1",
				0,
				"$1 $2 $3 $4"
			],
			[
				"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
				"$1-$2 $3 $4 $5",
				[
					"[26]"
				],
				"0$1",
				0,
				"$1 $2 $3 $4 $5"
			]
		],
		"0"
	],
	SG: [
		"65",
		"0[0-3]\\d",
		"(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
		[
			8,
			10,
			11
		],
		[
			[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				[
					"[369]|8(?:0[1-4]|[1-9])"
				]
			],
			[
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"8"
				]
			],
			[
				"(\\d{4})(\\d{4})(\\d{3})",
				"$1 $2 $3",
				[
					"7"
				]
			],
			[
				"(\\d{4})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"1"
				]
			]
		]
	],
	SH: [
		"290",
		"00",
		"(?:[256]\\d|8)\\d{3}",
		[
			4,
			5
		],
		0,
		0,
		0,
		0,
		0,
		0,
		"[256]"
	],
	SI: [
		"386",
		"00|10(?:22|66|88|99)",
		"[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
		[
			5,
			6,
			7,
			8
		],
		[
			[
				"(\\d{2})(\\d{3,6})",
				"$1 $2",
				[
					"8[09]|9"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{5})",
				"$1 $2",
				[
					"59|8"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[37][01]|4[0139]|51|6"
				],
				"0$1"
			],
			[
				"(\\d)(\\d{3})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[1-57]"
				],
				"(0$1)"
			]
		],
		"0",
		0,
		0,
		0,
		0,
		0,
		0,
		"00"
	],
	SJ: [
		"47",
		"00",
		"0\\d{4}|(?:[489]\\d|[57]9)\\d{6}",
		[
			5,
			8
		],
		0,
		0,
		0,
		0,
		0,
		0,
		"79"
	],
	SK: [
		"421",
		"00",
		"[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
		[
			6,
			7,
			9
		],
		[
			[
				"(\\d)(\\d{2})(\\d{3,4})",
				"$1 $2 $3",
				[
					"21"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{2})(\\d{2,3})",
				"$1 $2 $3",
				[
					"[3-5][1-8]1",
					"[3-5][1-8]1[67]"
				],
				"0$1"
			],
			[
				"(\\d)(\\d{3})(\\d{3})(\\d{2})",
				"$1/$2 $3 $4",
				[
					"2"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[689]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
				"$1/$2 $3 $4",
				[
					"[3-5]"
				],
				"0$1"
			]
		],
		"0"
	],
	SL: [
		"232",
		"00",
		"(?:[237-9]\\d|66)\\d{6}",
		[
			8
		],
		[
			[
				"(\\d{2})(\\d{6})",
				"$1 $2",
				[
					"[236-9]"
				],
				"(0$1)"
			]
		],
		"0"
	],
	SM: [
		"378",
		"00",
		"(?:0549|[5-7]\\d)\\d{6}",
		[
			8,
			10
		],
		[
			[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[5-7]"
				]
			],
			[
				"(\\d{4})(\\d{6})",
				"$1 $2",
				[
					"0"
				]
			]
		],
		0,
		0,
		"([89]\\d{5})$",
		"0549$1"
	],
	SN: [
		"221",
		"00",
		"(?:[378]\\d|93)\\d{7}",
		[
			9
		],
		[
			[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"8"
				]
			],
			[
				"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[379]"
				]
			]
		]
	],
	SO: [
		"252",
		"00",
		"[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
		[
			6,
			7,
			8,
			9
		],
		[
			[
				"(\\d{2})(\\d{4})",
				"$1 $2",
				[
					"8[125]"
				]
			],
			[
				"(\\d{6})",
				"$1",
				[
					"[134]"
				]
			],
			[
				"(\\d)(\\d{6})",
				"$1 $2",
				[
					"[15]|2[0-79]|3[0-46-8]|4[0-7]"
				]
			],
			[
				"(\\d)(\\d{7})",
				"$1 $2",
				[
					"24|[67]"
				]
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[3478]|64|90"
				]
			],
			[
				"(\\d{2})(\\d{5,7})",
				"$1 $2",
				[
					"1|28|6(?:0[5-7]|[1-35-9])|9[2-9]"
				]
			]
		],
		"0"
	],
	SR: [
		"597",
		"00",
		"(?:[2-5]|68|[78]\\d)\\d{5}",
		[
			6,
			7
		],
		[
			[
				"(\\d{2})(\\d{2})(\\d{2})",
				"$1-$2-$3",
				[
					"56"
				]
			],
			[
				"(\\d{3})(\\d{3})",
				"$1-$2",
				[
					"[2-5]"
				]
			],
			[
				"(\\d{3})(\\d{4})",
				"$1-$2",
				[
					"[6-8]"
				]
			]
		]
	],
	SS: [
		"211",
		"00",
		"[19]\\d{8}",
		[
			9
		],
		[
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[19]"
				],
				"0$1"
			]
		],
		"0"
	],
	ST: [
		"239",
		"00",
		"(?:22|9\\d)\\d{5}",
		[
			7
		],
		[
			[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				[
					"[29]"
				]
			]
		]
	],
	SV: [
		"503",
		"00",
		"[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",
		[
			7,
			8,
			11
		],
		[
			[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				[
					"[89]"
				]
			],
			[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				[
					"[267]"
				]
			],
			[
				"(\\d{3})(\\d{4})(\\d{4})",
				"$1 $2 $3",
				[
					"[89]"
				]
			]
		]
	],
	SX: [
		"1",
		"011",
		"7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
		[
			10
		],
		0,
		"1",
		0,
		"1|(5\\d{6})$",
		"721$1",
		0,
		"721"
	],
	SY: [
		"963",
		"00",
		"[1-39]\\d{8}|[1-5]\\d{7}",
		[
			8,
			9
		],
		[
			[
				"(\\d{2})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"[1-5]"
				],
				"0$1",
				1
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"9"
				],
				"0$1",
				1
			]
		],
		"0"
	],
	SZ: [
		"268",
		"00",
		"0800\\d{4}|(?:[237]\\d|900)\\d{6}",
		[
			8,
			9
		],
		[
			[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				[
					"[0237]"
				]
			],
			[
				"(\\d{5})(\\d{4})",
				"$1 $2",
				[
					"9"
				]
			]
		]
	],
	TA: [
		"290",
		"00",
		"8\\d{3}",
		[
			4
		],
		0,
		0,
		0,
		0,
		0,
		0,
		"8"
	],
	TC: [
		"1",
		"011",
		"(?:[58]\\d\\d|649|900)\\d{7}",
		[
			10
		],
		0,
		"1",
		0,
		"1|([2-479]\\d{6})$",
		"649$1",
		0,
		"649"
	],
	TD: [
		"235",
		"00|16",
		"(?:22|[69]\\d|77)\\d{6}",
		[
			8
		],
		[
			[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[2679]"
				]
			]
		],
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		"00"
	],
	TG: [
		"228",
		"00",
		"[279]\\d{7}",
		[
			8
		],
		[
			[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[279]"
				]
			]
		]
	],
	TH: [
		"66",
		"00[1-9]",
		"1\\d{9}|[1689]\\d{8}|[1-57]\\d{7}",
		[
			8,
			9,
			10
		],
		[
			[
				"(\\d)(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"2"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"[13-9]"
				],
				"0$1"
			],
			[
				"(\\d{4})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"1"
				]
			]
		],
		"0"
	],
	TJ: [
		"992",
		"810",
		"(?:00|11|[2-57-9]\\d)\\d{7}",
		[
			9
		],
		[
			[
				"(\\d{6})(\\d)(\\d{2})",
				"$1 $2 $3",
				[
					"331",
					"3317"
				],
				0,
				1
			],
			[
				"(\\d{3})(\\d{2})(\\d{4})",
				"$1 $2 $3",
				[
					"[34]7|91[78]"
				],
				0,
				1
			],
			[
				"(\\d{4})(\\d)(\\d{4})",
				"$1 $2 $3",
				[
					"3[1-5]"
				],
				0,
				1
			],
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"[02-57-9]|11"
				],
				0,
				1
			]
		],
		"8",
		0,
		0,
		0,
		0,
		0,
		0,
		"8~10"
	],
	TK: [
		"690",
		"00",
		"[2-47]\\d{3,6}",
		[
			4,
			5,
			6,
			7
		]
	],
	TL: [
		"670",
		"00",
		"7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
		[
			7,
			8
		],
		[
			[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				[
					"[2-489]|70"
				]
			],
			[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				[
					"7"
				]
			]
		]
	],
	TM: [
		"993",
		"810",
		"[1-6]\\d{7}",
		[
			8
		],
		[
			[
				"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2-$3-$4",
				[
					"12"
				],
				"(8 $1)"
			],
			[
				"(\\d{3})(\\d)(\\d{2})(\\d{2})",
				"$1 $2-$3-$4",
				[
					"[1-5]"
				],
				"(8 $1)"
			],
			[
				"(\\d{2})(\\d{6})",
				"$1 $2",
				[
					"6"
				],
				"8 $1"
			]
		],
		"8",
		0,
		0,
		0,
		0,
		0,
		0,
		"8~10"
	],
	TN: [
		"216",
		"00",
		"[2-57-9]\\d{7}",
		[
			8
		],
		[
			[
				"(\\d{2})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[2-57-9]"
				]
			]
		]
	],
	TO: [
		"676",
		"00",
		"(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
		[
			5,
			7
		],
		[
			[
				"(\\d{2})(\\d{3})",
				"$1-$2",
				[
					"[2-4]|50|6[09]|7[0-24-69]|8[05]"
				]
			],
			[
				"(\\d{4})(\\d{3})",
				"$1 $2",
				[
					"0"
				]
			],
			[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				[
					"[5-9]"
				]
			]
		]
	],
	TR: [
		"90",
		"00",
		"4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
		[
			7,
			10,
			12,
			13
		],
		[
			[
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"512|8[01589]|90"
				],
				"0$1",
				1
			],
			[
				"(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"5(?:[0-59]|61)",
					"5(?:[0-59]|616)",
					"5(?:[0-59]|6161)"
				],
				"0$1",
				1
			],
			[
				"(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[24][1-8]|3[1-9]"
				],
				"(0$1)",
				1
			],
			[
				"(\\d{3})(\\d{3})(\\d{6,7})",
				"$1 $2 $3",
				[
					"80"
				],
				"0$1",
				1
			]
		],
		"0"
	],
	TT: [
		"1",
		"011",
		"(?:[58]\\d\\d|900)\\d{7}",
		[
			10
		],
		0,
		"1",
		0,
		"1|([2-46-8]\\d{6})$",
		"868$1",
		0,
		"868"
	],
	TV: [
		"688",
		"00",
		"(?:2|7\\d\\d|90)\\d{4}",
		[
			5,
			6,
			7
		],
		[
			[
				"(\\d{2})(\\d{3})",
				"$1 $2",
				[
					"2"
				]
			],
			[
				"(\\d{2})(\\d{4})",
				"$1 $2",
				[
					"90"
				]
			],
			[
				"(\\d{2})(\\d{5})",
				"$1 $2",
				[
					"7"
				]
			]
		]
	],
	TW: [
		"886",
		"0(?:0[25-79]|19)",
		"[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
		[
			7,
			8,
			9,
			10,
			11
		],
		[
			[
				"(\\d{2})(\\d)(\\d{4})",
				"$1 $2 $3",
				[
					"202"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"[258]0"
				],
				"0$1"
			],
			[
				"(\\d)(\\d{3,4})(\\d{4})",
				"$1 $2 $3",
				[
					"[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
					"[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[49]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{4})(\\d{4,5})",
				"$1 $2 $3",
				[
					"7"
				],
				"0$1"
			]
		],
		"0",
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		"#"
	],
	TZ: [
		"255",
		"00[056]",
		"(?:[26-8]\\d|41|90)\\d{7}",
		[
			9
		],
		[
			[
				"(\\d{3})(\\d{2})(\\d{4})",
				"$1 $2 $3",
				[
					"[89]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"[24]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[67]"
				],
				"0$1"
			]
		],
		"0"
	],
	UA: [
		"380",
		"00",
		"[89]\\d{9}|[3-9]\\d{8}",
		[
			9,
			10
		],
		[
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
					"6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"4[45][0-5]|5(?:0|6[37])|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]",
					"4[45][0-5]|5(?:0|6(?:3[14-7]|7))|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]"
				],
				"0$1"
			],
			[
				"(\\d{4})(\\d{5})",
				"$1 $2",
				[
					"[3-6]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"[89]"
				],
				"0$1"
			]
		],
		"0",
		0,
		0,
		0,
		0,
		0,
		0,
		"0~0"
	],
	UG: [
		"256",
		"00[057]",
		"800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
		[
			9
		],
		[
			[
				"(\\d{4})(\\d{5})",
				"$1 $2",
				[
					"202",
					"2024"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{6})",
				"$1 $2",
				[
					"[27-9]|4(?:6[45]|[7-9])"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{7})",
				"$1 $2",
				[
					"[34]"
				],
				"0$1"
			]
		],
		"0"
	],
	US: [
		"1",
		"011",
		"[2-9]\\d{9}",
		[
			10
		],
		[
			[
				"(\\d{3})(\\d{3})(\\d{4})",
				"($1) $2-$3",
				[
					"[2-9]"
				],
				0,
				1,
				"$1-$2-$3"
			]
		],
		"1",
		0,
		0,
		0,
		0,
		0,
		[
			[
				"(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[0-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-289]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01579]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"
			],
			[
				""
			],
			[
				"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
			],
			[
				"900[2-9]\\d{6}"
			],
			[
				"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"
			]
		]
	],
	UY: [
		"598",
		"0(?:0|1[3-9]\\d)",
		"4\\d{9}|[249]\\d{7}|(?:[49]\\d|80)\\d{5}",
		[
			7,
			8,
			10
		],
		[
			[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				[
					"405|8|90"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"9"
				],
				"0$1"
			],
			[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				[
					"[24]"
				]
			],
			[
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"4"
				],
				"0$1"
			]
		],
		"0",
		0,
		0,
		0,
		0,
		0,
		0,
		"00",
		" int. "
	],
	UZ: [
		"998",
		"810",
		"(?:33|55|[679]\\d|88)\\d{7}",
		[
			9
		],
		[
			[
				"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[35-9]"
				],
				"8 $1"
			]
		],
		"8",
		0,
		0,
		0,
		0,
		0,
		0,
		"8~10"
	],
	VA: [
		"39",
		"00",
		"0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
		[
			6,
			7,
			8,
			9,
			10,
			11
		],
		0,
		0,
		0,
		0,
		0,
		0,
		"06698"
	],
	VC: [
		"1",
		"011",
		"(?:[58]\\d\\d|784|900)\\d{7}",
		[
			10
		],
		0,
		"1",
		0,
		"1|([2-7]\\d{6})$",
		"784$1",
		0,
		"784"
	],
	VE: [
		"58",
		"00",
		"[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
		[
			10
		],
		[
			[
				"(\\d{3})(\\d{7})",
				"$1-$2",
				[
					"[24-689]"
				],
				"0$1"
			]
		],
		"0"
	],
	VG: [
		"1",
		"011",
		"(?:284|[58]\\d\\d|900)\\d{7}",
		[
			10
		],
		0,
		"1",
		0,
		"1|([2-578]\\d{6})$",
		"284$1",
		0,
		"284"
	],
	VI: [
		"1",
		"011",
		"[58]\\d{9}|(?:34|90)0\\d{7}",
		[
			10
		],
		0,
		"1",
		0,
		"1|([2-9]\\d{6})$",
		"340$1",
		0,
		"340"
	],
	VN: [
		"84",
		"00",
		"[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
		[
			7,
			8,
			9,
			10
		],
		[
			[
				"(\\d{2})(\\d{5})",
				"$1 $2",
				[
					"80"
				],
				"0$1",
				1
			],
			[
				"(\\d{4})(\\d{4,6})",
				"$1 $2",
				[
					"1"
				],
				0,
				1
			],
			[
				"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"[69]"
				],
				"0$1",
				1
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[3578]"
				],
				"0$1",
				1
			],
			[
				"(\\d{2})(\\d{4})(\\d{4})",
				"$1 $2 $3",
				[
					"2[48]"
				],
				"0$1",
				1
			],
			[
				"(\\d{3})(\\d{4})(\\d{3})",
				"$1 $2 $3",
				[
					"2"
				],
				"0$1",
				1
			]
		],
		"0"
	],
	VU: [
		"678",
		"00",
		"[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
		[
			5,
			7
		],
		[
			[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				[
					"[57-9]"
				]
			]
		]
	],
	WF: [
		"681",
		"00",
		"(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",
		[
			6,
			9
		],
		[
			[
				"(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3",
				[
					"[478]"
				]
			],
			[
				"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
				"$1 $2 $3 $4",
				[
					"8"
				]
			]
		]
	],
	WS: [
		"685",
		"0",
		"(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
		[
			5,
			6,
			7,
			10
		],
		[
			[
				"(\\d{5})",
				"$1",
				[
					"[2-5]|6[1-9]"
				]
			],
			[
				"(\\d{3})(\\d{3,7})",
				"$1 $2",
				[
					"[68]"
				]
			],
			[
				"(\\d{2})(\\d{5})",
				"$1 $2",
				[
					"7"
				]
			]
		]
	],
	XK: [
		"383",
		"00",
		"[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",
		[
			8,
			9
		],
		[
			[
				"(\\d{3})(\\d{5})",
				"$1 $2",
				[
					"[89]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[2-4]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[23]"
				],
				"0$1"
			]
		],
		"0"
	],
	YE: [
		"967",
		"00",
		"(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
		[
			7,
			8,
			9
		],
		[
			[
				"(\\d)(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"[1-6]|7[24-68]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"7"
				],
				"0$1"
			]
		],
		"0"
	],
	YT: [
		"262",
		"00",
		"80\\d{7}|(?:26|63)9\\d{6}",
		[
			9
		],
		0,
		"0",
		0,
		0,
		0,
		0,
		"269|63"
	],
	ZA: [
		"27",
		"00",
		"[1-79]\\d{8}|8\\d{4,9}",
		[
			5,
			6,
			7,
			8,
			9,
			10
		],
		[
			[
				"(\\d{2})(\\d{3,4})",
				"$1 $2",
				[
					"8[1-4]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{2,3})",
				"$1 $2 $3",
				[
					"8[1-4]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"860"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"[1-9]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"8"
				],
				"0$1"
			]
		],
		"0"
	],
	ZM: [
		"260",
		"00",
		"(?:63|80)0\\d{6}|(?:21|[79]\\d)\\d{7}",
		[
			9
		],
		[
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[28]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{7})",
				"$1 $2",
				[
					"[79]"
				],
				"0$1"
			]
		],
		"0"
	],
	ZW: [
		"263",
		"00",
		"2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
		[
			5,
			6,
			7,
			8,
			9,
			10
		],
		[
			[
				"(\\d{3})(\\d{3,5})",
				"$1 $2",
				[
					"2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
				],
				"0$1"
			],
			[
				"(\\d)(\\d{3})(\\d{2,4})",
				"$1 $2 $3",
				[
					"[49]"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{4})",
				"$1 $2",
				[
					"80"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{7})",
				"$1 $2",
				[
					"24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
					"2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
				],
				"(0$1)"
			],
			[
				"(\\d{2})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"7"
				],
				"0$1"
			],
			[
				"(\\d{3})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
					"2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
				],
				"0$1"
			],
			[
				"(\\d{4})(\\d{6})",
				"$1 $2",
				[
					"8"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3,5})",
				"$1 $2",
				[
					"1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
				],
				"0$1"
			],
			[
				"(\\d{2})(\\d{3})(\\d{3,4})",
				"$1 $2 $3",
				[
					"29[013-9]|39|54"
				],
				"0$1"
			],
			[
				"(\\d{4})(\\d{3,5})",
				"$1 $2",
				[
					"(?:25|54)8",
					"258|5483"
				],
				"0$1"
			]
		],
		"0"
	]
};
var nonGeographic = {
	"800": [
		"800",
		0,
		"(?:005|[1-9]\\d\\d)\\d{5}",
		[
			8
		],
		[
			[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				[
					"\\d"
				]
			]
		],
		0,
		0,
		0,
		0,
		0,
		0,
		[
			0,
			0,
			[
				"(?:005|[1-9]\\d\\d)\\d{5}"
			]
		]
	],
	"808": [
		"808",
		0,
		"[1-9]\\d{7}",
		[
			8
		],
		[
			[
				"(\\d{4})(\\d{4})",
				"$1 $2",
				[
					"[1-9]"
				]
			]
		],
		0,
		0,
		0,
		0,
		0,
		0,
		[
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			[
				"[1-9]\\d{7}"
			]
		]
	],
	"870": [
		"870",
		0,
		"7\\d{11}|[35-7]\\d{8}",
		[
			9,
			12
		],
		[
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"[35-7]"
				]
			]
		],
		0,
		0,
		0,
		0,
		0,
		0,
		[
			0,
			[
				"(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
			]
		]
	],
	"878": [
		"878",
		0,
		"10\\d{10}",
		[
			12
		],
		[
			[
				"(\\d{2})(\\d{5})(\\d{5})",
				"$1 $2 $3",
				[
					"1"
				]
			]
		],
		0,
		0,
		0,
		0,
		0,
		0,
		[
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			[
				"10\\d{10}"
			]
		]
	],
	"881": [
		"881",
		0,
		"[0-36-9]\\d{8}",
		[
			9
		],
		[
			[
				"(\\d)(\\d{3})(\\d{5})",
				"$1 $2 $3",
				[
					"[0-36-9]"
				]
			]
		],
		0,
		0,
		0,
		0,
		0,
		0,
		[
			0,
			[
				"[0-36-9]\\d{8}"
			]
		]
	],
	"882": [
		"882",
		0,
		"[13]\\d{6}(?:\\d{2,5})?|285\\d{9}|(?:[19]\\d|49)\\d{6}",
		[
			7,
			8,
			9,
			10,
			11,
			12
		],
		[
			[
				"(\\d{2})(\\d{5})",
				"$1 $2",
				[
					"16|342"
				]
			],
			[
				"(\\d{2})(\\d{6})",
				"$1 $2",
				[
					"4"
				]
			],
			[
				"(\\d{2})(\\d{2})(\\d{4})",
				"$1 $2 $3",
				[
					"[19]"
				]
			],
			[
				"(\\d{2})(\\d{4})(\\d{3})",
				"$1 $2 $3",
				[
					"3[23]"
				]
			],
			[
				"(\\d{2})(\\d{3,4})(\\d{4})",
				"$1 $2 $3",
				[
					"1"
				]
			],
			[
				"(\\d{2})(\\d{4})(\\d{4})",
				"$1 $2 $3",
				[
					"34[57]"
				]
			],
			[
				"(\\d{3})(\\d{4})(\\d{4})",
				"$1 $2 $3",
				[
					"34"
				]
			],
			[
				"(\\d{2})(\\d{4,5})(\\d{5})",
				"$1 $2 $3",
				[
					"[1-3]"
				]
			]
		],
		0,
		0,
		0,
		0,
		0,
		0,
		[
			0,
			[
				"342\\d{4}|(?:337|49)\\d{6}|3(?:2|47|7\\d{3})\\d{7}",
				[
					7,
					8,
					9,
					10,
					12
				]
			],
			0,
			0,
			0,
			0,
			0,
			0,
			[
				"1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:(?:285\\d\\d|3(?:45|[69]\\d{3}))\\d|9[89])\\d{6}"
			]
		]
	],
	"883": [
		"883",
		0,
		"210\\d{7}|51\\d{7}(?:\\d{3})?",
		[
			9,
			10,
			12
		],
		[
			[
				"(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3",
				[
					"510"
				]
			],
			[
				"(\\d{3})(\\d{3})(\\d{4})",
				"$1 $2 $3",
				[
					"2"
				]
			],
			[
				"(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
				"$1 $2 $3 $4",
				[
					"510"
				]
			],
			[
				"(\\d{4})(\\d{4})(\\d{4})",
				"$1 $2 $3",
				[
					"5"
				]
			]
		],
		0,
		0,
		0,
		0,
		0,
		0,
		[
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			[
				"(?:210|51[013]0\\d)\\d{7}|5100\\d{5}"
			]
		]
	],
	"888": [
		"888",
		0,
		"\\d{11}",
		[
			11
		],
		[
			[
				"(\\d{3})(\\d{3})(\\d{5})",
				"$1 $2 $3"
			]
		],
		0,
		0,
		0,
		0,
		0,
		0,
		[
			0,
			0,
			0,
			0,
			0,
			0,
			[
				"\\d{11}"
			]
		]
	],
	"979": [
		"979",
		0,
		"[1359]\\d{8}",
		[
			9
		],
		[
			[
				"(\\d)(\\d{4})(\\d{4})",
				"$1 $2 $3",
				[
					"[1359]"
				]
			]
		],
		0,
		0,
		0,
		0,
		0,
		0,
		[
			0,
			0,
			0,
			[
				"[1359]\\d{8}"
			]
		]
	]
};
var metadata = {
	version: version,
	country_calling_codes: country_calling_codes,
	countries: countries,
	nonGeographic: nonGeographic
};

var classnames = _commonjsHelpers.createCommonjsModule(function (module) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

// Edits text `value` (if `operation` is passed) and repositions the `caret` if needed.
//
// Example:
//
// value - '88005553535'
// caret - 2 // starting from 0; is positioned before the first zero
// operation - 'Backspace'
//
// Returns
// {
// 	value: '8005553535'
// 	caret: 1
// }
//
// Currently supports just 'Delete' and 'Backspace' operations
//
function edit(value, caret, operation) {
  switch (operation) {
    case 'Backspace':
      // If there exists the previous character,
      // then erase it and reposition the caret.
      if (caret > 0) {
        // Remove the previous character
        value = value.slice(0, caret - 1) + value.slice(caret); // Position the caret where the previous (erased) character was

        caret--;
      }

      break;

    case 'Delete':
      // Remove current digit (if any)
      value = value.slice(0, caret) + value.slice(caret + 1);
      break;
  }

  return {
    value: value,
    caret: caret
  };
}

// Parses the `text`.
//
// Returns `{ value, caret }` where `caret` is
// the caret position inside `value`
// corresponding to the `caret_position` inside `text`.
//
// The `text` is parsed by feeding each character sequentially to
// `parse_character(character, value)` function
// and appending the result (if it's not `undefined`) to `value`.
//
// Example:
//
// `text` is `8 (800) 555-35-35`,
// `caret_position` is `4` (before the first `0`).
// `parse_character` is `(character, value) =>
//   if (character >= '0' && character <= '9') { return character }`.
//
// then `parse()` outputs `{ value: '88005553535', caret: 2 }`.
//
function parse(text, caret_position, parse_character) {
  var value = '';
  var focused_input_character_index = 0;
  var index = 0;

  while (index < text.length) {
    var character = parse_character(text[index], value);

    if (character !== undefined) {
      value += character;

      if (caret_position !== undefined) {
        if (caret_position === index) {
          focused_input_character_index = value.length - 1;
        } else if (caret_position > index) {
          focused_input_character_index = value.length;
        }
      }
    }

    index++;
  } // If caret position wasn't specified


  if (caret_position === undefined) {
    // Then set caret position to "after the last input character"
    focused_input_character_index = value.length;
  }

  var result = {
    value: value,
    caret: focused_input_character_index
  };
  return result;
}

// Counts all occurences of a symbol in a string
function count_occurences(symbol, string) {
  var count = 0; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes)
  // but template placeholder characters don't fall into that range
  // so skipping such miscellaneous "exotic" characters
  // won't matter here for just counting placeholder character occurrences.

  for (var _iterator = string.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var character = _ref;

    if (character === symbol) {
      count++;
    }
  }

  return count;
}

function closeBraces(retained_template, template) {
  var placeholder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'x';
  var empty_placeholder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ' ';
  var cut_before = retained_template.length;
  var opening_braces = count_occurences('(', retained_template);
  var closing_braces = count_occurences(')', retained_template);
  var dangling_braces = opening_braces - closing_braces;

  while (dangling_braces > 0 && cut_before < template.length) {
    retained_template += template[cut_before].replace(placeholder, empty_placeholder);

    if (template[cut_before] === ')') {
      dangling_braces--;
    }

    cut_before++;
  }

  return retained_template;
}

// are denoted by 'x'es (e.g. 'x (xxx) xxx-xx-xx').
//
// Returns a function which takes `value` characters
// and returns the `template` filled with those characters.
// If the `template` can only be partially filled
// then it is cut off.
//
// If `should_close_braces` is `true`,
// then it will also make sure all dangling braces are closed,
// e.g. "8 (8" -> "8 (8  )" (iPhone style phone number input).
//

function template_formatter (template) {
  var placeholder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'x';
  var should_close_braces = arguments.length > 2 ? arguments[2] : undefined;

  if (!template) {
    return function (value) {
      return {
        text: value
      };
    };
  }

  var characters_in_template = count_occurences(placeholder, template);
  return function (value) {
    if (!value) {
      return {
        text: '',
        template: template
      };
    }

    var value_character_index = 0;
    var filled_in_template = ''; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes)
    // but template placeholder characters don't fall into that range
    // and appending UTF-8 characters to a string in parts still works.

    for (var _iterator = template.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var character = _ref;

      if (character !== placeholder) {
        filled_in_template += character;
        continue;
      }

      filled_in_template += value[value_character_index];
      value_character_index++; // If the last available value character has been filled in,
      // then return the filled in template
      // (either trim the right part or retain it,
      //  if no more character placeholders in there)

      if (value_character_index === value.length) {
        // If there are more character placeholders
        // in the right part of the template
        // then simply trim it.
        if (value.length < characters_in_template) {
          break;
        }
      }
    }

    if (should_close_braces) {
      filled_in_template = closeBraces(filled_in_template, template);
    }

    return {
      text: filled_in_template,
      template: template
    };
  };
}

//
// `{ value, caret }` attribute is the result of `parse()` function call.
//
// Returns `{ text, caret }` where the new `caret` is the caret position
// inside `text` text corresponding to the original `caret` position inside `value`.
//
// `formatter(value)` is a function returning `{ text, template }`.
//
// `text` is the `value` value formatted using `template`.
// It may either cut off the non-filled right part of the `template`
// or it may fill the non-filled character placeholders
// in the right part of the `template` with `spacer`
// which is a space (' ') character by default.
//
// `template` is the template used to format the `value`.
// It can be either a full-length template or a partial template.
//
// `formatter` can also be a string — a `template`
// where character placeholders are denoted by 'x'es.
// In this case `formatter` function is automatically created.
//
// Example:
//
// `value` is '880',
// `caret` is `2` (before the first `0`)
//
// `formatter` is `'880' =>
//   { text: '8 (80 )', template: 'x (xxx) xxx-xx-xx' }`
//
// The result is `{ text: '8 (80 )', caret: 4 }`.
//

function format(value, caret, formatter) {
  if (typeof formatter === 'string') {
    formatter = template_formatter(formatter);
  }

  var _ref = formatter(value) || {},
      text = _ref.text,
      template = _ref.template;

  if (text === undefined) {
    text = value;
  }

  if (template) {
    if (caret === undefined) {
      caret = text.length;
    } else {
      var index = 0;
      var found = false;
      var possibly_last_input_character_index = -1;

      while (index < text.length && index < template.length) {
        // Character placeholder found
        if (text[index] !== template[index]) {
          if (caret === 0) {
            found = true;
            caret = index;
            break;
          }

          possibly_last_input_character_index = index;
          caret--;
        }

        index++;
      } // If the caret was positioned after last input character,
      // then the text caret index is just after the last input character.


      if (!found) {
        caret = possibly_last_input_character_index + 1;
      }
    }
  }

  return {
    text: text,
    caret: caret
  };
}

// Gets <input/> selection bounds
function getSelection(element) {
  // If no selection, return nothing
  if (element.selectionStart === element.selectionEnd) {
    return;
  }

  return {
    start: element.selectionStart,
    end: element.selectionEnd
  };
} // Key codes

var Keys = {
  Backspace: 8,
  Delete: 46
}; // Finds out the operation to be intercepted and performed
// based on the key down event `keyCode`.

function getOperation(event) {
  switch (event.keyCode) {
    case Keys.Backspace:
      return 'Backspace';

    case Keys.Delete:
      return 'Delete';
  }
} // Gets <input/> caret position

function getCaretPosition(element) {
  return element.selectionStart;
} // Sets <input/> caret position

function setCaretPosition(element, caret_position) {
  // Sanity check
  if (caret_position === undefined) {
    return;
  } // Set caret position.
  // There has been an issue with caret positioning on Android devices.
  // https://github.com/catamphetamine/input-format/issues/2
  // I was revisiting this issue and looked for similar issues in other libraries.
  // For example, there's [`text-mask`](https://github.com/text-mask/text-mask) library.
  // They've had exactly the same issue when the caret seemingly refused to be repositioned programmatically.
  // The symptoms were the same: whenever the caret passed through a non-digit character of a mask (a whitespace, a bracket, a dash, etc), it looked as if it placed itself one character before its correct position.
  // https://github.com/text-mask/text-mask/issues/300
  // They seem to have found a basic fix for it: calling `input.setSelectionRange()` in a timeout rather than instantly for Android devices.
  // https://github.com/text-mask/text-mask/pull/400/files
  // I've implemented the same workaround here.


  if (isAndroid()) {
    setTimeout(function () {
      return element.setSelectionRange(caret_position, caret_position);
    }, 0);
  } else {
    element.setSelectionRange(caret_position, caret_position);
  }
}

function isAndroid() {
  // `navigator` is not defined when running mocha tests.
  if (typeof navigator !== 'undefined') {
    return ANDROID_USER_AGENT_REG_EXP.test(navigator.userAgent);
  }
}

var ANDROID_USER_AGENT_REG_EXP = /Android/i;

function onChange(event, input, _parse, _format, on_change) {
  formatInputText(input, _parse, _format, undefined, on_change);
} // "Delete" and "Backspace" keys are special
// in a way that they're not handled by the regular `onChange()` handler
// and instead are intercepted and re-applied manually.
// The reason is that normally hitting "Backspace" or "Delete"
// results in erasing a character, but that character might be any character,
// while it would be a better "user experience" if it erased not just any character
// but the closest "meaningful" character.
// For example, if a template is `(xxx) xxx-xxxx`,
// and the `<input/>` value is `(111) 222-3333`,
// then, if a user begins erasing the `3333` part via "Backspace"
// and reaches the "-" character, then it would just erase the "-" character.
// Nothing wrong with that, but it would be a better "user experience"
// if hitting "Backspace" at that position would erase the closest "meaningful"
// character, which would be the rightmost `2`.
// So, what this `onKeyDown()` handler does is it intercepts
// "Backspace" and "Delete" keys and re-applies those operations manually
// following the logic described above.

function onKeyDown(event, input, _parse, _format, on_change) {
  var operation = getOperation(event);

  switch (operation) {
    case 'Delete':
    case 'Backspace':
      // Intercept this operation and perform it manually.
      event.preventDefault();
      var selection = getSelection(input); // If a selection is made, just erase the selected text.

      if (selection) {
        eraseSelection(input, selection);
        return formatInputText(input, _parse, _format, undefined, on_change);
      } // Else, perform the (character erasing) operation manually.


      return formatInputText(input, _parse, _format, operation, on_change);

  }
}
/**
 * Erases the selected text inside an `<input/>`.
 * @param  {DOMElement} input
 * @param  {Selection} selection
 */

function eraseSelection(input, selection) {
  var text = input.value;
  text = text.slice(0, selection.start) + text.slice(selection.end);
  input.value = text;
  setCaretPosition(input, selection.start);
}
/**
 * Parses and re-formats `<input/>` textual value.
 * E.g. when a user enters something into the `<input/>`
 * that raw input must first be parsed and the re-formatted properly.
 * Is called either after some user input (e.g. entered a character, pasted something)
 * or after the user performed an `operation` (e.g. "Backspace", "Delete").
 * @param  {DOMElement} input
 * @param  {Function} parse
 * @param  {Function} format
 * @param  {string} [operation] - The operation that triggered `<input/>` textual value change. E.g. "Backspace", "Delete".
 * @param  {Function} onChange
 */


function formatInputText(input, _parse, _format, operation, on_change) {
  // Parse `<input/>` textual value.
  // Get the `value` and `caret` position.
  var _parse2 = parse(input.value, getCaretPosition(input), _parse),
      value = _parse2.value,
      caret = _parse2.caret; // If a user performed an operation ("Backspace", "Delete")
  // then apply that operation and get the new `value` and `caret` position.


  if (operation) {
    var newValueAndCaret = edit(value, caret, operation);
    value = newValueAndCaret.value;
    caret = newValueAndCaret.caret;
  } // Format the `value`.
  // (and reposition the caret accordingly)


  var formatted = format(value, caret, _format);
  var text = formatted.text;
  caret = formatted.caret; // Set `<input/>` textual value manually
  // to prevent React from resetting the caret position
  // later inside a subsequent `render()`.
  // Doesn't work for custom `inputComponent`s for some reason.

  input.value = text; // Position the caret properly.

  setCaretPosition(input, caret); // If the `<input/>` textual value did change,
  // then the parsed `value` may have changed too.

  on_change(value);
}

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
//
// <ReactInput
// 	value={this.state.phone}
// 	onChange={phone => this.setState({ phone })}
// 	parse={character => character}
// 	format={value => ({ text: value, template: 'xxxxxxxx' })}/>
//

function Input(_ref, ref) {
  var value = _ref.value,
      parse = _ref.parse,
      format = _ref.format,
      InputComponent = _ref.inputComponent,
      onChange$1 = _ref.onChange,
      onKeyDown$1 = _ref.onKeyDown,
      rest = _objectWithoutProperties(_ref, ["value", "parse", "format", "inputComponent", "onChange", "onKeyDown"]);

  var internalRef = React.useRef();
  var setRef = React.useCallback(function (instance) {
    internalRef.current = instance;

    if (ref) {
      if (typeof ref === 'function') {
        ref(instance);
      } else {
        ref.current = instance;
      }
    }
  }, [ref]);

  var _onChange = React.useCallback(function (event) {
    return onChange(event, internalRef.current, parse, format, onChange$1);
  }, [internalRef, parse, format, onChange$1]);

  var _onKeyDown = React.useCallback(function (event) {
    if (onKeyDown$1) {
      onKeyDown$1(event);
    }

    return onKeyDown(event, internalRef.current, parse, format, onChange$1);
  }, [internalRef, parse, format, onChange$1, onKeyDown$1]);

  return React__default.createElement(InputComponent, _extends({}, rest, {
    ref: setRef,
    value: format(isEmptyValue(value) ? '' : value).text,
    onKeyDown: _onKeyDown,
    onChange: _onChange
  }));
}

Input = React__default.forwardRef(Input);
Input.propTypes = {
  // Parses a single characher of `<input/>` text.
  parse: index$4.propTypes.func.isRequired,
  // Formats `value` into `<input/>` text.
  format: index$4.propTypes.func.isRequired,
  // Renders `<input/>` by default.
  inputComponent: index$4.propTypes.elementType.isRequired,
  // `<input/>` `type` attribute.
  type: index$4.propTypes.string.isRequired,
  // Is parsed from <input/> text.
  value: index$4.propTypes.string,
  // This handler is called each time `<input/>` text is changed.
  onChange: index$4.propTypes.func.isRequired,
  // Passthrough
  onKeyDown: index$4.propTypes.func,
  onCut: index$4.propTypes.func,
  onPaste: index$4.propTypes.func
};
Input.defaultProps = {
  // Renders `<input/>` by default.
  inputComponent: 'input',
  // `<input/>` `type` attribute.
  type: 'text'
};
var Input$1 = Input;

function isEmptyValue(value) {
  return value === undefined || value === null;
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// https://stackoverflow.com/a/46971044/970769
var ParseError = function ParseError(code) {
  _classCallCheck(this, ParseError);

  this.name = this.constructor.name;
  this.message = code;
  this.stack = new Error(code).stack;
};
ParseError.prototype = Object.create(Error.prototype);
ParseError.prototype.constructor = ParseError;

// The minimum length of the national significant number.
var MIN_LENGTH_FOR_NSN = 2; // The ITU says the maximum length should be 15,
// but one can find longer numbers in Germany.

var MAX_LENGTH_FOR_NSN = 17; // The maximum length of the country calling code.

var MAX_LENGTH_COUNTRY_CODE = 3; // Digits accepted in phone numbers
// (ascii, fullwidth, arabic-indic, and eastern arabic digits).

var VALID_DIGITS = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"

var DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var SLASHES = "\uFF0F/";
var DOTS = "\uFF0E.";
var WHITESPACE = " \xA0\xAD\u200B\u2060\u3000";
var BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['

var TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
// excludes punctuation found as a leading character only. This consists of dash
// characters, white space characters, full stops, slashes, square brackets,
// parentheses and tildes. Full-width variants are also present.

var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
var PLUS_CHARS = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')

// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function compare (a, b) {
  a = a.split('-');
  b = b.split('-');
  var pa = a[0].split('.');
  var pb = b[0].split('.');

  for (var i = 0; i < 3; i++) {
    var na = Number(pa[i]);
    var nb = Number(pb[i]);
    if (na > nb) return 1;
    if (nb > na) return -1;
    if (!isNaN(na) && isNaN(nb)) return 1;
    if (isNaN(na) && !isNaN(nb)) return -1;
  }

  if (a[1] && b[1]) {
    return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
  }

  return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var V3 = '1.2.0'; // Moved `001` country code to "nonGeographic" section of metadata.

var V4 = '1.7.35';
var DEFAULT_EXT_PREFIX = ' ext. ';
var CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */

var Metadata =
/*#__PURE__*/
function () {
  function Metadata(metadata) {
    _classCallCheck$1(this, Metadata);

    validateMetadata(metadata);
    this.metadata = metadata;
    setVersion.call(this, metadata);
  }

  _createClass(Metadata, [{
    key: "getCountries",
    value: function getCountries() {
      return Object.keys(this.metadata.countries).filter(function (_) {
        return _ !== '001';
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function getCountryMetadata(countryCode) {
      return this.metadata.countries[countryCode];
    }
  }, {
    key: "nonGeographic",
    value: function nonGeographic() {
      if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
      // It's present in metadata generated from `1.7.35` to `1.7.37`.

      return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function hasCountry(country) {
      return this.getCountryMetadata(country) !== undefined;
    }
  }, {
    key: "hasCallingCode",
    value: function hasCallingCode(callingCode) {
      if (this.getCountryCodesForCallingCode(callingCode)) {
        return true;
      }

      if (this.nonGeographic()) {
        if (this.nonGeographic()[callingCode]) {
          return true;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return true;
        }
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function isNonGeographicCallingCode(callingCode) {
      if (this.nonGeographic()) {
        return this.nonGeographic()[callingCode] ? true : false;
      } else {
        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
      }
    } // Deprecated.

  }, {
    key: "country",
    value: function country(countryCode) {
      return this.selectNumberingPlan(countryCode);
    }
  }, {
    key: "selectNumberingPlan",
    value: function selectNumberingPlan(countryCode, callingCode) {
      // Supports just passing `callingCode` as the first argument.
      if (countryCode && CALLING_CODE_REG_EXP.test(countryCode)) {
        callingCode = countryCode;
        countryCode = null;
      }

      if (countryCode && countryCode !== '001') {
        if (!this.hasCountry(countryCode)) {
          throw new Error("Unknown country: ".concat(countryCode));
        }

        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
      } else if (callingCode) {
        if (!this.hasCallingCode(callingCode)) {
          throw new Error("Unknown calling code: ".concat(callingCode));
        }

        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
      } else {
        this.numberingPlan = undefined;
      }

      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function getCountryCodesForCallingCode(callingCode) {
      var countryCodes = this.countryCallingCodes()[callingCode];

      if (countryCodes) {
        // Metadata before V4 included "non-geographic entity" calling codes
        // inside `country_calling_codes` (for example, `"881":["001"]`).
        // Now the semantics of `country_calling_codes` has changed:
        // it's specifically for "countries" now.
        // Older versions of custom metadata will simply skip parsing
        // "non-geographic entity" phone numbers with new versions
        // of this library: it's not considered a bug,
        // because such numbers are extremely rare,
        // and developers extremely rarely use custom metadata.
        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
          return;
        }

        return countryCodes;
      }
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function getCountryCodeForCallingCode(callingCode) {
      var countryCodes = this.getCountryCodesForCallingCode(callingCode);

      if (countryCodes) {
        return countryCodes[0];
      }
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function getNumberingPlanMetadata(callingCode) {
      var countryCode = this.getCountryCodeForCallingCode(callingCode);

      if (countryCode) {
        return this.getCountryMetadata(countryCode);
      }

      if (this.nonGeographic()) {
        var metadata = this.nonGeographic()[callingCode];

        if (metadata) {
          return metadata;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return this.metadata.countries['001'];
        }
      }
    } // Deprecated.

  }, {
    key: "countryCallingCode",
    value: function countryCallingCode() {
      return this.numberingPlan.callingCode();
    } // Deprecated.

  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      return this.numberingPlan.IDDPrefix();
    } // Deprecated.

  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      return this.numberingPlan.defaultIDDPrefix();
    } // Deprecated.

  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      return this.numberingPlan.nationalNumberPattern();
    } // Deprecated.

  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      return this.numberingPlan.possibleLengths();
    } // Deprecated.

  }, {
    key: "formats",
    value: function formats() {
      return this.numberingPlan.formats();
    } // Deprecated.

  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this.numberingPlan.nationalPrefixForParsing();
    } // Deprecated.

  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.numberingPlan.nationalPrefixTransformRule();
    } // Deprecated.

  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.numberingPlan.leadingDigits();
    } // Deprecated.

  }, {
    key: "hasTypes",
    value: function hasTypes() {
      return this.numberingPlan.hasTypes();
    } // Deprecated.

  }, {
    key: "type",
    value: function type(_type) {
      return this.numberingPlan.type(_type);
    } // Deprecated.

  }, {
    key: "ext",
    value: function ext() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function countryCallingCodes() {
      if (this.v1) return this.metadata.country_phone_code_to_countries;
      return this.metadata.country_calling_codes;
    } // Deprecated.

  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function chooseCountryByCountryCallingCode(callingCode) {
      return this.selectNumberingPlan(callingCode);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function hasSelectedNumberingPlan() {
      return this.numberingPlan !== undefined;
    }
  }]);

  return Metadata;
}();

var NumberingPlan =
/*#__PURE__*/
function () {
  function NumberingPlan(metadata, globalMetadataObject) {
    _classCallCheck$1(this, NumberingPlan);

    this.globalMetadataObject = globalMetadataObject;
    this.metadata = metadata;
    setVersion.call(this, globalMetadataObject.metadata);
  }

  _createClass(NumberingPlan, [{
    key: "callingCode",
    value: function callingCode() {
      return this.metadata[0];
    } // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.

  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function getDefaultCountryMetadataForRegion() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[1];
    }
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      if (this.v1 || this.v2) return this.metadata[1];
      return this.metadata[2];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.v1) return;
      return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function _getFormats(metadata) {
      return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
    } // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "formats",
    value: function formats() {
      var _this = this;

      var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return formats.map(function (_) {
        return new Format(_, _this);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function nationalPrefix() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function _getNationalPrefixFormattingRule(metadata) {
      return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
    } // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function _nationalPrefixForParsing() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      // If `national_prefix_for_parsing` is not set explicitly,
      // then infer it from `national_prefix` (if any)
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function _getNationalPrefixIsOptionalWhenFormatting() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    } // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function types() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      // Versions 1.2.0 - 1.2.4: can be `[]`.

      /* istanbul ignore next */
      if (this.types() && this.types().length === 0) {
        return false;
      } // Versions <= 1.2.4: can be `undefined`.
      // Version >= 1.2.5: can be `0`.


      return !!this.types();
    }
  }, {
    key: "type",
    value: function type(_type2) {
      if (this.hasTypes() && getType(this.types(), _type2)) {
        return new Type(getType(this.types(), _type2), this);
      }
    }
  }, {
    key: "ext",
    value: function ext() {
      if (this.v1 || this.v2) return DEFAULT_EXT_PREFIX;
      return this.metadata[13] || DEFAULT_EXT_PREFIX;
    }
  }]);

  return NumberingPlan;
}();

var Format =
/*#__PURE__*/
function () {
  function Format(format, metadata) {
    _classCallCheck$1(this, Format);

    this._format = format;
    this.metadata = metadata;
  }

  _createClass(Format, [{
    key: "pattern",
    value: function pattern() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function format() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function leadingDigitsPatterns() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
      // National prefix is omitted if there's no national prefix formatting rule
      // set for this country, or when the national prefix formatting rule
      // contains no national prefix itself, or when this rule is set but
      // national prefix is optional for this phone number format
      // (and it is not enforced explicitly)
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    } // Checks whether national prefix formatting rule contains national prefix.

  }, {
    key: "usesNationalPrefix",
    value: function usesNationalPrefix() {
      return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
      // when `national_prefix_formatting_rule` is not present.
      // So, `true` or `false` are returned explicitly here, so that
      // `0` number isn't returned.
      ? true : false;
    }
  }, {
    key: "internationalFormat",
    value: function internationalFormat() {
      return this._format[5] || this.format();
    }
  }]);

  return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */


var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;

var Type =
/*#__PURE__*/
function () {
  function Type(type, metadata) {
    _classCallCheck$1(this, Type);

    this.type = type;
    this.metadata = metadata;
  }

  _createClass(Type, [{
    key: "pattern",
    value: function pattern() {
      if (this.metadata.v1) return this.type;
      return this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.metadata.v1) return;
      return this.type[1] || this.metadata.possibleLengths();
    }
  }]);

  return Type;
}();

function getType(types, type) {
  switch (type) {
    case 'FIXED_LINE':
      return types[0];

    case 'MOBILE':
      return types[1];

    case 'TOLL_FREE':
      return types[2];

    case 'PREMIUM_RATE':
      return types[3];

    case 'PERSONAL_NUMBER':
      return types[4];

    case 'VOICEMAIL':
      return types[5];

    case 'UAN':
      return types[6];

    case 'PAGER':
      return types[7];

    case 'VOIP':
      return types[8];

    case 'SHARED_COST':
      return types[9];
  }
}

function validateMetadata(metadata) {
  if (!metadata) {
    throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
  } // `country_phone_code_to_countries` was renamed to
  // `country_calling_codes` in `1.0.18`.


  if (!is_object(metadata) || !is_object(metadata.countries)) {
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(is_object(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + type_of(metadata) + ': ' + metadata, "."));
  }
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".

/* istanbul ignore next */

var is_object = function is_object(_) {
  return _typeof(_) === 'object';
}; // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".

/* istanbul ignore next */


var type_of = function type_of(_) {
  return _typeof(_);
};
/**
 * Returns "country calling code" for a country.
 * Throws an error if the country doesn't exist or isn't supported by this library.
 * @param  {string} country
 * @param  {object} metadata
 * @return {string}
 * @example
 * // Returns "44"
 * getCountryCallingCode("GB")
 */

function getCountryCallingCode(country, metadata) {
  metadata = new Metadata(metadata);

  if (metadata.hasCountry(country)) {
    return metadata.country(country).countryCallingCode();
  }

  throw new Error("Unknown country: ".concat(country));
}
function isSupportedCountry(country, metadata) {
  // metadata = new Metadata(metadata)
  // return metadata.hasCountry(country)
  return metadata.countries[country] !== undefined;
}

function setVersion(metadata) {
  var version = metadata.version;

  if (typeof version === 'number') {
    this.v1 = version === 1;
    this.v2 = version === 2;
    this.v3 = version === 3;
    this.v4 = version === 4;
  } else {
    if (!version) {
      this.v1 = true;
    } else if (compare(version, V3) === -1) {
      this.v2 = true;
    } else if (compare(version, V4) === -1) {
      this.v3 = true;
    } else {
      this.v4 = true;
    }
  }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
// function isCountryCode(countryCode) {
// 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
// }

var RFC3966_EXTN_PREFIX = ';ext=';
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */

var getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
  return "([".concat(VALID_DIGITS, "]{1,").concat(maxLength, "})");
};
/**
 * Helper initialiser method to create the regular-expression pattern to match
 * extensions.
 * Copy-pasted from Google's `libphonenumber`:
 * https://github.com/google/libphonenumber/blob/55b2646ec9393f4d3d6661b9c82ef9e258e8b829/javascript/i18n/phonenumbers/phonenumberutil.js#L759-L766
 * @return {string} RegEx pattern to capture extensions.
 */


function createExtensionPattern(purpose) {
  // We cap the maximum length of an extension based on the ambiguity of the way
  // the extension is prefixed. As per ITU, the officially allowed length for
  // extensions is actually 40, but we don't support this since we haven't seen real
  // examples and this introduces many false interpretations as the extension labels
  // are not standardized.

  /** @type {string} */
  var extLimitAfterExplicitLabel = '20';
  /** @type {string} */

  var extLimitAfterLikelyLabel = '15';
  /** @type {string} */

  var extLimitAfterAmbiguousChar = '9';
  /** @type {string} */

  var extLimitWhenNotSure = '6';
  /** @type {string} */

  var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.

  /** @type {string} */

  var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
  /** @type {string} */

  var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
  // patterns like "ext.".

  /** @type {string} */

  var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
  // commonly used or more ambiguous extension labels.

  /** @type {string} */

  var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.

  /** @type {string} */

  var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
  // comma as extension label may have it.

  /** @type {string} */

  var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
  // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
  // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
  // button with the extension number following.

  /** @type {string} */

  var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
  /** @type {string} */

  var rfcExtn = RFC3966_EXTN_PREFIX + getExtensionDigitsPattern(extLimitAfterExplicitLabel);
  /** @type {string} */

  var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
  /** @type {string} */

  var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  /** @type {string} */

  var americanStyleExtnWithSuffix = ambiguousSeparator + getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
  /** @type {string} */

  var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
  /** @type {string} */

  var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
  // using ";ext=". The second more generic where extension is mentioned with explicit
  // labels like "ext:". In both the above cases we allow more numbers in extension than
  // any other extension labels. The third one captures when single character extension
  // labels or less commonly used labels are used. In such cases we capture fewer
  // extension digits in order to reduce the chance of falsely interpreting two
  // numbers beside each other as a number + extension. The fourth one covers the
  // special case of American numbers where the extension is written with a hash
  // at the end, such as "- 503#". The fifth one is exclusively for extension
  // autodialling formats which are used when dialling and in this case we accept longer
  // extensions. The last one is more liberal on the number of commas that acts as
  // extension labels, so we have a strict cap on the number of digits in such extensions.

  return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}

//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//

var MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + VALID_DIGITS + ']{' + MIN_LENGTH_FOR_NSN + '}'; //
// And this is the second reg-exp:
// (see MIN_LENGTH_PHONE_NUMBER_PATTERN for a full description of this reg-exp)
//

var VALID_PHONE_NUMBER = '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){3,}' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']*'; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.

var VALID_PHONE_NUMBER_START_REG_EXP = new RegExp('^' + '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){1,2}' + '$', 'i');
var VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER + // Phone number extensions
'(?:' + createExtensionPattern() + ')?'; // The combined regular expression for valid phone numbers:
//

var VALID_PHONE_NUMBER_PATTERN = new RegExp( // Either a short two-digit-only phone number
'^' + MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' + // Or a longer fully parsed phone number (min 3 characters)
'^' + VALID_PHONE_NUMBER_WITH_EXTENSION + '$', 'i'); // Checks to see if the string of characters could possibly be a phone number at
// all. At the moment, checks to see that the string begins with at least 2
// digits, ignoring any punctuation commonly found in phone numbers. This method
// does not require the number to be normalized in advance - but does assume
// that leading non-number symbols have been removed, such as by the method
// `extract_possible_number`.
//

function isViablePhoneNumber(number) {
  return number.length >= MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.

function isViablePhoneNumberStart(number) {
  return VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}

// 1 or more valid digits, for use when parsing.

var EXTN_PATTERN = new RegExp('(?:' + createExtensionPattern() + ')$', 'i'); // Strips any extension (as in, the part of the number dialled after the call is
// connected, usually indicated with extn, ext, x or similar) from the end of
// the number, and returns it.

function extractExtension(number) {
  var start = number.search(EXTN_PATTERN);

  if (start < 0) {
    return {};
  } // If we find a potential extension, and the number preceding this is a viable
  // number, we assume it is an extension.


  var numberWithoutExtension = number.slice(0, start);
  var matches = number.match(EXTN_PATTERN);
  var i = 1;

  while (i < matches.length) {
    if (matches[i]) {
      return {
        number: numberWithoutExtension,
        ext: matches[i]
      };
    }

    i++;
  }
}

// These mappings map a character (key) to a specific digit that should
// replace it for normalization purposes. Non-European digits that
// may be used in phone numbers are mapped to a European equivalent.
//
// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
//
var DIGITS = {
  '0': '0',
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  "\uFF10": '0',
  // Fullwidth digit 0
  "\uFF11": '1',
  // Fullwidth digit 1
  "\uFF12": '2',
  // Fullwidth digit 2
  "\uFF13": '3',
  // Fullwidth digit 3
  "\uFF14": '4',
  // Fullwidth digit 4
  "\uFF15": '5',
  // Fullwidth digit 5
  "\uFF16": '6',
  // Fullwidth digit 6
  "\uFF17": '7',
  // Fullwidth digit 7
  "\uFF18": '8',
  // Fullwidth digit 8
  "\uFF19": '9',
  // Fullwidth digit 9
  "\u0660": '0',
  // Arabic-indic digit 0
  "\u0661": '1',
  // Arabic-indic digit 1
  "\u0662": '2',
  // Arabic-indic digit 2
  "\u0663": '3',
  // Arabic-indic digit 3
  "\u0664": '4',
  // Arabic-indic digit 4
  "\u0665": '5',
  // Arabic-indic digit 5
  "\u0666": '6',
  // Arabic-indic digit 6
  "\u0667": '7',
  // Arabic-indic digit 7
  "\u0668": '8',
  // Arabic-indic digit 8
  "\u0669": '9',
  // Arabic-indic digit 9
  "\u06F0": '0',
  // Eastern-Arabic digit 0
  "\u06F1": '1',
  // Eastern-Arabic digit 1
  "\u06F2": '2',
  // Eastern-Arabic digit 2
  "\u06F3": '3',
  // Eastern-Arabic digit 3
  "\u06F4": '4',
  // Eastern-Arabic digit 4
  "\u06F5": '5',
  // Eastern-Arabic digit 5
  "\u06F6": '6',
  // Eastern-Arabic digit 6
  "\u06F7": '7',
  // Eastern-Arabic digit 7
  "\u06F8": '8',
  // Eastern-Arabic digit 8
  "\u06F9": '9' // Eastern-Arabic digit 9

};
function parseDigit(character) {
  return DIGITS[character];
}
/**
 * Parses phone number digits from a string.
 * Drops all punctuation leaving only digits.
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * parseDigits('8 (800) 555')
 * // Outputs '8800555'.
 * ```
 */

function parseDigits(string) {
  var result = ''; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.

  for (var _iterator = string.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var character = _ref;
    var digit = parseDigit(character);

    if (digit) {
      result += digit;
    }
  }

  return result;
}

/**
 * Parses phone number characters from a string.
 * Drops all punctuation leaving only digits and the leading `+` sign (if any).
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * // Outputs '8800555'.
 * parseIncompletePhoneNumber('8 (800) 555')
 * // Outputs '+7800555'.
 * parseIncompletePhoneNumber('+7 800 555')
 * ```
 */

function parseIncompletePhoneNumber(string) {
  var result = ''; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.

  for (var _iterator = string.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var character = _ref;
    result += parsePhoneNumberCharacter(character, result) || '';
  }

  return result;
}
/**
 * Parses next character while parsing phone number digits (including a `+`)
 * from text: discards everything except `+` and digits, and `+` is only allowed
 * at the start of a phone number.
 * For example, is used in `react-phone-number-input` where it uses
 * [`input-format`](https://gitlab.com/catamphetamine/input-format).
 * @param  {string} character - Yet another character from raw input string.
 * @param  {string?} prevParsedCharacters - Previous parsed characters.
 * @param  {object} meta - Optional custom use-case-specific metadata.
 * @return {string?} The parsed character.
 */

function parsePhoneNumberCharacter(character, prevParsedCharacters) {
  // Only allow a leading `+`.
  if (character === '+') {
    // If this `+` is not the first parsed character
    // then discard it.
    if (prevParsedCharacters) {
      return;
    }

    return '+';
  } // Allow digits.


  return parseDigit(character);
}

/**
 * Merges two arrays.
 * @param  {*} a
 * @param  {*} b
 * @return {*}
 */
function mergeArrays(a, b) {
  var merged = a.slice();

  for (var _iterator = b, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var element = _ref;

    if (a.indexOf(element) < 0) {
      merged.push(element);
    }
  }

  return merged.sort(function (a, b) {
    return a - b;
  }); // ES6 version, requires Set polyfill.
  // let merged = new Set(a)
  // for (const element of b) {
  // 	merged.add(i)
  // }
  // return Array.from(merged).sort((a, b) => a - b)
}

function checkNumberLength(nationalNumber, metadata) {
  return checkNumberLengthForType(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
// Should only be called for the "new" metadata which has "possible lengths".

function checkNumberLengthForType(nationalNumber, type, metadata) {
  var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
  // This is declared in the XML schema.
  // For size efficiency, where a sub-description (e.g. fixed-line)
  // has the same "<possiblePengths/>" as the "general description", this is missing,
  // so we fall back to the "general description". Where no numbers of the type
  // exist at all, there is one possible length (-1) which is guaranteed
  // not to match the length of any real phone number.

  var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
  // Metadata before version `1.0.18` didn't contain `possible_lengths`.

  if (!possible_lengths) {
    return 'IS_POSSIBLE';
  }

  if (type === 'FIXED_LINE_OR_MOBILE') {
    // No such country in metadata.

    /* istanbul ignore next */
    if (!metadata.type('FIXED_LINE')) {
      // The rare case has been encountered where no fixedLine data is available
      // (true for some non-geographic entities), so we just check mobile.
      return checkNumberLengthForType(nationalNumber, 'MOBILE', metadata);
    }

    var mobile_type = metadata.type('MOBILE');

    if (mobile_type) {
      // Merge the mobile data in if there was any. "Concat" creates a new
      // array, it doesn't edit possible_lengths in place, so we don't need a copy.
      // Note that when adding the possible lengths from mobile, we have
      // to again check they aren't empty since if they are this indicates
      // they are the same as the general desc and should be obtained from there.
      possible_lengths = mergeArrays(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
      // re-sort (duplicates are okay). Sorting isn't so expensive because
      // the lists are very small.
      // if (local_lengths) {
      // 	local_lengths = mergeArrays(local_lengths, mobile_type.possibleLengthsLocal())
      // } else {
      // 	local_lengths = mobile_type.possibleLengthsLocal()
      // }
    }
  } // If the type doesn't exist then return 'INVALID_LENGTH'.
  else if (type && !type_info) {
      return 'INVALID_LENGTH';
    }

  var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
  // // This is safe because there is never an overlap beween the possible lengths
  // // and the local-only lengths; this is checked at build time.
  // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
  // {
  // 	return 'IS_POSSIBLE_LOCAL_ONLY'
  // }

  var minimum_length = possible_lengths[0];

  if (minimum_length === actual_length) {
    return 'IS_POSSIBLE';
  }

  if (minimum_length > actual_length) {
    return 'TOO_SHORT';
  }

  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
    return 'TOO_LONG';
  } // We skip the first element since we've already checked it.


  return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}

function isPossiblePhoneNumber(input, options, metadata) {
  /* istanbul ignore if */
  if (options === undefined) {
    options = {};
  }

  metadata = new Metadata(metadata);

  if (options.v2) {
    if (!input.countryCallingCode) {
      throw new Error('Invalid phone number object passed');
    }

    metadata.selectNumberingPlan(input.countryCallingCode);
  } else {
    if (!input.phone) {
      return false;
    }

    if (input.country) {
      if (!metadata.hasCountry(input.country)) {
        throw new Error("Unknown country: ".concat(input.country));
      }

      metadata.country(input.country);
    } else {
      if (!input.countryCallingCode) {
        throw new Error('Invalid phone number object passed');
      }

      metadata.selectNumberingPlan(input.countryCallingCode);
    }
  }

  if (metadata.possibleLengths()) {
    return isPossibleNumber(input.phone || input.nationalNumber, metadata);
  } else {
    // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
    // were missing for "non-geographical" numbering plans.
    // Just assume the number is possible in such cases:
    // it's unlikely that anyone generated their custom metadata
    // in that short period of time (one day).
    // This code can be removed in some future major version update.
    if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) {
      // "Non-geographic entities" did't have `possibleLengths`
      // due to a bug in metadata generation process.
      return true;
    } else {
      throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
  }
}
function isPossibleNumber(nationalNumber, metadata) {
  //, isInternational) {
  switch (checkNumberLength(nationalNumber, metadata)) {
    case 'IS_POSSIBLE':
      return true;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational

    default:
      return false;
  }
}

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * @param  {string} text - Phone URI (RFC 3966).
 * @return {object} `{ ?number, ?ext }`.
 */

function parseRFC3966(text) {
  var number;
  var ext; // Replace "tel:" with "tel=" for parsing convenience.

  text = text.replace(/^tel:/, 'tel=');

  for (var _iterator = text.split(';'), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var part = _ref;

    var _part$split = part.split('='),
        _part$split2 = _slicedToArray(_part$split, 2),
        name = _part$split2[0],
        value = _part$split2[1];

    switch (name) {
      case 'tel':
        number = value;
        break;

      case 'ext':
        ext = value;
        break;

      case 'phone-context':
        // Only "country contexts" are supported.
        // "Domain contexts" are ignored.
        if (value[0] === '+') {
          number = value + number;
        }

        break;
    }
  } // If the phone number is not viable, then abort.


  if (!isViablePhoneNumber(number)) {
    return {};
  }

  var result = {
    number: number
  };

  if (ext) {
    result.ext = ext;
  }

  return result;
}
/**
 * @param  {object} - `{ ?number, ?extension }`.
 * @return {string} Phone URI (RFC 3966).
 */

function formatRFC3966(_ref2) {
  var number = _ref2.number,
      ext = _ref2.ext;

  if (!number) {
    return '';
  }

  if (number[0] !== '+') {
    throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
  }

  return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
}

/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */
function matchesEntirely(text, regular_expression) {
  // If assigning the `''` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  text = text || '';
  return new RegExp('^(?:' + regular_expression + ')$').test(text);
}

var NON_FIXED_LINE_PHONE_TYPES = ['MOBILE', 'PREMIUM_RATE', 'TOLL_FREE', 'SHARED_COST', 'VOIP', 'PERSONAL_NUMBER', 'PAGER', 'UAN', 'VOICEMAIL']; // Finds out national phone number type (fixed line, mobile, etc)

function getNumberType(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {}; // When `parse()` returned `{}`
  // meaning that the phone number is not a valid one.

  if (!input.country) {
    return;
  }

  metadata = new Metadata(metadata);
  metadata.selectNumberingPlan(input.country, input.countryCallingCode);
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
  // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
  // Is this national number even valid for this country

  if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern())) {
    return;
  } // Is it fixed line number


  if (isNumberTypeEqualTo(nationalNumber, 'FIXED_LINE', metadata)) {
    // Because duplicate regular expressions are removed
    // to reduce metadata size, if "mobile" pattern is ""
    // then it means it was removed due to being a duplicate of the fixed-line pattern.
    //
    if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') {
      return 'FIXED_LINE_OR_MOBILE';
    } // v1 metadata.
    // Legacy.
    // Deprecated.


    if (!metadata.type('MOBILE')) {
      return 'FIXED_LINE_OR_MOBILE';
    } // Check if the number happens to qualify as both fixed line and mobile.
    // (no such country in the minimal metadata set)

    /* istanbul ignore if */


    if (isNumberTypeEqualTo(nationalNumber, 'MOBILE', metadata)) {
      return 'FIXED_LINE_OR_MOBILE';
    }

    return 'FIXED_LINE';
  }

  for (var _i = 0, _NON_FIXED_LINE_PHONE = NON_FIXED_LINE_PHONE_TYPES; _i < _NON_FIXED_LINE_PHONE.length; _i++) {
    var type = _NON_FIXED_LINE_PHONE[_i];

    if (isNumberTypeEqualTo(nationalNumber, type, metadata)) {
      return type;
    }
  }
}
function isNumberTypeEqualTo(nationalNumber, type, metadata) {
  type = metadata.type(type);

  if (!type || !type.pattern()) {
    return false;
  } // Check if any possible number lengths are present;
  // if so, we use them to avoid checking
  // the validation pattern if they don't match.
  // If they are absent, this means they match
  // the general description, which we have
  // already checked before a specific number type.


  if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) {
    return false;
  }

  return matchesEntirely(nationalNumber, type.pattern());
}

/**
 * Checks if a given phone number is valid.
 *
 * If the `number` is a string, it will be parsed to an object,
 * but only if it contains only valid phone number characters (including punctuation).
 * If the `number` is an object, it is used as is.
 *
 * The optional `defaultCountry` argument is the default country.
 * I.e. it does not restrict to just that country,
 * e.g. in those cases where several countries share
 * the same phone numbering rules (NANPA, Britain, etc).
 * For example, even though the number `07624 369230`
 * belongs to the Isle of Man ("IM" country code)
 * calling `isValidNumber('07624369230', 'GB', metadata)`
 * still returns `true` because the country is not restricted to `GB`,
 * it's just that `GB` is the default one for the phone numbering rules.
 * For restricting the country see `isValidNumberForRegion()`
 * though restricting a country might not be a good idea.
 * https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
 *
 * Examples:
 *
 * ```js
 * isValidNumber('+78005553535', metadata)
 * isValidNumber('8005553535', 'RU', metadata)
 * isValidNumber('88005553535', 'RU', metadata)
 * isValidNumber({ phone: '8005553535', country: 'RU' }, metadata)
 * ```
 */

function isValidNumber(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new Metadata(metadata); // This is just to support `isValidNumber({})`
  // for cases when `parseNumber()` returns `{}`.

  if (!input.country) {
    return false;
  }

  metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
  // distinguishing different countries having the same `countryCallingCode`.

  if (metadata.hasTypes()) {
    return getNumberType(input, options, metadata.metadata) !== undefined;
  } // If there are no type regexps for this country in metadata then use
  // `nationalNumberPattern` as a "better than nothing" replacement.


  var national_number = options.v2 ? input.nationalNumber : input.phone;
  return matchesEntirely(national_number, metadata.nationalNumberPattern());
}

//
// E.g. "(999) 111-22-33" -> "999 111 22 33"
//
// For some reason Google's metadata contains `<intlFormat/>`s with brackets and dashes.
// Meanwhile, there's no single opinion about using punctuation in international phone numbers.
//
// For example, Google's `<intlFormat/>` for USA is `+1 213-373-4253`.
// And here's a quote from WikiPedia's "North American Numbering Plan" page:
// https://en.wikipedia.org/wiki/North_American_Numbering_Plan
//
// "The country calling code for all countries participating in the NANP is 1.
// In international format, an NANP number should be listed as +1 301 555 01 00,
// where 301 is an area code (Maryland)."
//
// I personally prefer the international format without any punctuation.
// For example, brackets are remnants of the old age, meaning that the
// phone number part in brackets (so called "area code") can be omitted
// if dialing within the same "area".
// And hyphens were clearly introduced for splitting local numbers into memorizable groups.
// For example, remembering "5553535" is difficult but "555-35-35" is much simpler.
// Imagine a man taking a bus from home to work and seeing an ad with a phone number.
// He has a couple of seconds to memorize that number until it passes by.
// If it were spaces instead of hyphens the man wouldn't necessarily get it,
// but with hyphens instead of spaces the grouping is more explicit.
// I personally think that hyphens introduce visual clutter,
// so I prefer replacing them with spaces in international numbers.
// In the modern age all output is done on displays where spaces are clearly distinguishable
// so hyphens can be safely replaced with spaces without losing any legibility.
//

function applyInternationalSeparatorStyle(formattedNumber) {
  return formattedNumber.replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), 'g'), ' ').trim();
}

// first group is not used in the national pattern (e.g. Argentina) so the $1
// group does not match correctly. Therefore, we use `\d`, so that the first
// group actually used in the pattern will be matched.

var FIRST_GROUP_PATTERN = /(\$\d)/;
function formatNationalNumberUsingFormat(number, format, _ref) {
  var useInternationalFormat = _ref.useInternationalFormat,
      withNationalPrefix = _ref.withNationalPrefix,
      carrierCode = _ref.carrierCode,
      metadata = _ref.metadata;
  var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // This library doesn't use `domestic_carrier_code_formatting_rule`,
  // because that one is only used when formatting phone numbers
  // for dialing from a mobile phone, and this is not a dialing library.
  // carrierCode && format.domesticCarrierCodeFormattingRule()
  // 	// First, replace the $CC in the formatting rule with the desired carrier code.
  // 	// Then, replace the $FG in the formatting rule with the first group
  // 	// and the carrier code combined in the appropriate way.
  // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
  // 	: (
  // 		withNationalPrefix && format.nationalPrefixFormattingRule()
  // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
  // 			: format.format()
  // 	)
  withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()) : format.format());

  if (useInternationalFormat) {
    return applyInternationalSeparatorStyle(formattedNumber);
  }

  return formattedNumber;
}

/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */

var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
// a preferred IDD prefix is returned.

function getIddPrefix(country, callingCode, metadata) {
  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);

  if (countryMetadata.defaultIDDPrefix()) {
    return countryMetadata.defaultIDDPrefix();
  }

  if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) {
    return countryMetadata.IDDPrefix();
  }
}

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var DEFAULT_OPTIONS = {
  formatExtension: function formatExtension(formattedNumber, extension, metadata) {
    return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
  } // Formats a phone number
  //
  // Example use cases:
  //
  // ```js
  // formatNumber('8005553535', 'RU', 'INTERNATIONAL')
  // formatNumber('8005553535', 'RU', 'INTERNATIONAL', metadata)
  // formatNumber({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL')
  // formatNumber({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL', metadata)
  // formatNumber('+78005553535', 'NATIONAL')
  // formatNumber('+78005553535', 'NATIONAL', metadata)
  // ```
  //

};
function formatNumber(input, format, options, metadata) {
  // Apply default options.
  if (options) {
    options = _objectSpread({}, DEFAULT_OPTIONS, options);
  } else {
    options = DEFAULT_OPTIONS;
  }

  metadata = new Metadata(metadata);

  if (input.country && input.country !== '001') {
    // Validate `input.country`.
    if (!metadata.hasCountry(input.country)) {
      throw new Error("Unknown country: ".concat(input.country));
    }

    metadata.country(input.country);
  } else if (input.countryCallingCode) {
    metadata.selectNumberingPlan(input.countryCallingCode);
  } else return input.phone || '';

  var countryCallingCode = metadata.countryCallingCode();
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
  // but Babel has a bug and it says "duplicate variable declaration".

  var number;

  switch (format) {
    case 'NATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return '';
      }

      number = formatNationalNumber(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'INTERNATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return "+".concat(countryCallingCode);
      }

      number = formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata, options);
      number = "+".concat(countryCallingCode, " ").concat(number);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'E.164':
      // `E.164` doesn't define "phone number extensions".
      return "+".concat(countryCallingCode).concat(nationalNumber);

    case 'RFC3966':
      return formatRFC3966({
        number: "+".concat(countryCallingCode).concat(nationalNumber),
        ext: input.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?

    case 'IDD':
      if (!options.fromCountry) {
        return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
      }

      var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
      return addExtension(formattedNumber, input.ext, metadata, options.formatExtension);

    default:
      throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
  }
}

function formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
  var format = chooseFormatForNumber(metadata.formats(), number);

  if (!format) {
    return number;
  }

  return formatNationalNumberUsingFormat(number, format, {
    useInternationalFormat: formatAs === 'INTERNATIONAL',
    withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
    carrierCode: carrierCode,
    metadata: metadata
  });
}

function chooseFormatForNumber(availableFormats, nationalNnumber) {
  for (var _iterator = availableFormats, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var format = _ref;

    // Validate leading digits
    if (format.leadingDigitsPatterns().length > 0) {
      // The last leading_digits_pattern is used here, as it is the most detailed
      var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format

      if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) {
        continue;
      }
    } // Check that the national number matches the phone number format regular expression


    if (matchesEntirely(nationalNnumber, format.pattern())) {
      return format;
    }
  }
}

function addExtension(formattedNumber, ext, metadata, formatExtension) {
  return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}

function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
  var fromCountryCallingCode = getCountryCallingCode(fromCountry, metadata.metadata); // When calling within the same country calling code.

  if (fromCountryCallingCode === countryCallingCode) {
    var formattedNumber = formatNationalNumber(nationalNumber, carrierCode, 'NATIONAL', metadata); // For NANPA regions, return the national format for these regions
    // but prefix it with the country calling code.

    if (countryCallingCode === '1') {
      return countryCallingCode + ' ' + formattedNumber;
    } // If regions share a country calling code, the country calling code need
    // not be dialled. This also applies when dialling within a region, so this
    // if clause covers both these cases. Technically this is the case for
    // dialling from La Reunion to other overseas departments of France (French
    // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
    // this edge case for now and for those cases return the version including
    // country calling code. Details here:
    // http://www.petitfute.com/voyage/225-info-pratiques-reunion
    //


    return formattedNumber;
  }

  var iddPrefix = getIddPrefix(fromCountry, undefined, metadata.metadata);

  if (iddPrefix) {
    return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata));
  }
}

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } return target; }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$1(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$1(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$1(Constructor.prototype, protoProps); if (staticProps) _defineProperties$1(Constructor, staticProps); return Constructor; }

var PhoneNumber =
/*#__PURE__*/
function () {
  function PhoneNumber(countryCallingCode, nationalNumber, metadata) {
    _classCallCheck$2(this, PhoneNumber);

    if (!countryCallingCode) {
      throw new TypeError('`country` or `countryCallingCode` not passed');
    }

    if (!nationalNumber) {
      throw new TypeError('`nationalNumber` not passed');
    }

    if (!metadata) {
      throw new TypeError('`metadata` not passed');
    }

    var _metadata = new Metadata(metadata); // If country code is passed then derive `countryCallingCode` from it.
    // Also store the country code as `.country`.


    if (isCountryCode(countryCallingCode)) {
      this.country = countryCallingCode;

      _metadata.country(countryCallingCode);

      countryCallingCode = _metadata.countryCallingCode();
    }

    this.countryCallingCode = countryCallingCode;
    this.nationalNumber = nationalNumber;
    this.number = '+' + this.countryCallingCode + this.nationalNumber;
    this.metadata = metadata;
  }

  _createClass$1(PhoneNumber, [{
    key: "isPossible",
    value: function isPossible() {
      return isPossiblePhoneNumber(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return isValidNumber(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "isNonGeographic",
    value: function isNonGeographic() {
      var metadata = new Metadata(this.metadata);
      return metadata.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function isEqual(phoneNumber) {
      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
    } // // Is just an alias for `this.isValid() && this.country === country`.
    // // https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
    // isValidForRegion(country) {
    // 	return isValidNumberForRegion(this, country, { v2: true }, this.metadata)
    // }

  }, {
    key: "getType",
    value: function getType() {
      return getNumberType(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "format",
    value: function format(_format, options) {
      return formatNumber(this, _format, options ? _objectSpread$1({}, options, {
        v2: true
      }) : {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "formatNational",
    value: function formatNational(options) {
      return this.format('NATIONAL', options);
    }
  }, {
    key: "formatInternational",
    value: function formatInternational(options) {
      return this.format('INTERNATIONAL', options);
    }
  }, {
    key: "getURI",
    value: function getURI(options) {
      return this.format('RFC3966', options);
    }
  }]);

  return PhoneNumber;
}();

var isCountryCode = function isCountryCode(value) {
  return /^[A-Z]{2}$/.test(value);
};

var CAPTURING_DIGIT_PATTERN = new RegExp('([' + VALID_DIGITS + '])');
function stripIddPrefix(number, country, callingCode, metadata) {
  if (!country) {
    return;
  } // Check if the number is IDD-prefixed.


  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);
  var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());

  if (number.search(IDDPrefixPattern) !== 0) {
    return;
  } // Strip IDD prefix.


  number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
  // then those digits are a country calling code.
  // Since no country code starts with a `0`,
  // the code below validates that the next digit (if present) is not `0`.

  var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);

  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
    if (matchedGroups[1] === '0') {
      return;
    }
  }

  return number;
}

/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`.
 */
function extractNationalNumberFromPossiblyIncompleteNumber(number, metadata) {
  if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
    // See METADATA.md for the description of
    // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
    // Attempt to parse the first digits as a national prefix.
    var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
    var prefixMatch = prefixPattern.exec(number);

    if (prefixMatch) {
      var nationalNumber;
      var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
      // If a `national_prefix_for_parsing` has any "capturing groups"
      // then it means that the national (significant) number is equal to
      // those "capturing groups" transformed via `national_prefix_transform_rule`,
      // and nothing could be said about the actual national prefix:
      // what is it and was it even there.
      // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
      // then everything it matches is a national prefix.
      // To determine whether `national_prefix_for_parsing` matched any
      // "capturing groups", the value of the result of calling `.exec()`
      // is looked at, and if it has non-undefined values where there're
      // "capturing groups" in the regular expression, then it means
      // that "capturing groups" have been matched.
      // It's not possible to tell whether there'll be any "capturing gropus"
      // before the matching process, because a `national_prefix_for_parsing`
      // could exhibit both behaviors.

      var capturedGroupsCount = prefixMatch.length - 1;
      var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];

      if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
        nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
        // then carrier code is the second one.

        if (capturedGroupsCount > 1) {
          carrierCode = prefixMatch[1];
        }
      } // If there're no "capturing groups",
      // or if there're "capturing groups" but no
      // `national_prefix_transform_rule`,
      // then just strip the national prefix from the number,
      // and possibly a carrier code.
      // Seems like there could be more.
      else {
          // `prefixBeforeNationalNumber` is the whole substring matched by
          // the `national_prefix_for_parsing` regular expression.
          // There seem to be no guarantees that it's just a national prefix.
          // For example, if there's a carrier code, it's gonna be a
          // part of `prefixBeforeNationalNumber` too.
          var prefixBeforeNationalNumber = prefixMatch[0];
          nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
          // then carrier code is the first one.

          if (hasCapturedGroups) {
            carrierCode = prefixMatch[1];
          }
        } // Tries to guess whether a national prefix was present in the input.
      // This is not something copy-pasted from Google's library:
      // they don't seem to have an equivalent for that.
      // So this isn't an "officially approved" way of doing something like that.
      // But since there seems no other existing method, this library uses it.


      var nationalPrefix;

      if (hasCapturedGroups) {
        var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
        var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
        // `prefixMatch[0]` is `01115`, and `$1` is `11`,
        // and the rest of the phone number is `23456789`.
        // The national number is transformed via `9$1` to `91123456789`.
        // National prefix `0` is detected being present at the start.
        // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {

        if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) {
          nationalPrefix = metadata.numberingPlan.nationalPrefix();
        }
      } else {
        nationalPrefix = prefixMatch[0];
      }

      return {
        nationalNumber: nationalNumber,
        nationalPrefix: nationalPrefix,
        carrierCode: carrierCode
      };
    }
  }

  return {
    nationalNumber: number
  };
}

/**
 * Strips national prefix and carrier code from a complete phone number.
 * The difference from the non-"FromCompleteNumber" function is that
 * it won't extract national prefix if the resultant number is too short
 * to be a complete number for the selected phone numbering plan.
 * @param  {string} number — Complete phone number digits.
 * @param  {Metadata} metadata — Metadata with a phone numbering plan selected.
 * @return {object} `{ nationalNumber: string, carrierCode: string? }`.
 */

function extractNationalNumber(number, metadata) {
  // Parsing national prefixes and carrier codes
  // is only required for local phone numbers
  // but some people don't understand that
  // and sometimes write international phone numbers
  // with national prefixes (or maybe even carrier codes).
  // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
  // Google's original library forgives such mistakes
  // and so does this library, because it has been requested:
  // https://github.com/catamphetamine/libphonenumber-js/issues/127
  var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(number, metadata),
      nationalNumber = _extractNationalNumbe.nationalNumber,
      carrierCode = _extractNationalNumbe.carrierCode;

  if (!shouldExtractNationalPrefix(number, nationalNumber, metadata)) {
    // Don't strip the national prefix.
    return {
      nationalNumber: number
    };
  } // If a national prefix has been extracted, check to see
  // if the resultant number isn't too short.
  // Same code in Google's `libphonenumber`:
  // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3291-L3302
  // For some reason, they do this check right after the `national_number_pattern` check
  // this library does in `shouldExtractNationalPrefix()` function.
  // Why is there a second "resultant" number validity check?
  // They don't provide an explanation.
  // This library just copies the behavior.


  if (number.length !== nationalNumber.length + (carrierCode ? carrierCode.length : 0)) {
    // If not using legacy generated metadata (before version `1.0.18`)
    // then it has "possible lengths", so use those to validate the number length.
    if (metadata.possibleLengths()) {
      // "We require that the NSN remaining after stripping the national prefix and
      // carrier code be long enough to be a possible length for the region.
      // Otherwise, we don't do the stripping, since the original number could be
      // a valid short number."
      // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
      switch (checkNumberLength(nationalNumber, metadata)) {
        case 'TOO_SHORT':
        case 'INVALID_LENGTH':
          // case 'IS_POSSIBLE_LOCAL_ONLY':
          // Don't strip the national prefix.
          return {
            nationalNumber: number
          };
      }
    }
  }

  return {
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.

function shouldExtractNationalPrefix(number, nationalSignificantNumber, metadata) {
  // The equivalent in Google's code is:
  // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
  if (matchesEntirely(number, metadata.nationalNumberPattern()) && !matchesEntirely(nationalSignificantNumber, metadata.nationalNumberPattern())) {
    return false;
  } // Just "possible" number check would be more relaxed, so it's not used.
  // if (isPossibleNumber(number, metadata) &&
  // 	!isPossibleNumber(numberWithNationalPrefixExtracted, metadata)) {
  // 	return false
  // }


  return true;
}

/**
 * Sometimes some people incorrectly input international phone numbers
 * without the leading `+`. This function corrects such input.
 * @param  {string} number — Phone number digits.
 * @param  {string?} country
 * @param  {string?} callingCode
 * @param  {object} metadata
 * @return {object} `{ countryCallingCode: string?, number: string }`.
 */

function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata) {
  var countryCallingCode = country ? getCountryCallingCode(country, metadata) : callingCode;

  if (number.indexOf(countryCallingCode) === 0) {
    metadata = new Metadata(metadata);
    metadata.selectNumberingPlan(country, callingCode);
    var possibleShorterNumber = number.slice(countryCallingCode.length);

    var _extractNationalNumbe = extractNationalNumber(possibleShorterNumber, metadata),
        possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;

    var _extractNationalNumbe2 = extractNationalNumber(number, metadata),
        nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
    // or if it was too long before, we consider the number
    // with the country calling code stripped to be a better result
    // and keep that instead.
    // For example, in Germany (+49), `49` is a valid area code,
    // so if a number starts with `49`, it could be both a valid
    // national German number or an international number without
    // a leading `+`.


    if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) && matchesEntirely(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || checkNumberLength(nationalNumber, metadata) === 'TOO_LONG') {
      return {
        countryCallingCode: countryCallingCode,
        number: possibleShorterNumber
      };
    }
  }

  return {
    number: number
  };
}

/**
 * Converts a phone number digits (possibly with a `+`)
 * into a calling code and the rest phone number digits.
 * The "rest phone number digits" could include
 * a national prefix, carrier code, and national
 * (significant) number.
 * @param  {string} number — Phone number digits (possibly with a `+`).
 * @param  {string} [country] — Default country.
 * @param  {string} [callingCode] — Default calling code (some phone numbering plans are non-geographic).
 * @param  {object} metadata
 * @return {object} `{ countryCallingCode: string?, number: string }`
 * @example
 * // Returns `{ countryCallingCode: "1", number: "2133734253" }`.
 * extractCountryCallingCode('2133734253', 'US', null, metadata)
 * extractCountryCallingCode('2133734253', null, '1', metadata)
 * extractCountryCallingCode('+12133734253', null, null, metadata)
 * extractCountryCallingCode('+12133734253', 'RU', null, metadata)
 */

function extractCountryCallingCode(number, country, callingCode, metadata) {
  if (!number) {
    return {};
  } // If this is not an international phone number,
  // then either extract an "IDD" prefix, or extract a
  // country calling code from a number by autocorrecting it
  // by prepending a leading `+` in cases when it starts
  // with the country calling code.
  // https://wikitravel.org/en/International_dialling_prefix
  // https://github.com/catamphetamine/libphonenumber-js/issues/376


  if (number[0] !== '+') {
    // Convert an "out-of-country" dialing phone number
    // to a proper international phone number.
    var numberWithoutIDD = stripIddPrefix(number, country, callingCode, metadata); // If an IDD prefix was stripped then
    // convert the number to international one
    // for subsequent parsing.

    if (numberWithoutIDD && numberWithoutIDD !== number) {
      number = '+' + numberWithoutIDD;
    } else {
      // Check to see if the number starts with the country calling code
      // for the default country. If so, we remove the country calling code,
      // and do some checks on the validity of the number before and after.
      // https://github.com/catamphetamine/libphonenumber-js/issues/376
      if (country || callingCode) {
        var _extractCountryCallin = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata),
            countryCallingCode = _extractCountryCallin.countryCallingCode,
            shorterNumber = _extractCountryCallin.number;

        if (countryCallingCode) {
          return {
            countryCallingCode: countryCallingCode,
            number: shorterNumber
          };
        }
      }

      return {
        number: number
      };
    }
  } // Fast abortion: country codes do not begin with a '0'


  if (number[1] === '0') {
    return {};
  }

  metadata = new Metadata(metadata); // The thing with country phone codes
  // is that they are orthogonal to each other
  // i.e. there's no such country phone code A
  // for which country phone code B exists
  // where B starts with A.
  // Therefore, while scanning digits,
  // if a valid country code is found,
  // that means that it is the country code.
  //

  var i = 2;

  while (i - 1 <= MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
    var _countryCallingCode = number.slice(1, i);

    if (metadata.hasCallingCode(_countryCallingCode)) {
      metadata.selectNumberingPlan(_countryCallingCode);
      return {
        countryCallingCode: _countryCallingCode,
        number: number.slice(i)
      };
    }

    i++;
  }

  return {};
}

function getCountryByCallingCode(callingCode, nationalPhoneNumber, metadata) {


  var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);

  if (!possibleCountries) {
    return;
  } // If there's just one country corresponding to the country code,
  // then just return it, without further phone number digits validation.


  if (possibleCountries.length === 1) {
    return possibleCountries[0];
  }

  return selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata.metadata);
}

function selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata) {
  // Re-create `metadata` because it will be selecting a `country`.
  metadata = new Metadata(metadata);

  for (var _iterator = possibleCountries, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var country = _ref;
    metadata.country(country); // Leading digits check would be the simplest one

    if (metadata.leadingDigits()) {
      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) {
        return country;
      }
    } // Else perform full validation with all of those
    // fixed-line/mobile/etc regular expressions.
    else if (getNumberType({
        phone: nationalPhoneNumber,
        country: country
      }, undefined, metadata.metadata)) {
        return country;
      }
  }
}

// This is a port of Google Android `libphonenumber`'s
// This prevents malicious input from consuming CPU.

var MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.

var PHONE_NUMBER_START_PATTERN = new RegExp('[' + PLUS_CHARS + VALID_DIGITS + ']'); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".

var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + VALID_DIGITS + '#' + ']+$');
//
// ```js
// parse('8 (800) 555-35-35', 'RU')
// parse('8 (800) 555-35-35', 'RU', metadata)
// parse('8 (800) 555-35-35', { country: { default: 'RU' } })
// parse('8 (800) 555-35-35', { country: { default: 'RU' } }, metadata)
// parse('+7 800 555 35 35')
// parse('+7 800 555 35 35', metadata)
// ```
//

function parse$1(text, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new Metadata(metadata); // Validate `defaultCountry`.

  if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
    if (options.v2) {
      throw new ParseError('INVALID_COUNTRY');
    }

    throw new Error("Unknown country: ".concat(options.defaultCountry));
  } // Parse the phone number.


  var _parseInput = parseInput(text, options.v2, options.extract),
      formattedPhoneNumber = _parseInput.number,
      ext = _parseInput.ext,
      error = _parseInput.error; // If the phone number is not viable then return nothing.


  if (!formattedPhoneNumber) {
    if (options.v2) {
      if (error === 'TOO_SHORT') {
        throw new ParseError('TOO_SHORT');
      }

      throw new ParseError('NOT_A_NUMBER');
    }

    return {};
  }

  var _parsePhoneNumber = parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata),
      country = _parsePhoneNumber.country,
      nationalNumber = _parsePhoneNumber.nationalNumber,
      countryCallingCode = _parsePhoneNumber.countryCallingCode,
      carrierCode = _parsePhoneNumber.carrierCode;

  if (!metadata.hasSelectedNumberingPlan()) {
    if (options.v2) {
      throw new ParseError('INVALID_COUNTRY');
    }

    return {};
  } // Validate national (significant) number length.


  if (!nationalNumber || nationalNumber.length < MIN_LENGTH_FOR_NSN) {
    // Won't throw here because the regexp already demands length > 1.

    /* istanbul ignore if */
    if (options.v2) {
      throw new ParseError('TOO_SHORT');
    } // Google's demo just throws an error in this case.


    return {};
  } // Validate national (significant) number length.
  //
  // A sidenote:
  //
  // They say that sometimes national (significant) numbers
  // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
  // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
  // Such numbers will just be discarded.
  //


  if (nationalNumber.length > MAX_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError('TOO_LONG');
    } // Google's demo just throws an error in this case.


    return {};
  }

  if (options.v2) {
    var phoneNumber = new PhoneNumber(countryCallingCode, nationalNumber, metadata.metadata);

    if (country) {
      phoneNumber.country = country;
    }

    if (carrierCode) {
      phoneNumber.carrierCode = carrierCode;
    }

    if (ext) {
      phoneNumber.ext = ext;
    }

    return phoneNumber;
  } // Check if national phone number pattern matches the number.
  // National number pattern is different for each country,
  // even for those ones which are part of the "NANPA" group.


  var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) : false;

  if (!options.extended) {
    return valid ? result(country, nationalNumber, ext) : {};
  } // isInternational: countryCallingCode !== undefined


  return {
    country: country,
    countryCallingCode: countryCallingCode,
    carrierCode: carrierCode,
    valid: valid,
    possible: valid ? true : options.extended === true && metadata.possibleLengths() && isPossibleNumber(nationalNumber, metadata) ? true : false,
    phone: nationalNumber,
    ext: ext
  };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */

function extractFormattedPhoneNumber(text, extract, throwOnError) {
  if (!text) {
    return;
  }

  if (text.length > MAX_INPUT_STRING_LENGTH) {
    if (throwOnError) {
      throw new ParseError('TOO_LONG');
    }

    return;
  }

  if (extract === false) {
    return text;
  } // Attempt to extract a possible number from the string passed in


  var startsAt = text.search(PHONE_NUMBER_START_PATTERN);

  if (startsAt < 0) {
    return;
  }

  return text // Trim everything to the left of the phone number
  .slice(startsAt) // Remove trailing non-numerical characters
  .replace(AFTER_PHONE_NUMBER_END_PATTERN, '');
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */


function parseInput(text, v2, extract) {
  // Parse RFC 3966 phone number URI.
  if (text && text.indexOf('tel:') === 0) {
    return parseRFC3966(text);
  }

  var number = extractFormattedPhoneNumber(text, extract, v2); // If the phone number is not viable, then abort.

  if (!number) {
    return {};
  }

  if (!isViablePhoneNumber(number)) {
    if (isViablePhoneNumberStart(number)) {
      return {
        error: 'TOO_SHORT'
      };
    }

    return {};
  } // Attempt to parse extension first, since it doesn't require region-specific
  // data and we want to have the non-normalised number here.


  var withExtensionStripped = extractExtension(number);

  if (withExtensionStripped.ext) {
    return withExtensionStripped;
  }

  return {
    number: number
  };
}
/**
 * Creates `parse()` result object.
 */


function result(country, nationalNumber, ext) {
  var result = {
    country: country,
    phone: nationalNumber
  };

  if (ext) {
    result.ext = ext;
  }

  return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */


function parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
  // Extract calling code from phone number.
  var _extractCountryCallin = extractCountryCallingCode(parseIncompletePhoneNumber(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata),
      countryCallingCode = _extractCountryCallin.countryCallingCode,
      number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.


  var country;

  if (countryCallingCode) {
    metadata.selectNumberingPlan(countryCallingCode);
  } // If `formattedPhoneNumber` is in "national" format
  // then `number` is defined and `countryCallingCode` isn't.
  else if (number && (defaultCountry || defaultCallingCode)) {
      metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);

      if (defaultCountry) {
        country = defaultCountry;
      }

      countryCallingCode = defaultCallingCode || getCountryCallingCode(defaultCountry, metadata.metadata);
    } else return {};

  if (!number) {
    return {
      countryCallingCode: countryCallingCode
    };
  }

  var _extractNationalNumbe = extractNationalNumber(parseIncompletePhoneNumber(number), metadata),
      nationalNumber = _extractNationalNumbe.nationalNumber,
      carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
  // corresponding to the same country phone code
  // (e.g. NANPA countries all having `1` country phone code).
  // Therefore, to reliably determine the exact country,
  // national (significant) number should have been parsed first.
  //
  // When `metadata.json` is generated, all "ambiguous" country phone codes
  // get their countries populated with the full set of
  // "phone number type" regular expressions.
  //


  var exactCountry = getCountryByCallingCode(countryCallingCode, nationalNumber, metadata);

  if (exactCountry) {
    country = exactCountry;
    /* istanbul ignore if */

    if (exactCountry === '001') ; else {
      metadata.country(country);
    }
  }

  return {
    country: country,
    countryCallingCode: countryCallingCode,
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
}

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$2(target, key, source[key]); }); } return target; }

function _defineProperty$2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function parsePhoneNumber$1(text, options, metadata) {
  return parse$1(text, _objectSpread$2({}, options, {
    v2: true
  }), metadata);
}

function _typeof$1(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$1 = function _typeof(obj) { return typeof obj; }; } else { _typeof$1 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$1(obj); }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$3(target, key, source[key]); }); } return target; }

function _defineProperty$3(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray$1(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _nonIterableRest$1(); }

function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit$1(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }
function normalizeArguments(args) {
  var _Array$prototype$slic = Array.prototype.slice.call(args),
      _Array$prototype$slic2 = _slicedToArray$1(_Array$prototype$slic, 4),
      arg_1 = _Array$prototype$slic2[0],
      arg_2 = _Array$prototype$slic2[1],
      arg_3 = _Array$prototype$slic2[2],
      arg_4 = _Array$prototype$slic2[3];

  var text;
  var options;
  var metadata; // If the phone number is passed as a string.
  // `parsePhoneNumber('88005553535', ...)`.

  if (typeof arg_1 === 'string') {
    text = arg_1;
  } else throw new TypeError('A text for parsing must be a string.'); // If "default country" argument is being passed then move it to `options`.
  // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.


  if (!arg_2 || typeof arg_2 === 'string') {
    if (arg_4) {
      options = arg_3;
      metadata = arg_4;
    } else {
      options = undefined;
      metadata = arg_3;
    }

    if (arg_2) {
      options = _objectSpread$3({
        defaultCountry: arg_2
      }, options);
    }
  } // `defaultCountry` is not passed.
  // Example: `parsePhoneNumber('+78005553535', [options], metadata)`.
  else if (isObject(arg_2)) {
      if (arg_3) {
        options = arg_2;
        metadata = arg_3;
      } else {
        metadata = arg_2;
      }
    } else throw new Error("Invalid second argument: ".concat(arg_2));

  return {
    text: text,
    options: options,
    metadata: metadata
  };
} // Otherwise istanbul would show this as "branch not covered".

/* istanbul ignore next */

var isObject = function isObject(_) {
  return _typeof$1(_) === 'object';
};

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$4(target, key, source[key]); }); } return target; }

function _defineProperty$4(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function parsePhoneNumberFromString(text, options, metadata) {
  // Validate `defaultCountry`.
  if (options && options.defaultCountry && !isSupportedCountry(options.defaultCountry, metadata)) {
    options = _objectSpread$4({}, options, {
      defaultCountry: undefined
    });
  } // Parse phone number.


  try {
    return parsePhoneNumber$1(text, options, metadata);
  } catch (error) {
    /* istanbul ignore else */
    if (error instanceof ParseError) ; else {
      throw error;
    }
  }
}

function parsePhoneNumberFromString$1() {
  var _normalizeArguments = normalizeArguments(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  return parsePhoneNumberFromString(text, options, metadata);
}

function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$2(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$2(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$2(Constructor.prototype, protoProps); if (staticProps) _defineProperties$2(Constructor, staticProps); return Constructor; }

function _defineProperty$5(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AsYouTypeState =
/*#__PURE__*/
function () {
  function AsYouTypeState(_ref) {
    var _this = this;

    var onCountryChange = _ref.onCountryChange,
        onCallingCodeChange = _ref.onCallingCodeChange;

    _classCallCheck$3(this, AsYouTypeState);

    _defineProperty$5(this, "update", function (properties) {
      for (var _i = 0, _Object$keys = Object.keys(properties); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        _this[key] = properties[key];
      }
    });

    this.onCountryChange = onCountryChange;
    this.onCallingCodeChange = onCallingCodeChange;
  }

  _createClass$2(AsYouTypeState, [{
    key: "reset",
    value: function reset(defaultCountry, defaultCallingCode) {
      this.international = false;
      this.IDDPrefix = undefined;
      this.missingPlus = undefined;
      this.callingCode = undefined;
      this.digits = '';
      this.resetNationalSignificantNumber();
      this.initCountryAndCallingCode(defaultCountry, defaultCallingCode);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function resetNationalSignificantNumber() {
      this.nationalSignificantNumber = this.getNationalDigits();
      this.nationalSignificantNumberMatchesInput = true;
      this.nationalPrefix = undefined;
      this.carrierCode = undefined;
      this.complexPrefixBeforeNationalSignificantNumber = undefined;
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function initCountryAndCallingCode(country, callingCode) {
      this.setCountry(country);
      this.setCallingCode(callingCode);
    }
  }, {
    key: "setCountry",
    value: function setCountry(country) {
      this.country = country;
      this.onCountryChange(country);
    }
  }, {
    key: "setCallingCode",
    value: function setCallingCode(callingCode) {
      this.callingCode = callingCode;
      return this.onCallingCodeChange(this.country, callingCode);
    }
  }, {
    key: "startInternationalNumber",
    value: function startInternationalNumber() {
      // Prepend the `+` to parsed input.
      this.international = true; // If a default country was set then reset it
      // because an explicitly international phone
      // number is being entered.

      this.initCountryAndCallingCode();
    }
  }, {
    key: "appendDigits",
    value: function appendDigits(nextDigits) {
      this.digits += nextDigits;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function appendNationalSignificantNumberDigits(nextDigits) {
      this.nationalSignificantNumber += nextDigits;
    }
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */

  }, {
    key: "getNationalDigits",
    value: function getNationalDigits() {
      if (this.international) {
        return this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0));
      }

      return this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function getDigitsWithoutInternationalPrefix() {
      if (this.international) {
        if (this.IDDPrefix) {
          return this.digits.slice(this.IDDPrefix.length);
        }
      }

      return this.digits;
    }
  }]);

  return AsYouTypeState;
}();

// Should be the same as `DIGIT_PLACEHOLDER` in `libphonenumber-metadata-generator`.
var DIGIT_PLACEHOLDER = 'x'; // '\u2008' (punctuation space)

var DIGIT_PLACEHOLDER_MATCHER = new RegExp(DIGIT_PLACEHOLDER); // Counts all occurences of a symbol in a string.
// http://stackoverflow.com/questions/202605/repeat-string-javascript

function repeat(string, times) {
  if (times < 1) {
    return '';
  }

  var result = '';

  while (times > 1) {
    if (times & 1) {
      result += string;
    }

    times >>= 1;
    string += string;
  }

  return result + string;
}
function cutAndStripNonPairedParens(string, cutBeforeIndex) {
  if (string[cutBeforeIndex] === ')') {
    cutBeforeIndex++;
  }

  return stripNonPairedParens(string.slice(0, cutBeforeIndex));
}
function stripNonPairedParens(string) {
  var dangling_braces = [];
  var i = 0;

  while (i < string.length) {
    if (string[i] === '(') {
      dangling_braces.push(i);
    } else if (string[i] === ')') {
      dangling_braces.pop();
    }

    i++;
  }

  var start = 0;
  var cleared_string = '';
  dangling_braces.push(string.length);

  for (var _i2 = 0, _dangling_braces = dangling_braces; _i2 < _dangling_braces.length; _i2++) {
    var index = _dangling_braces[_i2];
    cleared_string += string.slice(start, index);
    start = index + 1;
  }

  return cleared_string;
}
function populateTemplateWithDigits(template, position, digits) {
  // Using `.split('')` to iterate through a string here
  // to avoid requiring `Symbol.iterator` polyfill.
  // `.split('')` is generally not safe for Unicode,
  // but in this particular case for `digits` it is safe.
  // for (const digit of digits)
  for (var _iterator2 = digits.split(''), _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
    var _ref2;

    if (_isArray2) {
      if (_i3 >= _iterator2.length) break;
      _ref2 = _iterator2[_i3++];
    } else {
      _i3 = _iterator2.next();
      if (_i3.done) break;
      _ref2 = _i3.value;
    }

    var digit = _ref2;

    // If there is room for more digits in current `template`,
    // then set the next digit in the `template`,
    // and return the formatted digits so far.
    // If more digits are entered than the current format could handle.
    if (template.slice(position + 1).search(DIGIT_PLACEHOLDER_MATCHER) < 0) {
      return;
    }

    position = template.search(DIGIT_PLACEHOLDER_MATCHER);
    template = template.replace(DIGIT_PLACEHOLDER_MATCHER, digit);
  }

  return [template, position];
}

function formatCompleteNumber(state, format, _ref) {
  var metadata = _ref.metadata,
      shouldTryNationalPrefixFormattingRule = _ref.shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix = _ref.getSeparatorAfterNationalPrefix;
  var matcher = new RegExp("^(?:".concat(format.pattern(), ")$"));

  if (matcher.test(state.nationalSignificantNumber)) {
    return formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, {
      metadata: metadata,
      shouldTryNationalPrefixFormattingRule: shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix
    });
  }
}
function canFormatCompleteNumber(nationalSignificantNumber, metadata) {
  return checkNumberLength(nationalSignificantNumber, metadata) === 'IS_POSSIBLE';
}

function formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, _ref2) {
  var metadata = _ref2.metadata,
      shouldTryNationalPrefixFormattingRule = _ref2.shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix = _ref2.getSeparatorAfterNationalPrefix;
  // `format` has already been checked for `nationalPrefix` requirement.
  var nationalSignificantNumber = state.nationalSignificantNumber,
      international = state.international,
      nationalPrefix = state.nationalPrefix,
      carrierCode = state.carrierCode; // Format the number with using `national_prefix_formatting_rule`.
  // If the resulting formatted number is a valid formatted number, then return it.
  //
  // Google's AsYouType formatter is different in a way that it doesn't try
  // to format using the "national prefix formatting rule", and instead it
  // simply prepends a national prefix followed by a " " character.
  // This code does that too, but as a fallback.
  // The reason is that "national prefix formatting rule" may use parentheses,
  // which wouldn't be included has it used the simpler Google's way.
  //

  if (shouldTryNationalPrefixFormattingRule(format)) {
    var formattedNumber = formatNationalNumber$1(state, format, {
      useNationalPrefixFormattingRule: true,
      getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
      metadata: metadata
    });

    if (formattedNumber) {
      return formattedNumber;
    }
  } // Format the number without using `national_prefix_formatting_rule`.


  return formatNationalNumber$1(state, format, {
    useNationalPrefixFormattingRule: false,
    getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
    metadata: metadata
  });
}

function formatNationalNumber$1(state, format, _ref3) {
  var metadata = _ref3.metadata,
      useNationalPrefixFormattingRule = _ref3.useNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix = _ref3.getSeparatorAfterNationalPrefix;
  var formattedNationalNumber = formatNationalNumberUsingFormat(state.nationalSignificantNumber, format, {
    carrierCode: state.carrierCode,
    useInternationalFormat: state.international,
    withNationalPrefix: useNationalPrefixFormattingRule,
    metadata: metadata
  });

  if (!useNationalPrefixFormattingRule) {
    if (state.nationalPrefix) {
      // If a national prefix was extracted, then just prepend it,
      // followed by a " " character.
      formattedNationalNumber = state.nationalPrefix + getSeparatorAfterNationalPrefix(format) + formattedNationalNumber;
    } else if (state.complexPrefixBeforeNationalSignificantNumber) {
      formattedNationalNumber = state.complexPrefixBeforeNationalSignificantNumber + ' ' + formattedNationalNumber;
    }
  }

  if (isValidFormattedNationalNumber(formattedNationalNumber, state)) {
    return formattedNationalNumber;
  }
} // Check that the formatted phone number contains exactly
// the same digits that have been input by the user.
// For example, when "0111523456789" is input for `AR` country,
// the extracted `this.nationalSignificantNumber` is "91123456789",
// which means that the national part of `this.digits` isn't simply equal to
// `this.nationalPrefix` + `this.nationalSignificantNumber`.
//
// Also, a `format` can add extra digits to the `this.nationalSignificantNumber`
// being formatted via `metadata[country].national_prefix_transform_rule`.
// For example, for `VI` country, it prepends `340` to the national number,
// and if this check hasn't been implemented, then there would be a bug
// when `340` "area coude" is "duplicated" during input for `VI` country:
// https://github.com/catamphetamine/libphonenumber-js/issues/318
//
// So, all these "gotchas" are filtered out.
//
// In the original Google's code, the comments say:
// "Check that we didn't remove nor add any extra digits when we matched
// this formatting pattern. This usually happens after we entered the last
// digit during AYTF. Eg: In case of MX, we swallow mobile token (1) when
// formatted but AYTF should retain all the number entered and not change
// in order to match a format (of same leading digits and length) display
// in that way."
// "If it's the same (i.e entered number and format is same), then it's
// safe to return this in formatted number as nothing is lost / added."
// Otherwise, don't use this format.
// https://github.com/google/libphonenumber/commit/3e7c1f04f5e7200f87fb131e6f85c6e99d60f510#diff-9149457fa9f5d608a11bb975c6ef4bc5
// https://github.com/google/libphonenumber/commit/3ac88c7106e7dcb553bcc794b15f19185928a1c6#diff-2dcb77e833422ee304da348b905cde0b
//


function isValidFormattedNationalNumber(formattedNationalNumber, state) {
  return parseDigits(formattedNationalNumber) === state.getNationalDigits();
}

function _classCallCheck$4(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$3(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$3(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$3(Constructor.prototype, protoProps); if (staticProps) _defineProperties$3(Constructor, staticProps); return Constructor; }

function _defineProperty$6(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// Could be any digit, I guess.

var DUMMY_DIGIT = '9'; // I don't know why is it exactly `15`

var LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15; // Create a phone number consisting only of the digit 9 that matches the
// `number_pattern` by applying the pattern to the "longest phone number" string.

var LONGEST_DUMMY_PHONE_NUMBER = repeat(DUMMY_DIGIT, LONGEST_NATIONAL_PHONE_NUMBER_LENGTH); // A set of characters that, if found in a national prefix formatting rules, are an indicator to
// us that we should separate the national prefix from the number when formatting.

var NATIONAL_PREFIX_SEPARATORS_PATTERN = /[- ]/; // Deprecated: Google has removed some formatting pattern related code from their repo.
// An example of a character class is "[1-4]".

var CREATE_CHARACTER_CLASS_PATTERN =  function () {
  return /\[([^\[\]])*\]/g;
}; // Any digit in a regular expression that actually denotes a digit. For
// example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
// (8 and 0) are standalone digits, but the rest are not.
// Two look-aheads are needed because the number following \\d could be a
// two-digit number, since the phone number can be as long as 15 digits.


var CREATE_STANDALONE_DIGIT_PATTERN =  function () {
  return /\d(?=[^,}][^,}])/g;
}; // A regular expression that is used to determine if a `format` is
// suitable to be used in the "as you type formatter".
// A `format` is suitable when the resulting formatted number has
// the same digits as the user has entered.
//
// In the simplest case, that would mean that the format
// doesn't add any additional digits when formatting a number.
// Google says that it also shouldn't add "star" (`*`) characters,
// like it does in some Israeli formats.
// Such basic format would only contain "valid punctuation"
// and "captured group" identifiers ($1, $2, etc).
//
// An example of a format that adds additional digits:
//
// Country: `AR` (Argentina).
// Format:
// {
//    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
//    "leading_digits_patterns": ["91"],
//    "national_prefix_formatting_rule": "0$1",
//    "format": "$2 15-$3-$4",
//    "international_format": "$1 $2 $3-$4"
// }
//
// In the format above, the `format` adds `15` to the digits when formatting a number.
// A sidenote: this format actually is suitable because `national_prefix_for_parsing`
// has previously removed `15` from a national number, so re-adding `15` in `format`
// doesn't actually result in any extra digits added to user's input.
// But verifying that would be a complex procedure, so the code chooses a simpler path:
// it simply filters out all `format`s that contain anything but "captured group" ids.
//
// This regular expression is called `ELIGIBLE_FORMAT_PATTERN` in Google's
// `libphonenumber` code.
//


var NON_ALTERING_FORMAT_REG_EXP = new RegExp('^' + '[' + VALID_PUNCTUATION + ']*' + '(\\$\\d[' + VALID_PUNCTUATION + ']*)+' + '$'); // This is the minimum length of the leading digits of a phone number
// to guarantee the first "leading digits pattern" for a phone number format
// to be preemptive.

var MIN_LEADING_DIGITS_LENGTH = 3;

var AsYouTypeFormatter =
/*#__PURE__*/
function () {
  function AsYouTypeFormatter(_ref) {
    var _this = this;

    var state = _ref.state,
        metadata = _ref.metadata;

    _classCallCheck$4(this, AsYouTypeFormatter);

    _defineProperty$6(this, "getSeparatorAfterNationalPrefix", function (format) {
      // `US` metadata doesn't have a `national_prefix_formatting_rule`,
      // so the `if` condition below doesn't apply to `US`,
      // but in reality there shoudl be a separator
      // between a national prefix and a national (significant) number.
      // So `US` national prefix separator is a "special" "hardcoded" case.
      if (_this.isNANP) {
        return ' ';
      } // If a `format` has a `national_prefix_formatting_rule`
      // and that rule has a separator after a national prefix,
      // then it means that there should be a separator
      // between a national prefix and a national (significant) number.


      if (format && format.nationalPrefixFormattingRule() && NATIONAL_PREFIX_SEPARATORS_PATTERN.test(format.nationalPrefixFormattingRule())) {
        return ' ';
      } // At this point, there seems to be no clear evidence that
      // there should be a separator between a national prefix
      // and a national (significant) number. So don't insert one.


      return '';
    });

    _defineProperty$6(this, "shouldTryNationalPrefixFormattingRule", function (format, _ref2) {
      var international = _ref2.international,
          nationalPrefix = _ref2.nationalPrefix;

      if (format.nationalPrefixFormattingRule()) {
        // In some countries, `national_prefix_formatting_rule` is `($1)`,
        // so it applies even if the user hasn't input a national prefix.
        // `format.usesNationalPrefix()` detects such cases.
        var usesNationalPrefix = format.usesNationalPrefix();

        if (usesNationalPrefix && nationalPrefix || !usesNationalPrefix && !international) {
          return true;
        }
      }
    });

    this.metadata = metadata;
    this.resetFormat();
  }

  _createClass$3(AsYouTypeFormatter, [{
    key: "resetFormat",
    value: function resetFormat() {
      this.chosenFormat = undefined;
      this.template = undefined;
      this.nationalNumberTemplate = undefined;
      this.populatedNationalNumberTemplate = undefined;
      this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function reset(numberingPlan, state) {
      this.resetFormat();

      if (numberingPlan) {
        this.isNANP = numberingPlan.callingCode() === '1';
        this.matchingFormats = numberingPlan.formats();

        if (state.nationalSignificantNumber) {
          this.narrowDownMatchingFormats(state);
        }
      } else {
        this.isNANP = undefined;
        this.matchingFormats = [];
      }
    }
  }, {
    key: "format",
    value: function format(nextDigits, state) {
      var _this2 = this;

      // See if the phone number digits can be formatted as a complete phone number.
      // If not, use the results from `formatNationalNumberWithNextDigits()`,
      // which formats based on the chosen formatting pattern.
      //
      // Attempting to format complete phone number first is how it's done
      // in Google's `libphonenumber`, so this library just follows it.
      // Google's `libphonenumber` code doesn't explain in detail why does it
      // attempt to format digits as a complete phone number
      // instead of just going with a previoulsy (or newly) chosen `format`:
      //
      // "Checks to see if there is an exact pattern match for these digits.
      //  If so, we should use this instead of any other formatting template
      //  whose leadingDigitsPattern also matches the input."
      //
      if (canFormatCompleteNumber(state.nationalSignificantNumber, this.metadata)) {
        for (var _iterator = this.matchingFormats, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
          var _ref3;

          if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref3 = _iterator[_i++];
          } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref3 = _i.value;
          }

          var format = _ref3;
          var formattedCompleteNumber = formatCompleteNumber(state, format, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function shouldTryNationalPrefixFormattingRule(format) {
              return _this2.shouldTryNationalPrefixFormattingRule(format, {
                international: state.international,
                nationalPrefix: state.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: this.getSeparatorAfterNationalPrefix
          });

          if (formattedCompleteNumber) {
            this.resetFormat();
            this.chosenFormat = format;
            this.setNationalNumberTemplate(formattedCompleteNumber.replace(/\d/g, DIGIT_PLACEHOLDER), state);
            this.populatedNationalNumberTemplate = formattedCompleteNumber; // With a new formatting template, the matched position
            // using the old template needs to be reset.

            this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(DIGIT_PLACEHOLDER);
            return formattedCompleteNumber;
          }
        }
      } // Format the digits as a partial (incomplete) phone number
      // using the previously chosen formatting pattern (or a newly chosen one).


      return this.formatNationalNumberWithNextDigits(nextDigits, state);
    } // Formats the next phone number digits.

  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function formatNationalNumberWithNextDigits(nextDigits, state) {
      var previouslyChosenFormat = this.chosenFormat; // Choose a format from the list of matching ones.

      var newlyChosenFormat = this.chooseFormat(state);

      if (newlyChosenFormat) {
        if (newlyChosenFormat === previouslyChosenFormat) {
          // If it can format the next (current) digits
          // using the previously chosen phone number format
          // then return the updated formatted number.
          return this.formatNextNationalNumberDigits(nextDigits);
        } else {
          // If a more appropriate phone number format
          // has been chosen for these "leading digits",
          // then re-format the national phone number part
          // using the newly selected format.
          return this.formatNextNationalNumberDigits(state.getNationalDigits());
        }
      }
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function narrowDownMatchingFormats(_ref4) {
      var _this3 = this;

      var nationalSignificantNumber = _ref4.nationalSignificantNumber,
          nationalPrefix = _ref4.nationalPrefix,
          international = _ref4.international;
      var leadingDigits = nationalSignificantNumber; // "leading digits" pattern list starts with a
      // "leading digits" pattern fitting a maximum of 3 leading digits.
      // So, after a user inputs 3 digits of a national (significant) phone number
      // this national (significant) number can already be formatted.
      // The next "leading digits" pattern is for 4 leading digits max,
      // and the "leading digits" pattern after it is for 5 leading digits max, etc.
      // This implementation is different from Google's
      // in that it searches for a fitting format
      // even if the user has entered less than
      // `MIN_LEADING_DIGITS_LENGTH` digits of a national number.
      // Because some leading digit patterns already match for a single first digit.

      var leadingDigitsPatternIndex = leadingDigits.length - MIN_LEADING_DIGITS_LENGTH;

      if (leadingDigitsPatternIndex < 0) {
        leadingDigitsPatternIndex = 0;
      }

      this.matchingFormats = this.matchingFormats.filter(function (format) {
        return _this3.formatSuits(format, international, nationalPrefix) && _this3.formatMatches(format, leadingDigits, leadingDigitsPatternIndex);
      }); // If there was a phone number format chosen
      // and it no longer holds given the new leading digits then reset it.
      // The test for this `if` condition is marked as:
      // "Reset a chosen format when it no longer holds given the new leading digits".
      // To construct a valid test case for this one can find a country
      // in `PhoneNumberMetadata.xml` yielding one format for 3 `<leadingDigits>`
      // and yielding another format for 4 `<leadingDigits>` (Australia in this case).

      if (this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1) {
        this.resetFormat();
      }
    }
  }, {
    key: "formatSuits",
    value: function formatSuits(format, international, nationalPrefix) {
      // When a prefix before a national (significant) number is
      // simply a national prefix, then it's parsed as `this.nationalPrefix`.
      // In more complex cases, a prefix before national (significant) number
      // could include a national prefix as well as some "capturing groups",
      // and in that case there's no info whether a national prefix has been parsed.
      // If national prefix is not used when formatting a phone number
      // using this format, but a national prefix has been entered by the user,
      // and was extracted, then discard such phone number format.
      // In Google's "AsYouType" formatter code, the equivalent would be this part:
      // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L175-L184
      if (nationalPrefix && !format.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !format.nationalPrefixIsOptionalWhenFormattingInNationalFormat()) {
        return false;
      } // If national prefix is mandatory for this phone number format
      // and there're no guarantees that a national prefix is present in user input
      // then discard this phone number format as not suitable.
      // In Google's "AsYouType" formatter code, the equivalent would be this part:
      // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L185-L193


      if (!international && !nationalPrefix && format.nationalPrefixIsMandatoryWhenFormattingInNationalFormat()) {
        return false;
      }

      return true;
    }
  }, {
    key: "formatMatches",
    value: function formatMatches(format, leadingDigits, leadingDigitsPatternIndex) {
      var leadingDigitsPatternsCount = format.leadingDigitsPatterns().length; // If this format is not restricted to a certain
      // leading digits pattern then it fits.

      if (leadingDigitsPatternsCount === 0) {
        return true;
      } // Start excluding any non-matching formats only when the
      // national number entered so far is at least 3 digits long,
      // otherwise format matching would give false negatives.
      // For example, when the digits entered so far are `2`
      // and the leading digits pattern is `21` –
      // it's quite obvious in this case that the format could be the one
      // but due to the absence of further digits it would give false negative.


      if (leadingDigits.length < MIN_LEADING_DIGITS_LENGTH) {
        return true;
      } // If at least `MIN_LEADING_DIGITS_LENGTH` digits of a national number are available
      // then format matching starts narrowing down the list of possible formats
      // (only previously matched formats are considered for next digits).


      leadingDigitsPatternIndex = Math.min(leadingDigitsPatternIndex, leadingDigitsPatternsCount - 1);
      var leadingDigitsPattern = format.leadingDigitsPatterns()[leadingDigitsPatternIndex]; // Brackets are required for `^` to be applied to
      // all or-ed (`|`) parts, not just the first one.

      return new RegExp("^(".concat(leadingDigitsPattern, ")")).test(leadingDigits);
    }
  }, {
    key: "getFormatFormat",
    value: function getFormatFormat(format, international) {
      return international ? format.internationalFormat() : format.format();
    }
  }, {
    key: "chooseFormat",
    value: function chooseFormat(state) {
      var _this4 = this;

      var _loop2 = function _loop2() {
        if (_isArray2) {
          if (_i2 >= _iterator2.length) return "break";
          _ref5 = _iterator2[_i2++];
        } else {
          _i2 = _iterator2.next();
          if (_i2.done) return "break";
          _ref5 = _i2.value;
        }

        var format = _ref5;

        // If this format is currently being used
        // and is still suitable, then stick to it.
        if (_this4.chosenFormat === format) {
          return "break";
        } // Sometimes, a formatting rule inserts additional digits in a phone number,
        // and "as you type" formatter can't do that: it should only use the digits
        // that the user has input.
        //
        // For example, in Argentina, there's a format for mobile phone numbers:
        //
        // {
        //    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
        //    "leading_digits_patterns": ["91"],
        //    "national_prefix_formatting_rule": "0$1",
        //    "format": "$2 15-$3-$4",
        //    "international_format": "$1 $2 $3-$4"
        // }
        //
        // In that format, `international_format` is used instead of `format`
        // because `format` inserts `15` in the formatted number,
        // and `AsYouType` formatter should only use the digits
        // the user has actually input, without adding any extra digits.
        // In this case, it wouldn't make a difference, because the `15`
        // is first stripped when applying `national_prefix_for_parsing`
        // and then re-added when using `format`, so in reality it doesn't
        // add any new digits to the number, but to detect that, the code
        // would have to be more complex: it would have to try formatting
        // the digits using the format and then see if any digits have
        // actually been added or removed, and then, every time a new digit
        // is input, it should re-check whether the chosen format doesn't
        // alter the digits.
        //
        // Google's code doesn't go that far, and so does this library:
        // it simply requires that a `format` doesn't add any additonal
        // digits to user's input.
        //
        // Also, people in general should move from inputting phone numbers
        // in national format (possibly with national prefixes)
        // and use international phone number format instead:
        // it's a logical thing in the modern age of mobile phones,
        // globalization and the internet.
        //

        /* istanbul ignore if */


        if (!NON_ALTERING_FORMAT_REG_EXP.test(_this4.getFormatFormat(format, state.international))) {
          return "continue";
        }

        if (!_this4.createTemplateForFormat(format, state)) {
          // Remove the format if it can't generate a template.
          _this4.matchingFormats = _this4.matchingFormats.filter(function (_) {
            return _ !== format;
          });
          return "continue";
        }

        _this4.chosenFormat = format;
        return "break";
      };

      // When there are multiple available formats, the formatter uses the first
      // format where a formatting template could be created.
      _loop: for (var _iterator2 = this.matchingFormats.slice(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref5;

        var _ret = _loop2();

        switch (_ret) {
          case "break":
            break _loop;

          case "continue":
            continue;
        }
      }

      if (!this.chosenFormat) {
        // No format matches the national (significant) phone number.
        this.resetFormat();
      }

      return this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function createTemplateForFormat(format, state) {
      // The formatter doesn't format numbers when numberPattern contains '|', e.g.
      // (20|3)\d{4}. In those cases we quickly return.
      // (Though there's no such format in current metadata)

      /* istanbul ignore if */
      if ( format.pattern().indexOf('|') >= 0) {
        return;
      } // Get formatting template for this phone number format


      var template = this.getTemplateForFormat(format, state); // If the national number entered is too long
      // for any phone number format, then abort.

      if (template) {
        this.setNationalNumberTemplate(template, state);
        return true;
      }
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function getInternationalPrefixBeforeCountryCallingCode(_ref6, options) {
      var IDDPrefix = _ref6.IDDPrefix,
          missingPlus = _ref6.missingPlus;

      if (IDDPrefix) {
        return options && options.spacing === false ? IDDPrefix : IDDPrefix + ' ';
      }

      if (missingPlus) {
        return '';
      }

      return '+';
    }
  }, {
    key: "getTemplate",
    value: function getTemplate(state) {
      if (!this.template) {
        return;
      } // `this.template` holds the template for a "complete" phone number.
      // The currently entered phone number is most likely not "complete",
      // so trim all non-populated digits.


      var index = -1;
      var i = 0;
      var internationalPrefix = state.international ? this.getInternationalPrefixBeforeCountryCallingCode(state, {
        spacing: false
      }) : '';

      while (i < internationalPrefix.length + state.getDigitsWithoutInternationalPrefix().length) {
        index = this.template.indexOf(DIGIT_PLACEHOLDER, index + 1);
        i++;
      }

      return cutAndStripNonPairedParens(this.template, index + 1);
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function setNationalNumberTemplate(template, state) {
      this.nationalNumberTemplate = template;
      this.populatedNationalNumberTemplate = template; // With a new formatting template, the matched position
      // using the old template needs to be reset.

      this.populatedNationalNumberTemplatePosition = -1; // For convenience, the public `.template` property
      // contains the whole international number
      // if the phone number being input is international:
      // 'x' for the '+' sign, 'x'es for the country phone code,
      // a spacebar and then the template for the formatted national number.

      if (state.international) {
        this.template = this.getInternationalPrefixBeforeCountryCallingCode(state).replace(/[\d\+]/g, DIGIT_PLACEHOLDER) + repeat(DIGIT_PLACEHOLDER, state.callingCode.length) + ' ' + template;
      } else {
        this.template = template;
      }
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */

  }, {
    key: "getTemplateForFormat",
    value: function getTemplateForFormat(format, _ref7) {
      var nationalSignificantNumber = _ref7.nationalSignificantNumber,
          international = _ref7.international,
          nationalPrefix = _ref7.nationalPrefix,
          complexPrefixBeforeNationalSignificantNumber = _ref7.complexPrefixBeforeNationalSignificantNumber;
      var pattern = format.pattern();
      /* istanbul ignore else */

      {
        pattern = pattern // Replace anything in the form of [..] with \d
        .replace(CREATE_CHARACTER_CLASS_PATTERN(), '\\d') // Replace any standalone digit (not the one in `{}`) with \d
        .replace(CREATE_STANDALONE_DIGIT_PATTERN(), '\\d');
      } // Generate a dummy national number (consisting of `9`s)
      // that fits this format's `pattern`.
      //
      // This match will always succeed,
      // because the "longest dummy phone number"
      // has enough length to accomodate any possible
      // national phone number format pattern.
      //


      var digits = LONGEST_DUMMY_PHONE_NUMBER.match(pattern)[0]; // If the national number entered is too long
      // for any phone number format, then abort.

      if (nationalSignificantNumber.length > digits.length) {
        return;
      } // Get a formatting template which can be used to efficiently format
      // a partial number where digits are added one by one.
      // Below `strictPattern` is used for the
      // regular expression (with `^` and `$`).
      // This wasn't originally in Google's `libphonenumber`
      // and I guess they don't really need it
      // because they're not using "templates" to format phone numbers
      // but I added `strictPattern` after encountering
      // South Korean phone number formatting bug.
      //
      // Non-strict regular expression bug demonstration:
      //
      // this.nationalSignificantNumber : `111111111` (9 digits)
      //
      // pattern : (\d{2})(\d{3,4})(\d{4})
      // format : `$1 $2 $3`
      // digits : `9999999999` (10 digits)
      //
      // '9999999999'.replace(new RegExp(/(\d{2})(\d{3,4})(\d{4})/g), '$1 $2 $3') = "99 9999 9999"
      //
      // template : xx xxxx xxxx
      //
      // But the correct template in this case is `xx xxx xxxx`.
      // The template was generated incorrectly because of the
      // `{3,4}` variability in the `pattern`.
      //
      // The fix is, if `this.nationalSignificantNumber` has already sufficient length
      // to satisfy the `pattern` completely then `this.nationalSignificantNumber`
      // is used instead of `digits`.


      var strictPattern = new RegExp('^' + pattern + '$');
      var nationalNumberDummyDigits = nationalSignificantNumber.replace(/\d/g, DUMMY_DIGIT); // If `this.nationalSignificantNumber` has already sufficient length
      // to satisfy the `pattern` completely then use it
      // instead of `digits`.

      if (strictPattern.test(nationalNumberDummyDigits)) {
        digits = nationalNumberDummyDigits;
      }

      var numberFormat = this.getFormatFormat(format, international);
      var nationalPrefixIncludedInTemplate; // If a user did input a national prefix (and that's guaranteed),
      // and if a `format` does have a national prefix formatting rule,
      // then see if that national prefix formatting rule
      // prepends exactly the same national prefix the user has input.
      // If that's the case, then use the `format` with the national prefix formatting rule.
      // Otherwise, use  the `format` without the national prefix formatting rule,
      // and prepend a national prefix manually to it.

      if (this.shouldTryNationalPrefixFormattingRule(format, {
        international: international,
        nationalPrefix: nationalPrefix
      })) {
        var numberFormatWithNationalPrefix = numberFormat.replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()); // If `national_prefix_formatting_rule` of a `format` simply prepends
        // national prefix at the start of a national (significant) number,
        // then such formatting can be used with `AsYouType` formatter.
        // There seems to be no `else` case: everywhere in metadata,
        // national prefix formatting rule is national prefix + $1,
        // or `($1)`, in which case such format isn't even considered
        // when the user has input a national prefix.

        /* istanbul ignore else */

        if (parseDigits(format.nationalPrefixFormattingRule()) === (nationalPrefix || '') + parseDigits('$1')) {
          numberFormat = numberFormatWithNationalPrefix;
          nationalPrefixIncludedInTemplate = true; // Replace all digits of the national prefix in the formatting template
          // with `DIGIT_PLACEHOLDER`s.

          if (nationalPrefix) {
            var i = nationalPrefix.length;

            while (i > 0) {
              numberFormat = numberFormat.replace(/\d/, DIGIT_PLACEHOLDER);
              i--;
            }
          }
        }
      } // Generate formatting template for this phone number format.


      var template = digits // Format the dummy phone number according to the format.
      .replace(new RegExp(pattern), numberFormat) // Replace each dummy digit with a DIGIT_PLACEHOLDER.
      .replace(new RegExp(DUMMY_DIGIT, 'g'), DIGIT_PLACEHOLDER); // If a prefix of a national (significant) number is not as simple
      // as just a basic national prefix, then just prepend such prefix
      // before the national (significant) number, optionally spacing
      // the two with a whitespace.

      if (!nationalPrefixIncludedInTemplate) {
        if (complexPrefixBeforeNationalSignificantNumber) {
          // Prepend the prefix to the template manually.
          template = repeat(DIGIT_PLACEHOLDER, complexPrefixBeforeNationalSignificantNumber.length) + ' ' + template;
        } else if (nationalPrefix) {
          // Prepend national prefix to the template manually.
          template = repeat(DIGIT_PLACEHOLDER, nationalPrefix.length) + this.getSeparatorAfterNationalPrefix(format) + template;
        }
      }

      if (international) {
        template = applyInternationalSeparatorStyle(template);
      }

      return template;
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function formatNextNationalNumberDigits(digits) {
      var result = populateTemplateWithDigits(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, digits);

      if (!result) {
        // Reset the format.
        this.resetFormat();
        return;
      }

      this.populatedNationalNumberTemplate = result[0];
      this.populatedNationalNumberTemplatePosition = result[1]; // Return the formatted phone number so far.

      return cutAndStripNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1); // The old way which was good for `input-format` but is not so good
      // for `react-phone-number-input`'s default input (`InputBasic`).
      // return closeNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1)
      // 	.replace(new RegExp(DIGIT_PLACEHOLDER, 'g'), ' ')
    }
  }]);

  return AsYouTypeFormatter;
}();

function _slicedToArray$2(arr, i) { return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _nonIterableRest$2(); }

function _nonIterableRest$2() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit$2(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$2(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck$5(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$4(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$4(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$4(Constructor.prototype, protoProps); if (staticProps) _defineProperties$4(Constructor, staticProps); return Constructor; }
var VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART = '[' + VALID_PUNCTUATION + VALID_DIGITS + ']+';
var VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN = new RegExp('^' + VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART + '$', 'i');
var VALID_FORMATTED_PHONE_NUMBER_PART = '(?:' + '[' + PLUS_CHARS + ']' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']*' + '|' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']+' + ')';
var AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp('[^' + VALID_PUNCTUATION + VALID_DIGITS + ']+' + '.*' + '$'); // Tests whether `national_prefix_for_parsing` could match
// different national prefixes.
// Matches anything that's not a digit or a square bracket.

var COMPLEX_NATIONAL_PREFIX = /[^\d\[\]]/;

var AsYouTypeParser =
/*#__PURE__*/
function () {
  function AsYouTypeParser(_ref) {
    var defaultCountry = _ref.defaultCountry,
        defaultCallingCode = _ref.defaultCallingCode,
        metadata = _ref.metadata,
        onNationalSignificantNumberChange = _ref.onNationalSignificantNumberChange;

    _classCallCheck$5(this, AsYouTypeParser);

    this.defaultCountry = defaultCountry;
    this.defaultCallingCode = defaultCallingCode;
    this.metadata = metadata;
    this.onNationalSignificantNumberChange = onNationalSignificantNumberChange;
  }

  _createClass$4(AsYouTypeParser, [{
    key: "input",
    value: function input(text, state) {
      var _extractFormattedDigi = extractFormattedDigitsAndPlus(text),
          _extractFormattedDigi2 = _slicedToArray$2(_extractFormattedDigi, 2),
          formattedDigits = _extractFormattedDigi2[0],
          hasPlus = _extractFormattedDigi2[1];

      var digits = parseDigits(formattedDigits); // Checks for a special case: just a leading `+` has been entered.

      var justLeadingPlus;

      if (hasPlus) {
        if (!state.digits) {
          state.startInternationalNumber();

          if (!digits) {
            justLeadingPlus = true;
          }
        }
      }

      if (digits) {
        this.inputDigits(digits, state);
      }

      return {
        digits: digits,
        justLeadingPlus: justLeadingPlus
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */

  }, {
    key: "inputDigits",
    value: function inputDigits(nextDigits, state) {
      var digits = state.digits;
      var hasReceivedThreeLeadingDigits = digits.length < 3 && digits.length + nextDigits.length >= 3; // Append phone number digits.

      state.appendDigits(nextDigits); // Attempt to extract IDD prefix:
      // Some users input their phone number in international format,
      // but in an "out-of-country" dialing format instead of using the leading `+`.
      // https://github.com/catamphetamine/libphonenumber-js/issues/185
      // Detect such numbers as soon as there're at least 3 digits.
      // Google's library attempts to extract IDD prefix at 3 digits,
      // so this library just copies that behavior.
      // I guess that's because the most commot IDD prefixes are
      // `00` (Europe) and `011` (US).
      // There exist really long IDD prefixes too:
      // for example, in Australia the default IDD prefix is `0011`,
      // and it could even be as long as `14880011`.
      // An IDD prefix is extracted here, and then every time when
      // there's a new digit and the number couldn't be formatted.

      if (hasReceivedThreeLeadingDigits) {
        this.extractIddPrefix(state);
      }

      if (this.isWaitingForCountryCallingCode(state)) {
        if (!this.extractCountryCallingCode(state)) {
          return;
        }
      } else {
        state.appendNationalSignificantNumberDigits(nextDigits);
      } // If a phone number is being input in international format,
      // then it's not valid for it to have a national prefix.
      // Still, some people incorrectly input such numbers with a national prefix.
      // In such cases, only attempt to strip a national prefix if the number becomes too long.
      // (but that is done later, not here)


      if (!state.international) {
        if (!this.hasExtractedNationalSignificantNumber) {
          this.extractNationalSignificantNumber(state.getNationalDigits(), state.update);
        }
      }
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function isWaitingForCountryCallingCode(_ref2) {
      var international = _ref2.international,
          callingCode = _ref2.callingCode;
      return international && !callingCode;
    } // Extracts a country calling code from a number
    // being entered in internatonal format.

  }, {
    key: "extractCountryCallingCode",
    value: function extractCountryCallingCode$1(state) {
      var _extractCountryCallin = extractCountryCallingCode('+' + state.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
          countryCallingCode = _extractCountryCallin.countryCallingCode,
          number = _extractCountryCallin.number;

      if (countryCallingCode) {
        state.setCallingCode(countryCallingCode);
        state.update({
          nationalSignificantNumber: number
        });
        return true;
      }
    }
  }, {
    key: "reset",
    value: function reset(numberingPlan) {
      if (numberingPlan) {
        this.hasSelectedNumberingPlan = true;

        var nationalPrefixForParsing = numberingPlan._nationalPrefixForParsing();

        this.couldPossiblyExtractAnotherNationalSignificantNumber = nationalPrefixForParsing && COMPLEX_NATIONAL_PREFIX.test(nationalPrefixForParsing);
      } else {
        this.hasSelectedNumberingPlan = undefined;
        this.couldPossiblyExtractAnotherNationalSignificantNumber = undefined;
      }
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */

  }, {
    key: "extractNationalSignificantNumber",
    value: function extractNationalSignificantNumber(nationalDigits, setState) {
      if (!this.hasSelectedNumberingPlan) {
        return;
      }

      var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(nationalDigits, this.metadata),
          nationalPrefix = _extractNationalNumbe.nationalPrefix,
          nationalNumber = _extractNationalNumbe.nationalNumber,
          carrierCode = _extractNationalNumbe.carrierCode;

      if (nationalNumber === nationalDigits) {
        return;
      }

      this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
      return true;
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */

  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function extractAnotherNationalSignificantNumber(nationalDigits, prevNationalSignificantNumber, setState) {
      if (!this.hasExtractedNationalSignificantNumber) {
        return this.extractNationalSignificantNumber(nationalDigits, setState);
      }

      if (!this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        return;
      }

      var _extractNationalNumbe2 = extractNationalNumberFromPossiblyIncompleteNumber(nationalDigits, this.metadata),
          nationalPrefix = _extractNationalNumbe2.nationalPrefix,
          nationalNumber = _extractNationalNumbe2.nationalNumber,
          carrierCode = _extractNationalNumbe2.carrierCode; // If a national prefix has been extracted previously,
      // then it's always extracted as additional digits are added.
      // That's assuming `extractNationalNumberFromPossiblyIncompleteNumber()`
      // doesn't do anything different from what it currently does.
      // So, just in case, here's this check, though it doesn't occur.

      /* istanbul ignore if */


      if (nationalNumber === prevNationalSignificantNumber) {
        return;
      }

      this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
      return true;
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function onExtractedNationalNumber(nationalPrefix, carrierCode, nationalSignificantNumber, nationalDigits, setState) {
      var complexPrefixBeforeNationalSignificantNumber;
      var nationalSignificantNumberMatchesInput; // This check also works with empty `this.nationalSignificantNumber`.

      var nationalSignificantNumberIndex = nationalDigits.lastIndexOf(nationalSignificantNumber); // If the extracted national (significant) number is the
      // last substring of the `digits`, then it means that it hasn't been altered:
      // no digits have been removed from the national (significant) number
      // while applying `national_prefix_transform_rule`.
      // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule

      if (nationalSignificantNumberIndex >= 0 && nationalSignificantNumberIndex === nationalDigits.length - nationalSignificantNumber.length) {
        nationalSignificantNumberMatchesInput = true; // If a prefix of a national (significant) number is not as simple
        // as just a basic national prefix, then such prefix is stored in
        // `this.complexPrefixBeforeNationalSignificantNumber` property and will be
        // prepended "as is" to the national (significant) number to produce
        // a formatted result.

        var prefixBeforeNationalNumber = nationalDigits.slice(0, nationalSignificantNumberIndex); // `prefixBeforeNationalNumber` is always non-empty,
        // because `onExtractedNationalNumber()` isn't called
        // when a national (significant) number hasn't been actually "extracted":
        // when a national (significant) number is equal to the national part of `digits`,
        // then `onExtractedNationalNumber()` doesn't get called.

        if (prefixBeforeNationalNumber !== nationalPrefix) {
          complexPrefixBeforeNationalSignificantNumber = prefixBeforeNationalNumber;
        }
      }

      setState({
        nationalPrefix: nationalPrefix,
        carrierCode: carrierCode,
        nationalSignificantNumber: nationalSignificantNumber,
        nationalSignificantNumberMatchesInput: nationalSignificantNumberMatchesInput,
        complexPrefixBeforeNationalSignificantNumber: complexPrefixBeforeNationalSignificantNumber
      }); // `onExtractedNationalNumber()` is only called when
      // the national (significant) number actually did change.

      this.hasExtractedNationalSignificantNumber = true;
      this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function reExtractNationalSignificantNumber(state) {
      // Attempt to extract a national prefix.
      //
      // Some people incorrectly input national prefix
      // in an international phone number.
      // For example, some people write British phone numbers as `+44(0)...`.
      //
      // Also, in some rare cases, it is valid for a national prefix
      // to be a part of an international phone number.
      // For example, mobile phone numbers in Mexico are supposed to be
      // dialled internationally using a `1` national prefix,
      // so the national prefix will be part of an international number.
      //
      // Quote from:
      // https://www.mexperience.com/dialing-cell-phones-in-mexico/
      //
      // "Dialing a Mexican cell phone from abroad
      // When you are calling a cell phone number in Mexico from outside Mexico,
      // it’s necessary to dial an additional “1” after Mexico’s country code
      // (which is “52”) and before the area code.
      // You also ignore the 045, and simply dial the area code and the
      // cell phone’s number.
      //
      // If you don’t add the “1”, you’ll receive a recorded announcement
      // asking you to redial using it.
      //
      // For example, if you are calling from the USA to a cell phone
      // in Mexico City, you would dial +52 – 1 – 55 – 1234 5678.
      // (Note that this is different to calling a land line in Mexico City
      // from abroad, where the number dialed would be +52 – 55 – 1234 5678)".
      //
      // Google's demo output:
      // https://libphonenumber.appspot.com/phonenumberparser?number=%2b5215512345678&country=MX
      //
      if (this.extractAnotherNationalSignificantNumber(state.getNationalDigits(), state.nationalSignificantNumber, state.update)) {
        return true;
      } // If no format matches the phone number, then it could be
      // "a really long IDD" (quote from a comment in Google's library).
      // An IDD prefix is first extracted when the user has entered at least 3 digits,
      // and then here — every time when there's a new digit and the number
      // couldn't be formatted.
      // For example, in Australia the default IDD prefix is `0011`,
      // and it could even be as long as `14880011`.
      //
      // Could also check `!hasReceivedThreeLeadingDigits` here
      // to filter out the case when this check duplicates the one
      // already performed when there're 3 leading digits,
      // but it's not a big deal, and in most cases there
      // will be a suitable `format` when there're 3 leading digits.
      //


      if (this.extractIddPrefix(state)) {
        this.extractCallingCodeAndNationalSignificantNumber(state);
        return true;
      } // Google's AsYouType formatter supports sort of an "autocorrection" feature
      // when it "autocorrects" numbers that have been input for a country
      // with that country's calling code.
      // Such "autocorrection" feature looks weird, but different people have been requesting it:
      // https://github.com/catamphetamine/libphonenumber-js/issues/376
      // https://github.com/catamphetamine/libphonenumber-js/issues/375
      // https://github.com/catamphetamine/libphonenumber-js/issues/316


      if (this.fixMissingPlus(state)) {
        this.extractCallingCodeAndNationalSignificantNumber(state);
        return true;
      }
    }
  }, {
    key: "extractIddPrefix",
    value: function extractIddPrefix(state) {
      // An IDD prefix can't be present in a number written with a `+`.
      // Also, don't re-extract an IDD prefix if has already been extracted.
      var international = state.international,
          IDDPrefix = state.IDDPrefix,
          digits = state.digits,
          nationalSignificantNumber = state.nationalSignificantNumber;

      if (international || IDDPrefix) {
        return;
      } // Some users input their phone number in "out-of-country"
      // dialing format instead of using the leading `+`.
      // https://github.com/catamphetamine/libphonenumber-js/issues/185
      // Detect such numbers.


      var numberWithoutIDD = stripIddPrefix(digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);

      if (numberWithoutIDD !== undefined && numberWithoutIDD !== digits) {
        // If an IDD prefix was stripped then convert the IDD-prefixed number
        // to international number for subsequent parsing.
        state.update({
          IDDPrefix: digits.slice(0, digits.length - numberWithoutIDD.length)
        });
        this.startInternationalNumber(state);
        return true;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function fixMissingPlus(state) {
      if (!state.international) {
        var _extractCountryCallin2 = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(state.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
            newCallingCode = _extractCountryCallin2.countryCallingCode,
            number = _extractCountryCallin2.number;

        if (newCallingCode) {
          state.update({
            missingPlus: true
          });
          this.startInternationalNumber(state);
          return true;
        }
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function startInternationalNumber(state) {
      state.startInternationalNumber(); // If a national (significant) number has been extracted before, reset it.

      if (state.nationalSignificantNumber) {
        state.resetNationalSignificantNumber();
        this.onNationalSignificantNumberChange();
        this.hasExtractedNationalSignificantNumber = undefined;
      }
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function extractCallingCodeAndNationalSignificantNumber(state) {
      if (this.extractCountryCallingCode(state)) {
        // `this.extractCallingCode()` is currently called when the number
        // couldn't be formatted during the standard procedure.
        // Normally, the national prefix would be re-extracted
        // for an international number if such number couldn't be formatted,
        // but since it's already not able to be formatted,
        // there won't be yet another retry, so also extract national prefix here.
        this.extractNationalSignificantNumber(state.getNationalDigits(), state.update);
      }
    }
  }]);

  return AsYouTypeParser;
}();

function extractFormattedPhoneNumber$1(text) {
  // Attempt to extract a possible number from the string passed in.
  var startsAt = text.search(VALID_FORMATTED_PHONE_NUMBER_PART);

  if (startsAt < 0) {
    return;
  } // Trim everything to the left of the phone number.


  text = text.slice(startsAt); // Trim the `+`.

  var hasPlus;

  if (text[0] === '+') {
    hasPlus = true;
    text = text.slice('+'.length);
  } // Trim everything to the right of the phone number.


  text = text.replace(AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, ''); // Re-add the previously trimmed `+`.

  if (hasPlus) {
    text = '+' + text;
  }

  return text;
}
/**
 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
 * @param  {string} text
 * @return {any[]}
 */


function _extractFormattedDigitsAndPlus(text) {
  // Extract a formatted phone number part from text.
  var extractedNumber = extractFormattedPhoneNumber$1(text) || ''; // Trim a `+`.

  if (extractedNumber[0] === '+') {
    return [extractedNumber.slice('+'.length), true];
  }

  return [extractedNumber];
}
/**
 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
 * @param  {string} text
 * @return {any[]}
 */


function extractFormattedDigitsAndPlus(text) {
  var _extractFormattedDigi3 = _extractFormattedDigitsAndPlus(text),
      _extractFormattedDigi4 = _slicedToArray$2(_extractFormattedDigi3, 2),
      formattedDigits = _extractFormattedDigi4[0],
      hasPlus = _extractFormattedDigi4[1]; // If the extracted phone number part
  // can possibly be a part of some valid phone number
  // then parse phone number characters from a formatted phone number.


  if (!VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN.test(formattedDigits)) {
    formattedDigits = '';
  }

  return [formattedDigits, hasPlus];
}

function _typeof$2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$2 = function _typeof(obj) { return typeof obj; }; } else { _typeof$2 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$2(obj); }

function _slicedToArray$3(arr, i) { return _arrayWithHoles$3(arr) || _iterableToArrayLimit$3(arr, i) || _nonIterableRest$3(); }

function _nonIterableRest$3() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit$3(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$3(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck$6(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$5(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$5(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$5(Constructor.prototype, protoProps); if (staticProps) _defineProperties$5(Constructor, staticProps); return Constructor; }

var AsYouType =
/*#__PURE__*/
function () {
  /**
   * @param {(string|object)?} [optionsOrDefaultCountry] - The default country used for parsing non-international phone numbers. Can also be an `options` object.
   * @param {Object} metadata
   */
  function AsYouType(optionsOrDefaultCountry, metadata) {
    _classCallCheck$6(this, AsYouType);

    this.metadata = new Metadata(metadata);

    var _this$getCountryAndCa = this.getCountryAndCallingCode(optionsOrDefaultCountry),
        _this$getCountryAndCa2 = _slicedToArray$3(_this$getCountryAndCa, 2),
        defaultCountry = _this$getCountryAndCa2[0],
        defaultCallingCode = _this$getCountryAndCa2[1];

    this.defaultCountry = defaultCountry;
    this.defaultCallingCode = defaultCallingCode;
    this.reset();
  }

  _createClass$5(AsYouType, [{
    key: "getCountryAndCallingCode",
    value: function getCountryAndCallingCode(optionsOrDefaultCountry) {
      // Set `defaultCountry` and `defaultCallingCode` options.
      var defaultCountry;
      var defaultCallingCode; // Turns out `null` also has type "object". Weird.

      if (optionsOrDefaultCountry) {
        if (_typeof$2(optionsOrDefaultCountry) === 'object') {
          defaultCountry = optionsOrDefaultCountry.defaultCountry;
          defaultCallingCode = optionsOrDefaultCountry.defaultCallingCode;
        } else {
          defaultCountry = optionsOrDefaultCountry;
        }
      }

      if (defaultCountry && !this.metadata.hasCountry(defaultCountry)) {
        defaultCountry = undefined;
      }

      return [defaultCountry, defaultCallingCode];
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */

  }, {
    key: "input",
    value: function input(text) {
      var _this$parser$input = this.parser.input(text, this.state),
          digits = _this$parser$input.digits,
          justLeadingPlus = _this$parser$input.justLeadingPlus;

      if (justLeadingPlus) {
        this.formattedOutput = '+';
      } else if (digits) {
        this.determineTheCountryIfNeeded(); // Match the available formats by the currently available leading digits.

        if (this.state.nationalSignificantNumber) {
          this.formatter.narrowDownMatchingFormats(this.state);
        }

        var formattedNationalNumber;

        if (this.metadata.hasSelectedNumberingPlan()) {
          formattedNationalNumber = this.formatter.format(digits, this.state);
        }

        if (formattedNationalNumber === undefined) {
          // See if another national (significant) number could be re-extracted.
          if (this.parser.reExtractNationalSignificantNumber(this.state)) {
            this.determineTheCountryIfNeeded(); // If it could, then re-try formatting the new national (significant) number.

            var nationalDigits = this.state.getNationalDigits();

            if (nationalDigits) {
              formattedNationalNumber = this.formatter.format(nationalDigits, this.state);
            }
          }
        }

        this.formattedOutput = formattedNationalNumber ? this.getFullNumber(formattedNationalNumber) : this.getNonFormattedNumber();
      }

      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function reset() {
      var _this = this;

      this.state = new AsYouTypeState({
        onCountryChange: function onCountryChange(country) {
          // Before version `1.6.0`, the official `AsYouType` formatter API
          // included the `.country` property of an `AsYouType` instance.
          // Since that property (along with the others) have been moved to
          // `this.state`, `this.country` property is emulated for compatibility
          // with the old versions.
          _this.country = country;
        },
        onCallingCodeChange: function onCallingCodeChange(country, callingCode) {
          _this.metadata.selectNumberingPlan(country, callingCode);

          _this.formatter.reset(_this.metadata.numberingPlan, _this.state);

          _this.parser.reset(_this.metadata.numberingPlan);
        }
      });
      this.formatter = new AsYouTypeFormatter({
        state: this.state,
        metadata: this.metadata
      });
      this.parser = new AsYouTypeParser({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function onNationalSignificantNumberChange() {
          _this.determineTheCountryIfNeeded();

          _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
        }
      });
      this.state.reset(this.defaultCountry, this.defaultCallingCode);
      this.formattedOutput = '';
      return this;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */

  }, {
    key: "isInternational",
    value: function isInternational() {
      return this.state.international;
    }
    /**
     * Returns the "country calling code" part of the phone number.
     * Returns `undefined` if the number is not being input in international format.
     * Returns "country calling code" for "non-geographic" phone numbering plans too.
     * @return {string} [callingCode]
     */

  }, {
    key: "getCallingCode",
    value: function getCallingCode() {
      return this.state.callingCode;
    } // A legacy alias.

  }, {
    key: "getCountryCallingCode",
    value: function getCountryCallingCode() {
      return this.getCallingCode();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */

  }, {
    key: "getCountry",
    value: function getCountry() {
      var _this$state = this.state,
          digits = _this$state.digits,
          country = _this$state.country; // If no digits have been input yet,
      // then `this.country` is the `defaultCountry`.
      // Won't return the `defaultCountry` in such case.

      if (!digits) {
        return;
      }

      var countryCode = country;

      return countryCode;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function determineTheCountryIfNeeded() {
      // Suppose a user enters a phone number in international format,
      // and there're several countries corresponding to that country calling code,
      // and a country has been derived from the number, and then
      // a user enters one more digit and the number is no longer
      // valid for the derived country, so the country should be re-derived
      // on every new digit in those cases.
      //
      // If the phone number is being input in national format,
      // then it could be a case when `defaultCountry` wasn't specified
      // when creating `AsYouType` instance, and just `defaultCallingCode` was specified,
      // and that "calling code" could correspond to a "non-geographic entity",
      // or there could be several countries corresponding to that country calling code.
      // In those cases, `this.country` is `undefined` and should be derived
      // from the number. Again, if country calling code is ambiguous, then
      // `this.country` should be re-derived with each new digit.
      //
      if (!this.state.country || this.isCountryCallingCodeAmbiguous()) {
        this.determineTheCountry();
      }
    } // Prepends `+CountryCode ` in case of an international phone number

  }, {
    key: "getFullNumber",
    value: function getFullNumber(formattedNationalNumber) {
      var _this2 = this;

      if (this.isInternational()) {
        var prefix = function prefix(text) {
          return _this2.formatter.getInternationalPrefixBeforeCountryCallingCode(_this2.state, {
            spacing: text ? true : false
          }) + text;
        };

        var callingCode = this.state.callingCode;

        if (!callingCode) {
          return prefix("".concat(this.state.getDigitsWithoutInternationalPrefix()));
        }

        if (!formattedNationalNumber) {
          return prefix(callingCode);
        }

        return prefix("".concat(callingCode, " ").concat(formattedNationalNumber));
      }

      return formattedNationalNumber;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function getNonFormattedNationalNumberWithPrefix() {
      var _this$state2 = this.state,
          nationalSignificantNumber = _this$state2.nationalSignificantNumber,
          complexPrefixBeforeNationalSignificantNumber = _this$state2.complexPrefixBeforeNationalSignificantNumber,
          nationalPrefix = _this$state2.nationalPrefix;
      var number = nationalSignificantNumber;
      var prefix = complexPrefixBeforeNationalSignificantNumber || nationalPrefix;

      if (prefix) {
        number = prefix + number;
      }

      return number;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function getNonFormattedNumber() {
      var nationalSignificantNumberMatchesInput = this.state.nationalSignificantNumberMatchesInput;
      return this.getFullNumber(nationalSignificantNumberMatchesInput ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function getNonFormattedTemplate() {
      var number = this.getNonFormattedNumber();

      if (number) {
        return number.replace(/[\+\d]/g, DIGIT_PLACEHOLDER);
      }
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function isCountryCallingCodeAmbiguous() {
      var callingCode = this.state.callingCode;
      var countryCodes = this.metadata.getCountryCodesForCallingCode(callingCode);
      return countryCodes && countryCodes.length > 1;
    } // Determines the country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.

  }, {
    key: "determineTheCountry",
    value: function determineTheCountry() {
      this.state.setCountry(getCountryByCallingCode(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, this.state.nationalSignificantNumber, this.metadata));
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */

  }, {
    key: "getNumber",
    value: function getNumber() {
      var _this$state3 = this.state,
          nationalSignificantNumber = _this$state3.nationalSignificantNumber,
          carrierCode = _this$state3.carrierCode;

      if (this.isInternational()) {
        if (!this.state.callingCode) {
          return;
        }
      } else {
        if (!this.state.country && !this.defaultCallingCode) {
          return;
        }
      }

      if (!nationalSignificantNumber) {
        return;
      }

      var countryCode = this.getCountry();
      var callingCode = this.getCountryCallingCode() || this.defaultCallingCode;
      var phoneNumber = new PhoneNumber(countryCode || callingCode, nationalSignificantNumber, this.metadata.metadata);

      if (carrierCode) {
        phoneNumber.carrierCode = carrierCode;
      } // Phone number extensions are not supported by "As You Type" formatter.


      return phoneNumber;
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */

  }, {
    key: "isPossible",
    value: function isPossible() {
      var phoneNumber = this.getNumber();

      if (!phoneNumber) {
        return false;
      }

      return phoneNumber.isPossible();
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */

  }, {
    key: "isValid",
    value: function isValid() {
      var phoneNumber = this.getNumber();

      if (!phoneNumber) {
        return false;
      }

      return phoneNumber.isValid();
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */

  }, {
    key: "getNationalNumber",
    value: function getNationalNumber() {
      return this.state.nationalSignificantNumber;
    }
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */

  }, {
    key: "getChars",
    value: function getChars() {
      return (this.state.international ? '+' : '') + this.state.digits;
    }
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */

  }, {
    key: "getTemplate",
    value: function getTemplate() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || '';
    }
  }]);

  return AsYouType;
}();

function getCountries(metadata) {
  return new Metadata(metadata).getCountries();
}

/**
 * Formats a (possibly incomplete) phone number.
 * The phone number can be either in E.164 format
 * or in a form of national number digits.
 * @param {string} value - A possibly incomplete phone number. Either in E.164 format or in a form of national number digits.
 * @param {string?} country - Two-letter ("ISO 3166-1 alpha-2") country code.
 * @return {string} Formatted (possibly incomplete) phone number.
 */

function formatIncompletePhoneNumber(value, country, metadata) {
  if (!metadata) {
    metadata = country;
    country = undefined;
  }

  return new AsYouType(country, metadata).input(value);
}

function getInputValuePrefix(_ref) {
  var country = _ref.country,
      international = _ref.international,
      withCountryCallingCode = _ref.withCountryCallingCode,
      metadata = _ref.metadata;
  return country && international && !withCountryCallingCode ? "+".concat(getCountryCallingCode(country, metadata)) : '';
}
function removeInputValuePrefix(value, prefix) {
  if (prefix) {
    value = value.slice(prefix.length);

    if (value[0] === ' ') {
      value = value.slice(1);
    }
  }

  return value;
}

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

function _objectWithoutProperties$1(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$1(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * This input uses `input-format` library
 * for "smart" caret positioning.
 */

function createInput(defaultMetadata) {
  function InputSmart(_ref, ref) {
    var country = _ref.country,
        international = _ref.international,
        withCountryCallingCode = _ref.withCountryCallingCode,
        metadata = _ref.metadata,
        rest = _objectWithoutProperties$1(_ref, ["country", "international", "withCountryCallingCode", "metadata"]);

    var format = React.useCallback(function (value) {
      // "As you type" formatter.
      var formatter = new AsYouType(country, metadata);
      var prefix = getInputValuePrefix({
        country: country,
        international: international,
        withCountryCallingCode: withCountryCallingCode,
        metadata: metadata
      }); // Format the number.

      var text = formatter.input(prefix + value);
      var template = formatter.getTemplate();

      if (prefix) {
        text = removeInputValuePrefix(text, prefix); // `AsYouType.getTemplate()` can be `undefined`.

        if (template) {
          template = removeInputValuePrefix(template, prefix);
        }
      }

      return {
        text: text,
        template: template
      };
    }, [country, metadata]);
    return React__default.createElement(Input$1, _extends$1({}, rest, {
      ref: ref,
      parse: parsePhoneNumberCharacter,
      format: format
    }));
  }

  InputSmart = React__default.forwardRef(InputSmart);
  InputSmart.propTypes = {
    /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * Perhaps the `country` property should have been called `defaultCountry`
     * because if `value` is an international number then `country` is ignored.
     */
    country: index$4.propTypes.string,

    /**
     * If `country` property is passed along with `international={true}` property
     * then the phone number will be input in "international" format for that `country`
     * (without "country calling code").
     * For example, if `country="US"` property is passed to "without country select" input
     * then the phone number will be input in the "national" format for `US` (`(213) 373-4253`).
     * But if both `country="US"` and `international={true}` properties are passed then
     * the phone number will be input in the "international" format for `US` (`213 373 4253`)
     * (without "country calling code" `+1`).
     */
    international: index$4.propTypes.bool,

    /**
     * If `country` and `international` properties are set,
     * then by default it won't include "country calling code" in the input field.
     * To change that, pass `withCountryCallingCode` property,
     * and it will include "country calling code" in the input field.
     */
    withCountryCallingCode: index$4.propTypes.bool,

    /**
     * `libphonenumber-js` metadata.
     */
    metadata: index$4.propTypes.object.isRequired
  };
  InputSmart.defaultProps = {
    metadata: defaultMetadata
  };
  return InputSmart;
}
var InputSmart = createInput();

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

function _objectWithoutProperties$2(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$2(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$2(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function createInput$1(defaultMetadata) {
  /**
   * `InputBasic`'s caret is not as "smart" as the default `inputComponent`'s
   * but still works good enough. When erasing or inserting digits in the middle
   * of a phone number the caret usually jumps to the end: this is the expected
   * behaviour and it's the workaround for the [Samsung Galaxy smart caret positioning bug](https://github.com/catamphetamine/react-phone-number-input/issues/75).
   */
  function InputBasic(_ref, ref) {
    var value = _ref.value,
        onChange = _ref.onChange,
        country = _ref.country,
        international = _ref.international,
        withCountryCallingCode = _ref.withCountryCallingCode,
        metadata = _ref.metadata,
        Input = _ref.inputComponent,
        rest = _objectWithoutProperties$2(_ref, ["value", "onChange", "country", "international", "withCountryCallingCode", "metadata", "inputComponent"]);

    var prefix = getInputValuePrefix({
      country: country,
      international: international,
      withCountryCallingCode: withCountryCallingCode,
      metadata: metadata
    });

    var _onChange = React.useCallback(function (event) {
      var newValue = parseIncompletePhoneNumber(event.target.value); // By default, if a value is something like `"(123)"`
      // then Backspace would only erase the rightmost brace
      // becoming something like `"(123"`
      // which would give the same `"123"` value
      // which would then be formatted back to `"(123)"`
      // and so a user wouldn't be able to erase the phone number.
      // Working around this issue with this simple hack.

      if (newValue === value) {
        var newValueFormatted = format$1(prefix, newValue, country, metadata);

        if (newValueFormatted.indexOf(event.target.value) === 0) {
          // Trim the last digit (or plus sign).
          newValue = newValue.slice(0, -1);
        }
      }

      onChange(newValue);
    }, [prefix, value, onChange, country, metadata]);

    return React__default.createElement(Input, _extends$2({}, rest, {
      ref: ref,
      value: format$1(prefix, value, country, metadata),
      onChange: _onChange
    }));
  }

  InputBasic = React__default.forwardRef(InputBasic);
  InputBasic.propTypes = {
    /**
     * The parsed phone number.
     * "Parsed" not in a sense of "E.164"
     * but rather in a sense of "having only
     * digits and possibly a leading plus character".
     * Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */
    value: index$4.propTypes.string.isRequired,

    /**
     * Updates the `value`.
     */
    onChange: index$4.propTypes.func.isRequired,

    /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * Perhaps the `country` property should have been called `defaultCountry`
     * because if `value` is an international number then `country` is ignored.
     */
    country: index$4.propTypes.string,

    /**
     * If `country` property is passed along with `international={true}` property
     * then the phone number will be input in "international" format for that `country`
     * (without "country calling code").
     * For example, if `country="US"` property is passed to "without country select" input
     * then the phone number will be input in the "national" format for `US` (`(213) 373-4253`).
     * But if both `country="US"` and `international={true}` properties are passed then
     * the phone number will be input in the "international" format for `US` (`213 373 4253`)
     * (without "country calling code" `+1`).
     */
    international: index$4.propTypes.bool,

    /**
     * If `country` and `international` properties are set,
     * then by default it won't include "country calling code" in the input field.
     * To change that, pass `withCountryCallingCode` property,
     * and it will include "country calling code" in the input field.
     */
    withCountryCallingCode: index$4.propTypes.bool,

    /**
     * `libphonenumber-js` metadata.
     */
    metadata: index$4.propTypes.object.isRequired,

    /**
     * The `<input/>` component.
     */
    inputComponent: index$4.propTypes.elementType.isRequired
  };
  InputBasic.defaultProps = {
    metadata: defaultMetadata,
    inputComponent: 'input'
  };
  return InputBasic;
}
var InputBasic = createInput$1();

function format$1(prefix, value, country, metadata) {
  return removeInputValuePrefix(formatIncompletePhoneNumber(prefix + value, country, metadata), prefix);
}

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

function _objectWithoutProperties$3(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$3(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$3(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
// `<img/>` is wrapped in a `<div/>` to prevent SVGs from exploding in size in IE 11.
// https://github.com/catamphetamine/react-phone-number-input/issues/111

function FlagComponent(_ref) {
  var country = _ref.country,
      countryName = _ref.countryName,
      flags = _ref.flags,
      flagUrl = _ref.flagUrl,
      rest = _objectWithoutProperties$3(_ref, ["country", "countryName", "flags", "flagUrl"]);

  if (flags && flags[country]) {
    return flags[country]({
      title: countryName
    });
  }

  return React__default.createElement("img", _extends$3({}, rest, {
    alt: countryName,
    role: countryName ? undefined : "presentation",
    src: flagUrl.replace('{XX}', country).replace('{xx}', country.toLowerCase())
  }));
}
FlagComponent.propTypes = {
  // The country to be selected by default.
  // Two-letter country code ("ISO 3166-1 alpha-2").
  country: index$4.propTypes.string.isRequired,
  // Will be HTML `title` attribute of the `<img/>`.
  countryName: index$4.propTypes.string.isRequired,
  // Country flag icon components.
  // By default flag icons are inserted as `<img/>`s
  // with their `src` pointed to `country-flag-icons` gitlab pages website.
  // There might be cases (e.g. an offline application)
  // where having a large (3 megabyte) `<svg/>` flags
  // bundle is more appropriate.
  // `import flags from 'react-phone-number-input/flags'`.
  flags: index$4.propTypes.objectOf(index$4.propTypes.elementType),
  // A URL for a country flag icon.
  // By default it points to `country-flag-icons` gitlab pages website.
  flagUrl: index$4.propTypes.string.isRequired
};

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

function _objectWithoutProperties$4(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$4(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$4(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function InternationalIcon(_ref) {
  var aspectRatio = _ref.aspectRatio,
      rest = _objectWithoutProperties$4(_ref, ["aspectRatio"]);

  if (aspectRatio === 1) {
    return React__default.createElement(InternationalIcon1x1, rest);
  } else {
    return React__default.createElement(InternationalIcon3x2, rest);
  }
}
InternationalIcon.propTypes = {
  title: index$4.propTypes.string.isRequired,
  aspectRatio: index$4.propTypes.number
}; // 3x2.
// Using `<title/>` in `<svg/>`s:
// https://developer.mozilla.org/en-US/docs/Web/SVG/Element/title

function InternationalIcon3x2(_ref2) {
  var title = _ref2.title,
      rest = _objectWithoutProperties$4(_ref2, ["title"]);

  return React__default.createElement("svg", _extends$4({}, rest, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 50"
  }), React__default.createElement("title", null, title), React__default.createElement("g", {
    className: "PhoneInputInternationalIconGlobe",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "2",
    strokeMiterlimit: "10"
  }, React__default.createElement("path", {
    strokeLinecap: "round",
    d: "M47.2,36.1C48.1,36,49,36,50,36c7.4,0,14,1.7,18.5,4.3"
  }), React__default.createElement("path", {
    d: "M68.6,9.6C64.2,12.3,57.5,14,50,14c-7.4,0-14-1.7-18.5-4.3"
  }), React__default.createElement("line", {
    x1: "26",
    y1: "25",
    x2: "74",
    y2: "25"
  }), React__default.createElement("line", {
    x1: "50",
    y1: "1",
    x2: "50",
    y2: "49"
  }), React__default.createElement("path", {
    strokeLinecap: "round",
    d: "M46.3,48.7c1.2,0.2,2.5,0.3,3.7,0.3c13.3,0,24-10.7,24-24S63.3,1,50,1S26,11.7,26,25c0,2,0.3,3.9,0.7,5.8"
  }), React__default.createElement("path", {
    strokeLinecap: "round",
    d: "M46.8,48.2c1,0.6,2.1,0.8,3.2,0.8c6.6,0,12-10.7,12-24S56.6,1,50,1S38,11.7,38,25c0,1.4,0.1,2.7,0.2,4c0,0.1,0,0.2,0,0.2"
  })), React__default.createElement("path", {
    className: "PhoneInputInternationalIconPhone",
    stroke: "none",
    fill: "currentColor",
    d: "M12.4,17.9c2.9-2.9,5.4-4.8,0.3-11.2S4.1,5.2,1.3,8.1C-2,11.4,1.1,23.5,13.1,35.6s24.3,15.2,27.5,11.9c2.8-2.8,7.8-6.3,1.4-11.5s-8.3-2.6-11.2,0.3c-2,2-7.2-2.2-11.7-6.7S10.4,19.9,12.4,17.9z"
  }));
}

InternationalIcon3x2.propTypes = {
  title: index$4.propTypes.string.isRequired
}; // 1x1.
// Using `<title/>` in `<svg/>`s:
// https://developer.mozilla.org/en-US/docs/Web/SVG/Element/title

function InternationalIcon1x1(_ref3) {
  var title = _ref3.title,
      rest = _objectWithoutProperties$4(_ref3, ["title"]);

  return React__default.createElement("svg", _extends$4({}, rest, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }), React__default.createElement("title", null, title), React__default.createElement("g", {
    className: "PhoneInputInternationalIconGlobe",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "2",
    strokeLinecap: "round"
  }, React__default.createElement("path", {
    d: "M8.45,13A21.44,21.44,0,1,1,37.08,41.56"
  }), React__default.createElement("path", {
    d: "M19.36,35.47a36.9,36.9,0,0,1-2.28-13.24C17.08,10.39,21.88.85,27.8.85s10.72,9.54,10.72,21.38c0,6.48-1.44,12.28-3.71,16.21"
  }), React__default.createElement("path", {
    d: "M17.41,33.4A39,39,0,0,1,27.8,32.06c6.62,0,12.55,1.5,16.48,3.86"
  }), React__default.createElement("path", {
    d: "M44.29,8.53c-3.93,2.37-9.86,3.88-16.49,3.88S15.25,10.9,11.31,8.54"
  }), React__default.createElement("line", {
    x1: "27.8",
    y1: "0.85",
    x2: "27.8",
    y2: "34.61"
  }), React__default.createElement("line", {
    x1: "15.2",
    y1: "22.23",
    x2: "49.15",
    y2: "22.23"
  })), React__default.createElement("path", {
    className: "PhoneInputInternationalIconPhone",
    stroke: "transparent",
    fill: "currentColor",
    d: "M9.42,26.64c2.22-2.22,4.15-3.59.22-8.49S3.08,17,.93,19.17c-2.49,2.48-.13,11.74,9,20.89s18.41,11.5,20.89,9c2.15-2.15,5.91-4.77,1-8.71s-6.27-2-8.49.22c-1.55,1.55-5.48-1.69-8.86-5.08S7.87,28.19,9.42,26.64Z"
  }));
}

InternationalIcon1x1.propTypes = {
  title: index$4.propTypes.string.isRequired
};

/**
 * Sorts country `<select/>` options.
 * Can move some country `<select/>` options
 * to the top of the list, for example.
 * @param  {object[]} countryOptions — Country `<select/>` options.
 * @param  {string[]} [countryOptionsOrder] — Country `<select/>` options order. Example: `["US", "CA", "AU", "|", "..."]`.
 * @return {object[]}
 */

function sortCountryOptions(options, order) {
  if (!order) {
    return options;
  }

  var optionsOnTop = [];
  var optionsOnBottom = [];
  var appendTo = optionsOnTop;

  for (var _iterator = order, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var element = _ref;

    if (element === '|') {
      appendTo.push({
        divider: true
      });
    } else if (element === '...' || element === '…') {
      appendTo = optionsOnBottom;
    } else {
      (function () {
        var countryCode = void 0;

        if (element === '🌐') {
          countryCode = undefined;
        } else {
          countryCode = element;
        } // Find the position of the option.


        var index = options.indexOf(options.filter(function (option) {
          return option.value === countryCode;
        })[0]); // Get the option.

        var option = options[index]; // Remove the option from its default position.

        options.splice(index, 1); // Add the option on top.

        appendTo.push(option);
      })();
    }
  }

  return optionsOnTop.concat(options).concat(optionsOnBottom);
}
function getSupportedCountryOptions(countryOptions, metadata) {
  if (countryOptions) {
    countryOptions = countryOptions.filter(function (option) {
      switch (option) {
        case '🌐':
        case '|':
        case '...':
        case '…':
          return true;

        default:
          return isCountrySupportedWithError(option, metadata);
      }
    });

    if (countryOptions.length > 0) {
      return countryOptions;
    }
  }
}
function isCountrySupportedWithError(country, metadata) {
  if (isSupportedCountry(country, metadata)) {
    return true;
  } else {
    console.error("Country not found: ".concat(country));
    return false;
  }
}
function getSupportedCountries(countries, metadata) {
  if (countries) {
    countries = countries.filter(function (country) {
      return isCountrySupportedWithError(country, metadata);
    });

    if (countries.length === 0) {
      countries = undefined;
    }
  }

  return countries;
}

function createCountryIconComponent(_ref) {
  var flags = _ref.flags,
      flagUrl = _ref.flagUrl,
      FlagComponent = _ref.flagComponent,
      InternationalIcon$1 = _ref.internationalIcon;

  function CountryIcon(_ref2) {
    var country = _ref2.country,
        label = _ref2.label,
        aspectRatio = _ref2.aspectRatio;

    // `aspectRatio` is currently a hack for the default "International" icon
    // to render it as a square when Unicode flag icons are used.
    // So `aspectRatio` property is only used with the default "International" icon.
    var _aspectRatio = InternationalIcon$1 === InternationalIcon ? aspectRatio : undefined;

    return React__default.createElement("div", {
      className: classnames('PhoneInputCountryIcon', {
        'PhoneInputCountryIcon--square': _aspectRatio === 1,
        'PhoneInputCountryIcon--border': country
      })
    }, country ? React__default.createElement(FlagComponent, {
      country: country,
      countryName: label,
      flags: flags,
      flagUrl: flagUrl,
      className: "PhoneInputCountryIconImg"
    }) : React__default.createElement(InternationalIcon$1, {
      title: label,
      aspectRatio: _aspectRatio,
      className: "PhoneInputCountryIconImg"
    }));
  }

  CountryIcon.propTypes = {
    country: index$4.propTypes.string,
    label: index$4.propTypes.string.isRequired,
    aspectRatio: index$4.propTypes.number
  };
  return CountryIcon;
}
createCountryIconComponent({
  // Must be equal to `defaultProps.flagUrl` in `./PhoneInputWithCountry.js`.
  flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg',
  flagComponent: FlagComponent,
  internationalIcon: InternationalIcon
});

var metadata$1 = index$4.propTypes.shape({
  country_calling_codes: index$4.propTypes.object.isRequired,
  countries: index$4.propTypes.object.isRequired
});
var labels = index$4.propTypes.objectOf(index$4.propTypes.string);

var ONLY_DIGITS_REGEXP = /^\d+$/;
function getInternationalPhoneNumberPrefix(country, metadata) {
  // Standard international phone number prefix: "+" and "country calling code".
  var prefix = '+' + getCountryCallingCode(country, metadata); // Get "leading digits" for a phone number of the country.
  // If there're "leading digits" then they can be part of the prefix too.

  metadata = new Metadata(metadata);
  metadata.country(country);

  if (metadata.numberingPlan.leadingDigits() && ONLY_DIGITS_REGEXP.test(metadata.numberingPlan.leadingDigits())) {
    prefix += metadata.numberingPlan.leadingDigits();
  }

  return prefix;
}

/**
 * Decides which country should be pre-selected
 * when the phone number input component is first mounted.
 * @param  {object?} phoneNumber - An instance of `PhoneNumber` class.
 * @param  {string?} country - Pre-defined country (two-letter code).
 * @param  {string[]?} countries - A list of countries available.
 * @param  {object} metadata - `libphonenumber-js` metadata
 * @return {string?}
 */

function getPreSelectedCountry(_ref) {
  var value = _ref.value,
      phoneNumber = _ref.phoneNumber,
      defaultCountry = _ref.defaultCountry,
      getAnyCountry = _ref.getAnyCountry,
      countries = _ref.countries,
      required = _ref.required,
      metadata = _ref.metadata;
  var country; // If can get country from E.164 phone number
  // then it overrides the `country` passed (or not passed).

  if (phoneNumber && phoneNumber.country) {
    // `country` will be left `undefined` in case of non-detection.
    country = phoneNumber.country;
  } else if (defaultCountry) {
    if (!value || couldNumberBelongToCountry(value, defaultCountry, metadata)) {
      country = defaultCountry;
    }
  } // Only pre-select a country if it's in the available `countries` list.


  if (countries && countries.indexOf(country) < 0) {
    country = undefined;
  } // If there will be no "International" option
  // then some `country` must be selected.
  // It will still be the wrong country though.
  // But still country `<select/>` can't be left in a broken state.


  if (!country && required && countries && countries.length > 0) {
    country = getAnyCountry(); // noCountryMatchesTheNumber = true
  }

  return country;
}
/**
 * Generates a sorted list of country `<select/>` options.
 * @param  {string[]} countries - A list of two-letter ("ISO 3166-1 alpha-2") country codes.
 * @param  {object} labels - Custom country labels. E.g. `{ RU: 'Россия', US: 'США', ... }`.
 * @param  {boolean} addInternationalOption - Whether should include "International" option at the top of the list.
 * @return {object[]} A list of objects having shape `{ value : string, label : string }`.
 */

function getCountrySelectOptions(_ref2) {
  var countries = _ref2.countries,
      countryNames = _ref2.countryNames,
      addInternationalOption = _ref2.addInternationalOption,
      compareStringsLocales = _ref2.compareStringsLocales,
      _compareStrings = _ref2.compareStrings;

  // Default country name comparator uses `String.localeCompare()`.
  if (!_compareStrings) {
    _compareStrings = compareStrings;
  } // Generates a `<Select/>` option for each country.


  var countrySelectOptions = countries.map(function (country) {
    return {
      value: country,
      // All `locale` country names included in this library
      // include all countries (this is checked at build time).
      // The only case when a country name might be missing
      // is when a developer supplies their own `labels` property.
      // To guard against such cases, a missing country name
      // is substituted by country code.
      label: countryNames[country] || country
    };
  }); // Sort the list of countries alphabetically.

  countrySelectOptions.sort(function (a, b) {
    return _compareStrings(a.label, b.label, compareStringsLocales);
  }); // Add the "International" option to the country list (if suitable)

  if (addInternationalOption) {
    countrySelectOptions.unshift({
      label: countryNames.ZZ
    });
  }

  return countrySelectOptions;
}
/**
 * Parses a E.164 phone number to an instance of `PhoneNumber` class.
 * @param {string?} value = E.164 phone number.
 * @param  {object} metadata - `libphonenumber-js` metadata
 * @return {object} Object having shape `{ country: string?, countryCallingCode: string, number: string }`. `PhoneNumber`: https://gitlab.com/catamphetamine/libphonenumber-js#phonenumber.
 * @example
 * parsePhoneNumber('+78005553535')
 */

function parsePhoneNumber$2(value, metadata) {
  return parsePhoneNumberFromString$1(value || '', metadata);
}
/**
 * Generates national number digits for a parsed phone.
 * May prepend national prefix.
 * The phone number must be a complete and valid phone number.
 * @param  {object} phoneNumber - An instance of `PhoneNumber` class.
 * @param  {object} metadata - `libphonenumber-js` metadata
 * @return {string}
 * @example
 * getNationalNumberDigits({ country: 'RU', phone: '8005553535' })
 * // returns '88005553535'
 */

function generateNationalNumberDigits(phoneNumber) {
  return phoneNumber.formatNational().replace(/\D/g, '');
}
/**
 * Migrates parsed `<input/>` `value` for the newly selected `country`.
 * @param {string?} phoneDigits - Phone number digits (and `+`) parsed from phone number `<input/>` (it's not the same as the `value` property).
 * @param {string?} prevCountry - Previously selected country.
 * @param {string?} newCountry - Newly selected country. Can't be same as previously selected country.
 * @param {object} metadata - `libphonenumber-js` metadata.
 * @param {boolean} useNationalFormat - whether should attempt to convert from international to national number for the new country.
 * @return {string?}
 */

function getPhoneDigitsForNewCountry(phoneDigits, _ref3) {
  var prevCountry = _ref3.prevCountry,
      newCountry = _ref3.newCountry,
      metadata = _ref3.metadata,
      useNationalFormat = _ref3.useNationalFormat;

  // If `parsed_input` is empty
  // then no need to migrate anything.
  if (!phoneDigits) {
    if (useNationalFormat) {
      return '';
    } else {
      // If `phoneDigits` is empty then set `phoneDigits` to
      // `+{getCountryCallingCode(newCountry)}`.
      return getInternationalPhoneNumberPrefix(newCountry, metadata);
    }
  } // If switching to some country.
  // (from "International" or another country)
  // If switching from "International" then `phoneDigits` starts with a `+`.
  // Otherwise it may or may not start with a `+`.


  if (newCountry) {
    // If the phone number was entered in international format
    // then migrate it to the newly selected country.
    // The phone number may be incomplete.
    // The phone number entered not necessarily starts with
    // the previously selected country phone prefix.
    if (phoneDigits[0] === '+') {
      // If the international phone number is for the new country
      // then convert it to local if required.
      if (useNationalFormat) {
        // // If a phone number is being input in international form
        // // and the country can already be derived from it,
        // // and if it is the new country, then format as a national number.
        // const derived_country = getCountryFromPossiblyIncompleteInternationalPhoneNumber(phoneDigits, metadata)
        // if (derived_country === newCountry) {
        // 	return stripCountryCallingCode(phoneDigits, derived_country, metadata)
        // }
        // Actually, the two countries don't necessarily need to match:
        // the condition could be looser here, because several countries
        // might share the same international phone number format
        // (for example, "NANPA" countries like US, Canada, etc).
        // The looser condition would be just "same nternational phone number format"
        // which would mean "same country calling code" in the context of `libphonenumber-js`.
        if (phoneDigits.indexOf('+' + getCountryCallingCode(newCountry, metadata)) === 0) {
          return stripCountryCallingCode(phoneDigits, newCountry, metadata);
        } // Simply discard the previously entered international phone number,
        // because otherwise any "smart" transformation like getting the
        // "national (significant) number" part and then prepending the
        // newly selected country's "country calling code" to it
        // would just be confusing for a user without being actually useful.


        return ''; // // Simply strip the leading `+` character
        // // therefore simply converting all digits into a "local" phone number.
        // // https://github.com/catamphetamine/react-phone-number-input/issues/287
        // return phoneDigits.slice(1)
      }

      if (prevCountry) {
        var newCountryPrefix = getInternationalPhoneNumberPrefix(newCountry, metadata);

        if (phoneDigits.indexOf(newCountryPrefix) === 0) {
          return phoneDigits;
        } else {
          return newCountryPrefix;
        }
      } else {
        var defaultValue = getInternationalPhoneNumberPrefix(newCountry, metadata); // If `phoneDigits`'s country calling code part is the same
        // as for the new `country`, then leave `phoneDigits` as is.

        if (phoneDigits.indexOf(defaultValue) === 0) {
          return phoneDigits;
        } // If `phoneDigits`'s country calling code part is not the same
        // as for the new `country`, then set `phoneDigits` to
        // `+{getCountryCallingCode(newCountry)}`.


        return defaultValue;
      } // // If the international phone number already contains
      // // any country calling code then trim the country calling code part.
      // // (that could also be the newly selected country phone code prefix as well)
      // // `phoneDigits` doesn't neccessarily belong to `prevCountry`.
      // // (e.g. if a user enters an international number
      // //  not belonging to any of the reduced `countries` list).
      // phoneDigits = stripCountryCallingCode(phoneDigits, prevCountry, metadata)
      // // Prepend country calling code prefix
      // // for the newly selected country.
      // return e164(phoneDigits, newCountry, metadata) || `+${getCountryCallingCode(newCountry, metadata)}`

    }
  } // If switching to "International" from a country.
  else {
      // If the phone number was entered in national format.
      if (phoneDigits[0] !== '+') {
        // Format the national phone number as an international one.
        // The phone number entered not necessarily even starts with
        // the previously selected country phone prefix.
        // Even if the phone number belongs to whole another country
        // it will still be parsed into some national phone number.
        return e164(phoneDigits, prevCountry, metadata) || '';
      }
    }

  return phoneDigits;
}
/**
 * Converts phone number digits to a (possibly incomplete) E.164 phone number.
 * @param  {string?} number - A possibly incomplete phone number digits string. Can be a possibly incomplete E.164 phone number.
 * @param  {string?} country
 * @param  {[object} metadata - `libphonenumber-js` metadata.
 * @return {string?}
 */

function e164(number, country, metadata) {
  if (!number) {
    return;
  } // If the phone number is being input in international format.


  if (number[0] === '+') {
    // If it's just the `+` sign then return nothing.
    if (number === '+') {
      return;
    } // If there are any digits then the `value` is returned as is.


    return number;
  } // For non-international phone numbers
  // an accompanying country code is required.


  if (!country) {
    return;
  }

  var partial_national_significant_number = getNationalSignificantNumberDigits(number, country, metadata);

  if (partial_national_significant_number) {
    return "+".concat(getCountryCallingCode(country, metadata)).concat(partial_national_significant_number);
  }
}
/**
 * Trims phone number digits if they exceed the maximum possible length
 * for a national (significant) number for the country.
 * @param  {string} number - A possibly incomplete phone number digits string. Can be a possibly incomplete E.164 phone number.
 * @param  {string} country
 * @param  {object} metadata - `libphonenumber-js` metadata.
 * @return {string} Can be empty.
 */

function trimNumber(number, country, metadata) {
  var nationalSignificantNumberPart = getNationalSignificantNumberDigits(number, country, metadata);

  if (nationalSignificantNumberPart) {
    var overflowDigitsCount = nationalSignificantNumberPart.length - getMaxNumberLength(country, metadata);

    if (overflowDigitsCount > 0) {
      return number.slice(0, number.length - overflowDigitsCount);
    }
  }

  return number;
}

function getMaxNumberLength(country, metadata) {
  // Get "possible lengths" for a phone number of the country.
  metadata = new Metadata(metadata);
  metadata.country(country); // Return the last "possible length".

  return metadata.numberingPlan.possibleLengths()[metadata.numberingPlan.possibleLengths().length - 1];
} // If the phone number being input is an international one
// then tries to derive the country from the phone number.
// (regardless of whether there's any country currently selected)

/**
 * @param {string} partialE164Number - A possibly incomplete E.164 phone number.
 * @param {string?} country - Currently selected country.
 * @param {string[]?} countries - A list of available countries. If not passed then "all countries" are assumed.
 * @param  {object} metadata - `libphonenumber-js` metadata.
 * @return {string?}
 */


function getCountryForPartialE164Number(partialE164Number, _ref4) {
  var country = _ref4.country,
      countries = _ref4.countries,
      required = _ref4.required,
      metadata = _ref4.metadata;

  if (partialE164Number === '+') {
    // Don't change the currently selected country yet.
    return country;
  }

  var derived_country = getCountryFromPossiblyIncompleteInternationalPhoneNumber(partialE164Number, metadata); // If a phone number is being input in international form
  // and the country can already be derived from it,
  // then select that country.

  if (derived_country && (!countries || countries.indexOf(derived_country) >= 0)) {
    return derived_country;
  } // If "International" country option has not been disabled
  // and the international phone number entered doesn't correspond
  // to the currently selected country then reset the currently selected country.
  else if (country && !required && !couldNumberBelongToCountry(partialE164Number, country, metadata)) {
      return undefined;
    } // Don't change the currently selected country.


  return country;
}
/**
 * Parses `<input/>` value. Derives `country` from `input`. Derives an E.164 `value`.
 * @param  {string?} phoneDigits — Parsed `<input/>` value. Examples: `""`, `"+"`, `"+123"`, `"123"`.
 * @param  {string?} prevPhoneDigits — Previous parsed `<input/>` value. Examples: `""`, `"+"`, `"+123"`, `"123"`.
 * @param  {string?} country - Currently selected country.
 * @param  {boolean} countryRequired - Is selecting some country required.
 * @param  {function} getAnyCountry - Can be used to get any country when selecting some country required.
 * @param  {string[]?} countries - A list of available countries. If not passed then "all countries" are assumed.
 * @param  {boolean} international - Set to `true` to force international phone number format (leading `+`). Set to `false` to force "national" phone number format. Is `undefined` by default.
 * @param  {boolean} limitMaxLength — Whether to enable limiting phone number max length.
 * @param  {object} metadata - `libphonenumber-js` metadata.
 * @return {object} An object of shape `{ input, country, value }`.
 */

function onPhoneDigitsChange(phoneDigits, _ref5) {
  var prevPhoneDigits = _ref5.prevPhoneDigits,
      country = _ref5.country,
      defaultCountry = _ref5.defaultCountry,
      countryRequired = _ref5.countryRequired,
      getAnyCountry = _ref5.getAnyCountry,
      countries = _ref5.countries,
      international = _ref5.international,
      limitMaxLength = _ref5.limitMaxLength,
      countryCallingCodeEditable = _ref5.countryCallingCodeEditable,
      metadata = _ref5.metadata;

  if (international && countryCallingCodeEditable === false) {
    var prefix = getInternationalPhoneNumberPrefix(country, metadata); // The `<input/>` value must start with the country calling code.

    if (phoneDigits.indexOf(prefix) !== 0) {
      var _value; // If a phone number input is declared as
      // `international` and `withCountryCallingCode`,
      // then it's gonna be non-empty even before the user
      // has input anything in it.
      // This will result in its contents (the country calling code part)
      // being selected when the user tabs into such field.
      // If the user then starts inputting the national part digits,
      // then `<input/>` value changes from `+xxx` to `y`
      // because inputting anything while having the `<input/>` value
      // selected results in erasing the `<input/>` value
      // So, the component handles such case by restoring
      // the intended `<input/>`` value: `+xxxy`.
      // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/43


      if (phoneDigits && phoneDigits[0] !== '+') {
        phoneDigits = prefix + phoneDigits;
        _value = phoneDigits;
      } else {
        phoneDigits = prefix;
      }

      return {
        phoneDigits: phoneDigits,
        value: _value,
        country: country
      };
    }
  } // If `international` property is `false`, then it means
  // "enforce national-only format during input",
  // so, if that's the case, then remove all `+` characters,
  // but only if some country is currently selected.
  // (not if "International" country is selected).


  if (international === false && country && phoneDigits && phoneDigits[0] === '+') {
    phoneDigits = convertInternationalPhoneDigitsToNational(phoneDigits, country, metadata);
  } // Trim the input to not exceed the maximum possible number length.


  if (phoneDigits && country && limitMaxLength) {
    phoneDigits = trimNumber(phoneDigits, country, metadata);
  } // If this `onChange()` event was triggered
  // as a result of selecting "International" country,
  // then force-prepend a `+` sign if the phone number
  // `<input/>` value isn't in international format.
  // Also, force-prepend a `+` sign if international
  // phone number input format is set.


  if (phoneDigits && phoneDigits[0] !== '+' && (!country || international)) {
    phoneDigits = '+' + phoneDigits;
  } // If the previously entered phone number
  // has been entered in international format
  // and the user decides to erase it,
  // then also reset the `country`
  // because it was most likely automatically selected
  // while the user was typing in the phone number
  // in international format.
  // This fixes the issue when a user is presented
  // with a phone number input with no country selected
  // and then types in their local phone number
  // then discovers that the input's messed up
  // (a `+` has been prepended at the start of their input
  //  and a random country has been selected),
  // decides to undo it all by erasing everything
  // and then types in their local phone number again
  // resulting in a seemingly correct phone number
  // but in reality that phone number has incorrect country.
  // https://github.com/catamphetamine/react-phone-number-input/issues/273


  if (!phoneDigits && prevPhoneDigits && prevPhoneDigits[0] === '+') {
    if (international) {
      country = undefined;
    } else {
      country = defaultCountry;
    }
  } // Also resets such "randomly" selected country
  // as soon as the user erases the number
  // digit-by-digit up to the leading `+` sign.


  if (phoneDigits === '+' && prevPhoneDigits && prevPhoneDigits[0] === '+' && prevPhoneDigits.length > '+'.length) {
    country = undefined;
  } // Generate the new `value` property.


  var value;

  if (phoneDigits) {
    if (phoneDigits[0] === '+') {
      if (phoneDigits === '+') {
        value = undefined;
      } else if (country && getInternationalPhoneNumberPrefix(country, metadata).indexOf(phoneDigits) === 0) {
        value = undefined;
      } else {
        value = phoneDigits;
      }
    } else {
      value = e164(phoneDigits, country, metadata);
    }
  } // Derive the country from the phone number.
  // (regardless of whether there's any country currently selected,
  //  because there could be several countries corresponding to one country calling code)


  if (value) {
    country = getCountryForPartialE164Number(value, {
      country: country,
      countries: countries,
      metadata: metadata
    }); // If `international` property is `false`, then it means
    // "enforce national-only format during input",
    // so, if that's the case, then remove all `+` characters,
    // but only if some country is currently selected.
    // (not if "International" country is selected).

    if (international === false && country && phoneDigits && phoneDigits[0] === '+') {
      phoneDigits = convertInternationalPhoneDigitsToNational(phoneDigits, country, metadata); // Re-calculate `value` because `phoneDigits` has changed.

      value = e164(phoneDigits, country, metadata);
    }
  }

  if (!country && countryRequired) {
    country = defaultCountry || getAnyCountry();
  }

  return {
    phoneDigits: phoneDigits,
    country: country,
    value: value
  };
}

function convertInternationalPhoneDigitsToNational(input, country, metadata) {
  // Handle the case when a user might have pasted
  // a phone number in international format.
  if (input.indexOf(getInternationalPhoneNumberPrefix(country, metadata)) === 0) {
    // Create "as you type" formatter.
    var formatter = new AsYouType(country, metadata); // Input partial national phone number.

    formatter.input(input); // Return the parsed partial national phone number.

    var phoneNumber = formatter.getNumber();

    if (phoneNumber) {
      // Transform the number to a national one,
      // and remove all non-digits.
      return phoneNumber.formatNational().replace(/\D/g, '');
    } else {
      return '';
    }
  } else {
    // Just remove the `+` sign.
    return input.replace(/\D/g, '');
  }
}
/**
 * Determines the country for a given (possibly incomplete) E.164 phone number.
 * @param  {string} number - A possibly incomplete E.164 phone number.
 * @param  {object} metadata - `libphonenumber-js` metadata.
 * @return {string?}
 */


function getCountryFromPossiblyIncompleteInternationalPhoneNumber(number, metadata) {
  var formatter = new AsYouType(null, metadata);
  formatter.input(number); // // `001` is a special "non-geograpical entity" code
  // // in Google's `libphonenumber` library.
  // if (formatter.getCountry() === '001') {
  // 	return
  // }

  return formatter.getCountry();
}
/**
 * Compares two strings.
 * A helper for `Array.sort()`.
 * @param {string} a — First string.
 * @param {string} b — Second string.
 * @param {(string[]|string)} [locales] — The `locales` argument of `String.localeCompare`.
 */

function compareStrings(a, b, locales) {
  // Use `String.localeCompare` if it's available.
  // https://developer.mozilla.org/ru/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare
  // Which means everyone except IE <= 10 and Safari <= 10.
  // `localeCompare()` is available in latest Node.js versions.

  /* istanbul ignore else */
  if (String.prototype.localeCompare) {
    return a.localeCompare(b, locales);
  }
  /* istanbul ignore next */


  return a < b ? -1 : a > b ? 1 : 0;
}
/**
 * Strips `+${countryCallingCode}` prefix from an E.164 phone number.
 * @param {string} number - (possibly incomplete) E.164 phone number.
 * @param {string?} country - A possible country for this phone number.
 * @param {object} metadata - `libphonenumber-js` metadata.
 * @return {string}
 */

function stripCountryCallingCode(number, country, metadata) {
  // Just an optimization, so that it
  // doesn't have to iterate through all country calling codes.
  if (country) {
    var countryCallingCodePrefix = '+' + getCountryCallingCode(country, metadata); // If `country` fits the actual `number`.

    if (number.length < countryCallingCodePrefix.length) {
      if (countryCallingCodePrefix.indexOf(number) === 0) {
        return '';
      }
    } else {
      if (number.indexOf(countryCallingCodePrefix) === 0) {
        return number.slice(countryCallingCodePrefix.length);
      }
    }
  } // If `country` doesn't fit the actual `number`.
  // Try all available country calling codes.


  for (var _i = 0, _Object$keys = Object.keys(metadata.country_calling_codes); _i < _Object$keys.length; _i++) {
    var country_calling_code = _Object$keys[_i];

    if (number.indexOf(country_calling_code) === '+'.length) {
      return number.slice('+'.length + country_calling_code.length);
    }
  }

  return '';
}
/**
 * Parses a partially entered national phone number digits
 * (or a partially entered E.164 international phone number)
 * and returns the national significant number part.
 * National significant number returned doesn't come with a national prefix.
 * @param {string} number - National number digits. Or possibly incomplete E.164 phone number.
 * @param {string?} country
 * @param {object} metadata - `libphonenumber-js` metadata.
 * @return {string} [result]
 */

function getNationalSignificantNumberDigits(number, country, metadata) {
  // Create "as you type" formatter.
  var formatter = new AsYouType(country, metadata); // Input partial national phone number.

  formatter.input(number); // Return the parsed partial national phone number.

  var phoneNumber = formatter.getNumber();
  return phoneNumber && phoneNumber.nationalNumber;
}
/**
 * Checks if a partially entered E.164 phone number could belong to a country.
 * @param  {string} number
 * @param  {string} country
 * @return {boolean}
 */

function couldNumberBelongToCountry(number, country, metadata) {
  var intlPhoneNumberPrefix = getInternationalPhoneNumberPrefix(country, metadata);
  var i = 0;

  while (i < number.length && i < intlPhoneNumberPrefix.length) {
    if (number[i] !== intlPhoneNumberPrefix[i]) {
      return false;
    }

    i++;
  }

  return true;
}
/**
 * Gets initial "phone digits" (including `+`, if using international format).
 * @return {string} [phoneDigits] Returns `undefined` if there should be no initial "phone digits".
 */

function getInitialPhoneDigits(_ref6) {
  var value = _ref6.value,
      phoneNumber = _ref6.phoneNumber,
      defaultCountry = _ref6.defaultCountry,
      international = _ref6.international,
      useNationalFormat = _ref6.useNationalFormat,
      metadata = _ref6.metadata;

  // If the `value` (E.164 phone number)
  // belongs to the currently selected country
  // and `useNationalFormat` is `true`
  // then convert `value` (E.164 phone number)
  // to a local phone number digits.
  // E.g. '+78005553535' -> '88005553535'.
  if ((international === false || useNationalFormat) && phoneNumber && phoneNumber.country) {
    return generateNationalNumberDigits(phoneNumber);
  } // If `international` property is `true`,
  // meaning "enforce international phone number format",
  // then always show country calling code in the input field.


  if (!value && international && defaultCountry) {
    return getInternationalPhoneNumberPrefix(defaultCountry, metadata);
  }

  return value;
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty$7(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$7(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function getPhoneInputWithCountryStateUpdateFromNewProps(props, prevProps, state) {
  var metadata = props.metadata,
      countries = props.countries,
      newDefaultCountry = props.defaultCountry,
      newValue = props.value,
      newReset = props.reset,
      international = props.international,
      displayInitialValueAsLocalNumber = props.displayInitialValueAsLocalNumber,
      initialValueFormat = props.initialValueFormat;
  var prevDefaultCountry = prevProps.defaultCountry,
      prevValue = prevProps.value,
      prevReset = prevProps.reset;
  var country = state.country,
      value = state.value,
      hasUserSelectedACountry = state.hasUserSelectedACountry;

  var _getInitialPhoneDigits = function _getInitialPhoneDigits(parameters) {
    return getInitialPhoneDigits(_objectSpread$5({}, parameters, {
      international: international,
      useNationalFormat: displayInitialValueAsLocalNumber || initialValueFormat === 'national',
      metadata: metadata
    }));
  }; // Some users requested a way to reset the component
  // (both number `<input/>` and country `<select/>`).
  // Whenever `reset` property changes both number `<input/>`
  // and country `<select/>` are reset.
  // It's not implemented as some instance `.reset()` method
  // because `ref` is forwarded to `<input/>`.
  // It's also not replaced with just resetting `country` on
  // external `value` reset, because a user could select a country
  // and then not input any `value`, and so the selected country
  // would be "stuck", if not using this `reset` property.
  // https://github.com/catamphetamine/react-phone-number-input/issues/300


  if (newReset !== prevReset) {
    return {
      phoneDigits: _getInitialPhoneDigits({
        value: undefined,
        defaultCountry: newDefaultCountry
      }),
      value: undefined,
      country: newDefaultCountry,
      hasUserSelectedACountry: undefined
    };
  } // `value` is the value currently shown in the component:
  // it's stored in the component's `state`, and it's not the `value` property.
  // `prevValue` is "previous `value` property".
  // `newValue` is "new `value` property".
  // If the default country changed
  // (e.g. in case of ajax GeoIP detection after page loaded)
  // then select it, but only if the user hasn't already manually
  // selected a country, and no phone number has been manually entered so far.
  // Because if the user has already started inputting a phone number
  // then they're okay with no country being selected at all ("International")
  // and they don't want to be disturbed, don't want their input to be screwed, etc.


  if (newDefaultCountry !== prevDefaultCountry) {
    var isNewDefaultCountrySupported = !newDefaultCountry || isCountrySupportedWithError(newDefaultCountry, metadata);

    var noValueHasBeenEnteredByTheUser = // By default, "no value has been entered" means `value` is `undefined`.
    !value || // When `international` is `true`, and some country has been pre-selected,
    // then the `<input/>` contains a pre-filled value of `+${countryCallingCode}${leadingDigits}`,
    // so in case of `international` being `true`, "the user hasn't entered anything" situation
    // doesn't just mean `value` is `undefined`, but could also mean `value` is `+${countryCallingCode}`.
    international && value === _getInitialPhoneDigits({
      value: undefined,
      defaultCountry: prevDefaultCountry
    }); // Only update the `defaultCountry` property if no phone number
    // has been entered by the user or pre-set by the application.


    var noValueHasBeenEntered = !newValue && noValueHasBeenEnteredByTheUser;

    if (!hasUserSelectedACountry && isNewDefaultCountrySupported && noValueHasBeenEntered) {
      return {
        country: newDefaultCountry,
        // If `phoneDigits` is empty, then automatically select the new `country`
        // and set `phoneDigits` to `+{getCountryCallingCode(newCountry)}`.
        // The code assumes that "no phone number has been entered by the user",
        // and no `value` property has been passed, so the `phoneNumber` parameter
        // of `_getInitialPhoneDigits({ value, phoneNumber, ... })` is `undefined`.
        phoneDigits: _getInitialPhoneDigits({
          value: undefined,
          defaultCountry: newDefaultCountry
        }),
        // `value` is `undefined` and it stays so.
        value: undefined
      };
    }
  } // If a new `value` is set externally.
  // (e.g. as a result of an ajax API request
  //  to get user's phone after page loaded)
  // The first part — `newValue !== prevValue` —
  // is basically `props.value !== prevProps.value`
  // so it means "if value property was changed externally".
  // The second part — `newValue !== value` —
  // is for ignoring the `getDerivedStateFromProps()` call
  // which happens in `this.onChange()` right after `this.setState()`.
  // If this `getDerivedStateFromProps()` call isn't ignored
  // then the country flag would reset on each input.


  if (newValue !== prevValue && newValue !== value) {
    var phoneNumber;
    var parsedCountry;

    if (newValue) {
      phoneNumber = parsePhoneNumber$2(newValue, metadata);
      var supportedCountries = getSupportedCountries(countries, metadata);

      if (phoneNumber && phoneNumber.country) {
        // Ignore `else` because all countries are supported in metadata.

        /* istanbul ignore next */
        if (!supportedCountries || supportedCountries.indexOf(phoneNumber.country) >= 0) {
          parsedCountry = phoneNumber.country;
        }
      } else {
        parsedCountry = getCountryForPartialE164Number(newValue, {
          country: undefined,
          countries: supportedCountries,
          metadata: metadata
        });
      }
    }

    var hasUserSelectedACountryUpdate;

    if (!newValue) {
      // Reset `hasUserSelectedACountry` flag in `state`.
      hasUserSelectedACountryUpdate = {
        hasUserSelectedACountry: undefined
      };
    }

    return _objectSpread$5({}, hasUserSelectedACountryUpdate, {
      phoneDigits: _getInitialPhoneDigits({
        phoneNumber: phoneNumber,
        value: newValue,
        defaultCountry: newDefaultCountry
      }),
      value: newValue,
      country: newValue ? parsedCountry : newDefaultCountry
    });
  } // `defaultCountry` didn't change.
  // `value` didn't change.
  // `phoneDigits` didn't change, because `value` didn't change.
  //
  // So no need to update state.

}

function _typeof$3(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$3 = function _typeof(obj) { return typeof obj; }; } else { _typeof$3 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$3(obj); }

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty$8(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

function _objectWithoutProperties$5(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$5(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$5(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$7(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$6(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$6(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$6(Constructor.prototype, protoProps); if (staticProps) _defineProperties$6(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof$3(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty$8(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PhoneNumberInput_ =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(PhoneNumberInput_, _React$PureComponent);

  function PhoneNumberInput_(props) {
    var _this;

    _classCallCheck$7(this, PhoneNumberInput_);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PhoneNumberInput_).call(this, props));

    _defineProperty$8(_assertThisInitialized(_this), "inputRef", React__default.createRef());

    _defineProperty$8(_assertThisInitialized(_this), "setInputRef", function (instance) {
      _this.inputRef.current = instance;
      var ref = _this.props.inputRef;

      if (ref) {
        if (typeof ref === 'function') {
          ref(instance);
        } else {
          ref.current = instance;
        }
      }
    });

    _defineProperty$8(_assertThisInitialized(_this), "isCountrySupportedWithError", function (country) {
      var metadata = _this.props.metadata;
      return isCountrySupportedWithError(country, metadata);
    });

    _defineProperty$8(_assertThisInitialized(_this), "onCountryChange", function (newCountry) {
      var _this$props = _this.props,
          international = _this$props.international,
          metadata = _this$props.metadata,
          onChange = _this$props.onChange,
          focusInputOnCountrySelection = _this$props.focusInputOnCountrySelection;
      var _this$state = _this.state,
          prevPhoneDigits = _this$state.phoneDigits,
          prevCountry = _this$state.country; // After the new `country` has been selected,
      // if the phone number `<input/>` holds any digits
      // then migrate those digits for the new `country`.

      var newPhoneDigits = getPhoneDigitsForNewCountry(prevPhoneDigits, {
        prevCountry: prevCountry,
        newCountry: newCountry,
        metadata: metadata,
        // Convert the phone number to "national" format
        // when the user changes the selected country by hand.
        useNationalFormat: !international
      });
      var newValue = e164(newPhoneDigits, newCountry, metadata); // Focus phone number `<input/>` upon country selection.

      if (focusInputOnCountrySelection) {
        _this.inputRef.current.focus();
      } // If the user has already manually selected a country
      // then don't override that already selected country
      // if the `defaultCountry` property changes.
      // That's what `hasUserSelectedACountry` flag is for.


      _this.setState({
        country: newCountry,
        hasUserSelectedACountry: true,
        phoneDigits: newPhoneDigits,
        value: newValue
      }, function () {
        // Update the new `value` property.
        // Doing it after the `state` has been updated
        // because `onChange()` will trigger `getDerivedStateFromProps()`
        // with the new `value` which will be compared to `state.value` there.
        onChange(newValue);
      });
    });

    _defineProperty$8(_assertThisInitialized(_this), "onChange", function (_phoneDigits) {
      var _this$props2 = _this.props,
          defaultCountry = _this$props2.defaultCountry,
          onChange = _this$props2.onChange,
          addInternationalOption = _this$props2.addInternationalOption,
          international = _this$props2.international,
          limitMaxLength = _this$props2.limitMaxLength,
          countryCallingCodeEditable = _this$props2.countryCallingCodeEditable,
          metadata = _this$props2.metadata;
      var _this$state2 = _this.state,
          countries = _this$state2.countries,
          prevPhoneDigits = _this$state2.phoneDigits,
          currentlySelectedCountry = _this$state2.country;

      var _onPhoneDigitsChange = onPhoneDigitsChange(_phoneDigits, {
        prevPhoneDigits: prevPhoneDigits,
        country: currentlySelectedCountry,
        countryRequired: !addInternationalOption,
        defaultCountry: defaultCountry,
        getAnyCountry: function getAnyCountry() {
          return _this.getFirstSupportedCountry({
            countries: countries
          });
        },
        countries: countries,
        international: international,
        limitMaxLength: limitMaxLength,
        countryCallingCodeEditable: countryCallingCodeEditable,
        metadata: metadata
      }),
          phoneDigits = _onPhoneDigitsChange.phoneDigits,
          country = _onPhoneDigitsChange.country,
          value = _onPhoneDigitsChange.value;

      var stateUpdate = {
        phoneDigits: phoneDigits,
        value: value,
        country: country
      };

      if (countryCallingCodeEditable === false) {
        // If it simply did `setState({ phoneDigits: intlPrefix })` here,
        // then it would have no effect when erasing an inital international prefix
        // via Backspace, because `phoneDigits` in `state` wouldn't change
        // as a result, because it was `prefix` and it became `prefix`,
        // so the component wouldn't rerender, and the user would be able
        // to erase the country calling code part, and that part is
        // assumed to be non-eraseable. That's why the component is
        // forcefully rerendered here.
        // https://github.com/catamphetamine/react-phone-number-input/issues/367#issuecomment-721703501
        if (!value && phoneDigits === _this.state.phoneDigits) {
          // Force a re-render of the `<input/>` in order to reset its value.
          stateUpdate.forceRerender = {};
        }
      }

      _this.setState(stateUpdate, // Update the new `value` property.
      // Doing it after the `state` has been updated
      // because `onChange()` will trigger `getDerivedStateFromProps()`
      // with the new `value` which will be compared to `state.value` there.
      function () {
        return onChange(value);
      });
    });

    _defineProperty$8(_assertThisInitialized(_this), "_onFocus", function () {
      return _this.setState({
        isFocused: true
      });
    });

    _defineProperty$8(_assertThisInitialized(_this), "_onBlur", function () {
      return _this.setState({
        isFocused: false
      });
    });

    _defineProperty$8(_assertThisInitialized(_this), "onFocus", function (event) {
      _this._onFocus();

      var onFocus = _this.props.onFocus;

      if (onFocus) {
        onFocus(event);
      }
    });

    _defineProperty$8(_assertThisInitialized(_this), "onBlur", function (event) {
      var onBlur = _this.props.onBlur;

      _this._onBlur();

      if (onBlur) {
        onBlur(event);
      }
    });

    _defineProperty$8(_assertThisInitialized(_this), "onCountryFocus", function (event) {
      _this._onFocus(); // this.setState({ countrySelectFocused: true })


      var countrySelectProps = _this.props.countrySelectProps;

      if (countrySelectProps) {
        var onFocus = countrySelectProps.onFocus;

        if (onFocus) {
          onFocus(event);
        }
      }
    });

    _defineProperty$8(_assertThisInitialized(_this), "onCountryBlur", function (event) {
      _this._onBlur(); // this.setState({ countrySelectFocused: false })


      var countrySelectProps = _this.props.countrySelectProps;

      if (countrySelectProps) {
        var onBlur = countrySelectProps.onBlur;

        if (onBlur) {
          onBlur(event);
        }
      }
    });

    var _this$props3 = _this.props,
        _value = _this$props3.value,
        labels = _this$props3.labels,
        _international = _this$props3.international,
        _addInternationalOption = _this$props3.addInternationalOption,
        displayInitialValueAsLocalNumber = _this$props3.displayInitialValueAsLocalNumber,
        initialValueFormat = _this$props3.initialValueFormat,
        _metadata = _this$props3.metadata;
    var _this$props4 = _this.props,
        _defaultCountry = _this$props4.defaultCountry,
        _countries = _this$props4.countries; // Validate `defaultCountry`.

    if (_defaultCountry) {
      if (!_this.isCountrySupportedWithError(_defaultCountry)) {
        _defaultCountry = undefined;
      }
    } // Validate `countries`.


    _countries = getSupportedCountries(_countries, _metadata);
    var phoneNumber = parsePhoneNumber$2(_value, _metadata);
    _this.CountryIcon = createCountryIconComponent(_this.props);
    var preSelectedCountry = getPreSelectedCountry({
      value: _value,
      phoneNumber: phoneNumber,
      defaultCountry: _defaultCountry,
      required: !_addInternationalOption,
      countries: _countries || getCountries(_metadata),
      getAnyCountry: function getAnyCountry() {
        return _this.getFirstSupportedCountry({
          countries: _countries
        });
      },
      metadata: _metadata
    });
    _this.state = {
      // Workaround for `this.props` inside `getDerivedStateFromProps()`.
      props: _this.props,
      // The country selected.
      country: preSelectedCountry,
      // `countries` are stored in `this.state` because they're filtered.
      // For example, a developer might theoretically pass some unsupported
      // countries as part of the `countries` property, and because of that
      // the component uses `this.state.countries` (which are filtered)
      // instead of `this.props.countries`
      // (which could potentially contain unsupported countries).
      countries: _countries,
      // `phoneDigits` state property holds non-formatted user's input.
      // The reason is that there's no way of finding out
      // in which form should `value` be displayed: international or national.
      // E.g. if `value` is `+78005553535` then it could be input
      // by a user both as `8 (800) 555-35-35` and `+7 800 555 35 35`.
      // Hence storing just `value` is not sufficient for correct formatting.
      // E.g. if a user entered `8 (800) 555-35-35`
      // then value is `+78005553535` and `phoneDigits` are `88005553535`
      // and if a user entered `+7 800 555 35 35`
      // then value is `+78005553535` and `phoneDigits` are `+78005553535`.
      phoneDigits: getInitialPhoneDigits({
        value: _value,
        phoneNumber: phoneNumber,
        defaultCountry: _defaultCountry,
        international: _international,
        useNationalFormat: displayInitialValueAsLocalNumber || initialValueFormat === 'national',
        metadata: _metadata
      }),
      // `value` property is duplicated in state.
      // The reason is that `getDerivedStateFromProps()`
      // needs this `value` to compare to the new `value` property
      // to find out if `phoneDigits` needs updating:
      // If the `value` property was changed externally
      // then it won't be equal to `state.value`
      // in which case `phoneDigits` and `country` should be updated.
      value: _value
    };
    return _this;
  }

  _createClass$6(PhoneNumberInput_, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var onCountryChange = this.props.onCountryChange;
      var defaultCountry = this.props.defaultCountry;
      var selectedCountry = this.state.country;

      if (onCountryChange) {
        if (defaultCountry) {
          if (!this.isCountrySupportedWithError(defaultCountry)) {
            defaultCountry = undefined;
          }
        }

        if (selectedCountry !== defaultCountry) {
          onCountryChange(selectedCountry);
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var onCountryChange = this.props.onCountryChange;
      var country = this.state.country; // Call `onCountryChange` when user selects another country.

      if (onCountryChange && country !== prevState.country) {
        onCountryChange(country);
      }
    }
  }, {
    key: "getCountrySelectOptions",
    value: function getCountrySelectOptions$1(_ref) {
      var countries = _ref.countries;
      var _this$props5 = this.props,
          international = _this$props5.international,
          countryCallingCodeEditable = _this$props5.countryCallingCodeEditable,
          countryOptionsOrder = _this$props5.countryOptionsOrder,
          addInternationalOption = _this$props5.addInternationalOption,
          labels = _this$props5.labels,
          locales = _this$props5.locales,
          metadata = _this$props5.metadata;
      return useMemoCountrySelectOptions(function () {
        return sortCountryOptions(getCountrySelectOptions({
          countries: countries || getCountries(metadata),
          countryNames: labels,
          addInternationalOption: international && countryCallingCodeEditable === false ? false : addInternationalOption,
          compareStringsLocales: locales // compareStrings

        }), getSupportedCountryOptions(countryOptionsOrder, metadata));
      }, [countries, countryOptionsOrder, addInternationalOption, labels, metadata]);
    }
  }, {
    key: "getFirstSupportedCountry",
    value: function getFirstSupportedCountry(_ref2) {
      var countries = _ref2.countries;
      var countryOptions = this.getCountrySelectOptions({
        countries: countries
      });
      return countryOptions[0].value;
    } // A shorthand for not passing `metadata` as a second argument.

  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          name = _this$props6.name,
          disabled = _this$props6.disabled,
          autoComplete = _this$props6.autoComplete,
          style = _this$props6.style,
          className = _this$props6.className,
          inputRef = _this$props6.inputRef,
          inputComponent = _this$props6.inputComponent,
          numberInputProps = _this$props6.numberInputProps,
          smartCaret = _this$props6.smartCaret,
          CountrySelectComponent = _this$props6.countrySelectComponent,
          countrySelectProps = _this$props6.countrySelectProps,
          ContainerComponent = _this$props6.containerComponent,
          defaultCountry = _this$props6.defaultCountry,
          countriesProperty = _this$props6.countries,
          countryOptionsOrder = _this$props6.countryOptionsOrder,
          labels = _this$props6.labels,
          flags = _this$props6.flags,
          flagComponent = _this$props6.flagComponent,
          flagUrl = _this$props6.flagUrl,
          addInternationalOption = _this$props6.addInternationalOption,
          internationalIcon = _this$props6.internationalIcon,
          displayInitialValueAsLocalNumber = _this$props6.displayInitialValueAsLocalNumber,
          initialValueFormat = _this$props6.initialValueFormat,
          onCountryChange = _this$props6.onCountryChange,
          limitMaxLength = _this$props6.limitMaxLength,
          countryCallingCodeEditable = _this$props6.countryCallingCodeEditable,
          focusInputOnCountrySelection = _this$props6.focusInputOnCountrySelection,
          reset = _this$props6.reset,
          metadata = _this$props6.metadata,
          international = _this$props6.international,
          locales = _this$props6.locales,
          rest = _objectWithoutProperties$5(_this$props6, ["name", "disabled", "autoComplete", "style", "className", "inputRef", "inputComponent", "numberInputProps", "smartCaret", "countrySelectComponent", "countrySelectProps", "containerComponent", "defaultCountry", "countries", "countryOptionsOrder", "labels", "flags", "flagComponent", "flagUrl", "addInternationalOption", "internationalIcon", "displayInitialValueAsLocalNumber", "initialValueFormat", "onCountryChange", "limitMaxLength", "countryCallingCodeEditable", "focusInputOnCountrySelection", "reset", "metadata", "international", "locales"]);

      var _this$state3 = this.state,
          country = _this$state3.country,
          countries = _this$state3.countries,
          phoneDigits = _this$state3.phoneDigits,
          isFocused = _this$state3.isFocused;
      var InputComponent = smartCaret ? InputSmart : InputBasic;
      var countrySelectOptions = this.getCountrySelectOptions({
        countries: countries
      });
      return React__default.createElement(ContainerComponent, {
        style: style,
        className: classnames(className, 'PhoneInput', {
          'PhoneInput--focus': isFocused
        })
      }, React__default.createElement(CountrySelectComponent, _extends$5({
        name: name ? "".concat(name, "Country") : undefined,
        "aria-label": labels.country
      }, countrySelectProps, {
        value: country,
        options: countrySelectOptions,
        onChange: this.onCountryChange,
        onFocus: this.onCountryFocus,
        onBlur: this.onCountryBlur,
        disabled: disabled || countrySelectProps && countrySelectProps.disabled,
        iconComponent: this.CountryIcon
      })), React__default.createElement(InputComponent, _extends$5({
        ref: this.setInputRef,
        type: "tel",
        autoComplete: autoComplete
      }, numberInputProps, rest, {
        name: name,
        metadata: metadata,
        country: country,
        value: phoneDigits || '',
        onChange: this.onChange,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        disabled: disabled,
        inputComponent: inputComponent,
        className: classnames('PhoneInputInput', numberInputProps && numberInputProps.className, rest.className)
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    // `state` holds previous props as `props`, and also:
    // * `country` — The currently selected country, e.g. `"RU"`.
    // * `value` — The currently entered phone number (E.164), e.g. `+78005553535`.
    // * `phoneDigits` — The parsed `<input/>` value, e.g. `8005553535`.
    // (and a couple of other less significant properties)
    value: function getDerivedStateFromProps(props, state) {
      return _objectSpread$6({
        // Emulate `prevProps` via `state.props`.
        props: props
      }, getPhoneInputWithCountryStateUpdateFromNewProps(props, state.props, state));
    }
  }]);

  return PhoneNumberInput_;
}(React__default.PureComponent); // This wrapper is only to `.forwardRef()` to the `<input/>`.


var PhoneNumberInput = React__default.forwardRef(function (props, ref) {
  return React__default.createElement(PhoneNumberInput_, _extends$5({}, props, {
    inputRef: ref
  }));
});
PhoneNumberInput.propTypes = {
  /**
   * Phone number in `E.164` format.
   *
   * Example:
   *
   * `"+12223333333"`
   */
  value: index$4.propTypes.string,

  /**
   * Updates the `value` as the user inputs the phone number.
   */
  onChange: index$4.propTypes.func.isRequired,

  /**
   * Toggles the `--focus` CSS class.
   * @ignore
   */
  onFocus: index$4.propTypes.func,

  /**
   * `onBlur` is usually passed by `redux-form`.
   * @ignore
   */
  onBlur: index$4.propTypes.func,

  /**
   * `onKeyDown` handler (e.g. to handle Enter key press).
   * @ignore
   */
  onKeyDown: index$4.propTypes.func,

  /**
   * Set to `true` to disable both the phone number `<input/>`
   * and the country `<select/>`.
   */
  disabled: index$4.propTypes.bool,

  /**
   * Sets `autoComplete` property for phone number `<input/>`.
   *
   * Web browser's "autocomplete" feature
   * remembers the phone number being input
   * and can also autofill the `<input/>`
   * with previously remembered phone numbers.
   *
   * https://developers.google.com
   * /web/updates/2015/06/checkout-faster-with-autofill
   *
   * For example, can be used to turn it off:
   *
   * "So when should you use `autocomplete="off"`?
   *  One example is when you've implemented your own version
   *  of autocomplete for search. Another example is any form field
   *  where users will input and submit different kinds of information
   *  where it would not be useful to have the browser remember
   *  what was submitted previously".
   */
  // (is `"tel"` by default)
  autoComplete: index$4.propTypes.string.isRequired,

  /**
   * Set to `"national"` to show the initial `value` in
   * "national" format rather than "international".
   *
   * For example, if `initialValueFormat` is `"national"`
   * and the initial `value="+12133734253"` is passed
   * then the `<input/>` value will be `"(213) 373-4253"`.
   *
   * By default, `initialValueFormat` is `undefined`,
   * meaning that if the initial `value="+12133734253"` is passed
   * then the `<input/>` value will be `"+1 213 373 4253"`.
   *
   * The reason for such default behaviour is that
   * the newer generation grows up when there are no stationary phones
   * and therefore everyone inputs phone numbers in international format
   * in their smartphones so people gradually get more accustomed to
   * writing phone numbers in international format rather than in local format.
   * Future people won't be using "national" format, only "international".
   */
  // (is `undefined` by default)
  initialValueFormat: index$4.propTypes.oneOf(['national']),
  // `displayInitialValueAsLocalNumber` property has been
  // superceded by `initialValueFormat` property.
  displayInitialValueAsLocalNumber: index$4.propTypes.bool,

  /**
   * The country to be selected by default.
   * For example, can be set after a GeoIP lookup.
   *
   * Example: `"US"`.
   */
  // A two-letter country code ("ISO 3166-1 alpha-2").
  defaultCountry: index$4.propTypes.string,

  /**
   * If specified, only these countries will be available for selection.
   *
   * Example:
   *
   * `["RU", "UA", "KZ"]`
   */
  countries: index$4.propTypes.arrayOf(index$4.propTypes.string),

  /**
   * Custom country `<select/>` option names.
   * Also some labels like "ext" and country `<select/>` `aria-label`.
   *
   * Example:
   *
   * `{ "ZZ": "Международный", RU: "Россия", US: "США", ... }`
   *
   * See the `locales` directory for examples.
   */
  labels: labels.isRequired,

  /**
   * Country `<select/>` options are sorted by their labels.
   * The default sorting function uses `a.localeCompare(b, locales)`,
   * and, if that's not available, falls back to simple `a > b` / `a < b`.
   * Some languages, like Chinese, support multiple sorting variants
   * (called "collations"), and the user might prefer one or another.
   * Also, sometimes the Operating System language is not always
   * the preferred language for a person using a website or an application,
   * so there should be a way to specify custom locale.
   * This `locales` property mimicks the `locales` argument of `Intl` constructors,
   * and can be either a Unicode BCP 47 locale identifier or an array of such locale identifiers.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument
   */
  locales: index$4.propTypes.oneOfType([index$4.propTypes.string, index$4.propTypes.arrayOf(index$4.propTypes.string)]),

  /*
   * Custom country `<select/>` options sorting function.
   * The default one uses `a.localeCompare(b)`, and,
   * if that's not available, falls back to simple `a > b`/`a < b`.
   * There have been requests to add custom sorter for cases
   * like Chinese language and "pinyin" (non-default) sorting order.
   * https://stackoverflow.com/questions/22907288/chinese-sorting-by-pinyin-in-javascript-with-localecompare
  compareStrings: PropTypes.func,
   */

  /**
   * A URL template of a country flag, where
   * "{XX}" is a two-letter country code in upper case,
   * or where "{xx}" is a two-letter country code in lower case.
   * By default it points to `country-flag-icons` gitlab pages website.
   * I imagine someone might want to download those country flag icons
   * and host them on their own servers instead
   * (all flags are available in the `country-flag-icons` library).
   * There's a catch though: new countries may be added in future,
   * so when hosting country flag icons on your own server
   * one should check the `CHANGELOG.md` every time before updating this library,
   * otherwise there's a possibility that some new country flag would be missing.
   */
  flagUrl: index$4.propTypes.string.isRequired,

  /**
   * Custom country flag icon components.
   * These flags will be used instead of the default ones.
   * The the "Flags" section of the readme for more info.
   *
   * The shape is an object where keys are country codes
   * and values are flag icon components.
   * Flag icon components receive the same properties
   * as `flagComponent` (see below).
   *
   * Example:
   *
   * `{ "RU": (props) => <img src="..."/> }`
   *
   * Example:
   *
   * `import flags from 'country-flag-icons/react/3x2'`
   *
   * `import PhoneInput from 'react-phone-number-input'`
   *
   * `<PhoneInput flags={flags} .../>`
   */
  flags: index$4.propTypes.objectOf(index$4.propTypes.elementType),

  /**
   * Country flag icon component.
   *
   * Takes properties:
   *
   * * `country: string` — The country code.
   * * `countryName: string` — The country name.
   * * `flagUrl: string` — The `flagUrl` property (see above).
   * * `flags: object` — The `flags` property (see above).
   */
  flagComponent: index$4.propTypes.elementType.isRequired,

  /**
   * Set to `false` to remove the "International" option from country `<select/>`.
   */
  addInternationalOption: index$4.propTypes.bool.isRequired,

  /**
   * "International" icon component.
   * Should have the same aspect ratio.
   *
   * Receives properties:
   *
   * * `title: string` — "International" country option label.
   */
  internationalIcon: index$4.propTypes.elementType.isRequired,

  /**
   * Can be used to place some countries on top of the list of country `<select/>` options.
   *
   * * `"XX"` — inserts an option for "XX" country.
   * * `"🌐"` — inserts "International" option.
   * * `"|"` — inserts a separator.
   * * `"..."` — inserts options for the rest of the countries (can be omitted, in which case it will be automatically added at the end).
   *
   * Example:
   *
   * `["US", "CA", "AU", "|", "..."]`
   */
  countryOptionsOrder: index$4.propTypes.arrayOf(index$4.propTypes.string),

  /**
   * `<Phone/>` component CSS style object.
   */
  style: index$4.propTypes.object,

  /**
   * `<Phone/>` component CSS class.
   */
  className: index$4.propTypes.string,

  /**
   * Country `<select/>` component.
   *
   * Receives properties:
   *
   * * `name: string?` — HTML `name` attribute.
   * * `value: string?` — The currently selected country code.
   * * `onChange(value: string?)` — Updates the `value`.
   * * `onFocus()` — Is used to toggle the `--focus` CSS class.
   * * `onBlur()` — Is used to toggle the `--focus` CSS class.
   * * `options: object[]` — The list of all selectable countries (including "International") each being an object of shape `{ value: string?, label: string }`.
   * * `iconComponent: PropTypes.elementType` — React component that renders a country icon: `<Icon country={value}/>`. If `country` is `undefined` then it renders an "International" icon.
   * * `disabled: boolean?` — HTML `disabled` attribute.
   * * `tabIndex: (number|string)?` — HTML `tabIndex` attribute.
   * * `className: string` — CSS class name.
   */
  countrySelectComponent: index$4.propTypes.elementType.isRequired,

  /**
   * Country `<select/>` component props.
   * Along with the usual DOM properties such as `aria-label` and `tabIndex`,
   * some custom properties are supported, such as `arrowComponent` and `unicodeFlags`.
   */
  countrySelectProps: index$4.propTypes.object,

  /**
   * Phone number `<input/>` component.
   *
   * Receives properties:
   *
   * * `value: string` — The formatted `value`.
   * * `onChange(event: Event)` — Updates the formatted `value` from `event.target.value`.
   * * `onFocus()` — Is used to toggle the `--focus` CSS class.
   * * `onBlur()` — Is used to toggle the `--focus` CSS class.
   * * Other properties like `type="tel"` or `autoComplete="tel"` that should be passed through to the DOM `<input/>`.
   *
   * Must also either use `React.forwardRef()` to "forward" `ref` to the `<input/>` or implement `.focus()` method.
   */
  inputComponent: index$4.propTypes.elementType.isRequired,

  /**
   * Wrapping `<div/>` component.
   *
   * Receives properties:
   *
   * * `style: object` — A component CSS style object.
   * * `className: string` — Classes to attach to the component, typically changes when component focuses or blurs.
   */
  containerComponent: index$4.propTypes.elementType.isRequired,

  /**
   * Phone number `<input/>` component props.
   */
  numberInputProps: index$4.propTypes.object,

  /**
   * By default, the caret position is being "intelligently" managed
   * while a user inputs a phone number.
   * This "smart" caret behavior can be turned off
   * by passing `smartCaret={false}` property.
   * This is just an "escape hatch" for any possible caret position issues.
   */
  // Is `true` by default.
  smartCaret: index$4.propTypes.bool.isRequired,

  /**
   * Set to `true` to force "international" phone number format.
   * Set to `false` to force "national" phone number format.
   * By default it's `undefined` meaning that it doesn't enforce any phone number format.
   */
  international: index$4.propTypes.bool,

  /**
   * If set to `true`, the phone number input will get trimmed
   * if it exceeds the maximum length for the country.
   */
  limitMaxLength: index$4.propTypes.bool.isRequired,

  /**
   * If set to `false`, and `international` is `true`, then
   * users won't be able to erase the "country calling part"
   * of a phone number in the `<input/>`.
   */
  countryCallingCodeEditable: index$4.propTypes.bool.isRequired,

  /**
   * `libphonenumber-js` metadata.
   *
   * Can be used to pass custom `libphonenumber-js` metadata
   * to reduce the overall bundle size for those who compile "custom" metadata.
   */
  metadata: metadata$1.isRequired,

  /**
   * Is called every time the selected country changes:
   * either programmatically or when user selects it manually from the list.
   */
  // People have been asking for a way to get the selected country.
  // @see  https://github.com/catamphetamine/react-phone-number-input/issues/128
  // For some it's just a "business requirement".
  // I guess it's about gathering as much info on the user as a website can
  // without introducing any addional fields that would complicate the form
  // therefore reducing "conversion" (that's a marketing term).
  // Assuming that the phone number's country is the user's country
  // is not 100% correct but in most cases I guess it's valid.
  onCountryChange: index$4.propTypes.func,

  /**
   * If set to `false`, will not focus the `<input/>` component
   * when the user selects a country from the list of countries.
   * This can be used to conform to the Web Content Accessibility Guidelines (WCAG).
   * Quote:
   * "On input: Changing the setting of any user interface component
   *  does not automatically cause a change of context unless the user
   *  has been advised of the behaviour before using the component."
   */
  focusInputOnCountrySelection: index$4.propTypes.bool.isRequired
};
PhoneNumberInput.defaultProps = {
  /**
   * Remember (and autofill) the value as a phone number.
   */
  autoComplete: 'tel',

  /**
   * Flag icon component.
   */
  flagComponent: FlagComponent,

  /**
   * By default, uses icons from `country-flag-icons` gitlab pages website.
   */
  // Must be equal to `flagUrl` in `./CountryIcon.js`.
  flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg',

  /**
   * Default "International" country `<select/>` option icon.
   */
  internationalIcon: InternationalIcon,

  /**
   * Phone number `<input/>` component.
   */
  inputComponent: 'input',

  /**
   * Wrapping `<div/>` component.
   */
  containerComponent: 'div',

  /**
   * Some users requested a way to reset the component:
   * both number `<input/>` and country `<select/>`.
   * Whenever `reset` property changes both number `<input/>`
   * and country `<select/>` are reset.
   * It's not implemented as some instance `.reset()` method
   * because `ref` is forwarded to `<input/>`.
   * It's also not replaced with just resetting `country` on
   * external `value` reset, because a user could select a country
   * and then not input any `value`, and so the selected country
   * would be "stuck", if not using this `reset` property.
   */
  // https://github.com/catamphetamine/react-phone-number-input/issues/300
  reset: index$4.propTypes.any,

  /**
   *
   */

  /**
   * Set to `false` to use "basic" caret instead of the "smart" one.
   */
  smartCaret: true,

  /**
   * Whether to add the "International" option
   * to the list of countries.
   */
  addInternationalOption: true,

  /**
   * If set to `true` the phone number input will get trimmed
   * if it exceeds the maximum length for the country.
   */
  limitMaxLength: false,

  /**
   * If set to `false`, and `international` is `true`, then
   * users won't be able to erase the "country calling part"
   * of a phone number in the `<input/>`.
   */
  countryCallingCodeEditable: true,

  /**
   * If set to `false`, will not focus the `<input/>` component
   * when the user selects a country from the list of countries.
   * This can be used to conform to the Web Content Accessibility Guidelines (WCAG).
   * Quote:
   * "On input: Changing the setting of any user interface component
   *  does not automatically cause a change of context unless the user
   *  has been advised of the behaviour before using the component."
   */
  focusInputOnCountrySelection: true
};
var countrySelectOptionsMemo;
var countrySelectOptionsMemoDependencies;

function useMemoCountrySelectOptions(generator, dependencies) {
  if (!countrySelectOptionsMemoDependencies || !areEqualArrays(dependencies, countrySelectOptionsMemoDependencies)) {
    countrySelectOptionsMemo = generator();
    countrySelectOptionsMemoDependencies = dependencies;
  }

  return countrySelectOptionsMemo;
}

function areEqualArrays(a, b) {
  if (a.length !== b.length) {
    return false;
  }

  var i = 0;

  while (i < a.length) {
    if (a[i] !== b[i]) {
      return false;
    }

    i++;
  }

  return true;
}

var ext = "ext.";
var country = "Phone number country";
var phone = "Phone";
var AB = "Abkhazia";
var AC = "Ascension Island";
var AD = "Andorra";
var AE = "United Arab Emirates";
var AF = "Afghanistan";
var AG = "Antigua and Barbuda";
var AI = "Anguilla";
var AL = "Albania";
var AM = "Armenia";
var AO = "Angola";
var AQ = "Antarctica";
var AR = "Argentina";
var AS = "American Samoa";
var AT = "Austria";
var AU = "Australia";
var AW = "Aruba";
var AX = "Åland Islands";
var AZ = "Azerbaijan";
var BA = "Bosnia and Herzegovina";
var BB = "Barbados";
var BD = "Bangladesh";
var BE = "Belgium";
var BF = "Burkina Faso";
var BG = "Bulgaria";
var BH = "Bahrain";
var BI = "Burundi";
var BJ = "Benin";
var BL = "Saint Barthélemy";
var BM = "Bermuda";
var BN = "Brunei Darussalam";
var BO = "Bolivia";
var BQ = "Bonaire, Sint Eustatius and Saba";
var BR = "Brazil";
var BS = "Bahamas";
var BT = "Bhutan";
var BV = "Bouvet Island";
var BW = "Botswana";
var BY = "Belarus";
var BZ = "Belize";
var CA = "Canada";
var CC = "Cocos (Keeling) Islands";
var CD = "Congo, Democratic Republic of the";
var CF = "Central African Republic";
var CG = "Congo";
var CH = "Switzerland";
var CI = "Cote d'Ivoire";
var CK = "Cook Islands";
var CL = "Chile";
var CM = "Cameroon";
var CN = "China";
var CO = "Colombia";
var CR = "Costa Rica";
var CU = "Cuba";
var CV = "Cape Verde";
var CW = "Curaçao";
var CX = "Christmas Island";
var CY = "Cyprus";
var CZ = "Czech Republic";
var DE = "Germany";
var DJ = "Djibouti";
var DK = "Denmark";
var DM = "Dominica";
var DO = "Dominican Republic";
var DZ = "Algeria";
var EC = "Ecuador";
var EE = "Estonia";
var EG = "Egypt";
var EH = "Western Sahara";
var ER = "Eritrea";
var ES = "Spain";
var ET = "Ethiopia";
var FI = "Finland";
var FJ = "Fiji";
var FK = "Falkland Islands";
var FM = "Federated States of Micronesia";
var FO = "Faroe Islands";
var FR = "France";
var GA = "Gabon";
var GB = "United Kingdom";
var GD = "Grenada";
var GE = "Georgia";
var GF = "French Guiana";
var GG = "Guernsey";
var GH = "Ghana";
var GI = "Gibraltar";
var GL = "Greenland";
var GM = "Gambia";
var GN = "Guinea";
var GP = "Guadeloupe";
var GQ = "Equatorial Guinea";
var GR = "Greece";
var GS = "South Georgia and the South Sandwich Islands";
var GT = "Guatemala";
var GU = "Guam";
var GW = "Guinea-Bissau";
var GY = "Guyana";
var HK = "Hong Kong";
var HM = "Heard Island and McDonald Islands";
var HN = "Honduras";
var HR = "Croatia";
var HT = "Haiti";
var HU = "Hungary";
var ID = "Indonesia";
var IE = "Ireland";
var IL = "Israel";
var IM = "Isle of Man";
var IN = "India";
var IO = "British Indian Ocean Territory";
var IQ = "Iraq";
var IR = "Iran";
var IS = "Iceland";
var IT = "Italy";
var JE = "Jersey";
var JM = "Jamaica";
var JO = "Jordan";
var JP = "Japan";
var KE = "Kenya";
var KG = "Kyrgyzstan";
var KH = "Cambodia";
var KI = "Kiribati";
var KM = "Comoros";
var KN = "Saint Kitts and Nevis";
var KP = "North Korea";
var KR = "South Korea";
var KW = "Kuwait";
var KY = "Cayman Islands";
var KZ = "Kazakhstan";
var LA = "Laos";
var LB = "Lebanon";
var LC = "Saint Lucia";
var LI = "Liechtenstein";
var LK = "Sri Lanka";
var LR = "Liberia";
var LS = "Lesotho";
var LT = "Lithuania";
var LU = "Luxembourg";
var LV = "Latvia";
var LY = "Libya";
var MA = "Morocco";
var MC = "Monaco";
var MD = "Moldova";
var ME = "Montenegro";
var MF = "Saint Martin (French Part)";
var MG = "Madagascar";
var MH = "Marshall Islands";
var MK = "North Macedonia";
var ML = "Mali";
var MM = "Burma";
var MN = "Mongolia";
var MO = "Macao";
var MP = "Northern Mariana Islands";
var MQ = "Martinique";
var MR = "Mauritania";
var MS = "Montserrat";
var MT = "Malta";
var MU = "Mauritius";
var MV = "Maldives";
var MW = "Malawi";
var MX = "Mexico";
var MY = "Malaysia";
var MZ = "Mozambique";
var NA = "Namibia";
var NC = "New Caledonia";
var NE = "Niger";
var NF = "Norfolk Island";
var NG = "Nigeria";
var NI = "Nicaragua";
var NL = "Netherlands";
var NO = "Norway";
var NP = "Nepal";
var NR = "Nauru";
var NU = "Niue";
var NZ = "New Zealand";
var OM = "Oman";
var OS = "South Ossetia";
var PA = "Panama";
var PE = "Peru";
var PF = "French Polynesia";
var PG = "Papua New Guinea";
var PH = "Philippines";
var PK = "Pakistan";
var PL = "Poland";
var PM = "Saint Pierre and Miquelon";
var PN = "Pitcairn";
var PR = "Puerto Rico";
var PS = "Palestine";
var PT = "Portugal";
var PW = "Palau";
var PY = "Paraguay";
var QA = "Qatar";
var RE = "Reunion";
var RO = "Romania";
var RS = "Serbia";
var RU = "Russia";
var RW = "Rwanda";
var SA = "Saudi Arabia";
var SB = "Solomon Islands";
var SC = "Seychelles";
var SD = "Sudan";
var SE = "Sweden";
var SG = "Singapore";
var SH = "Saint Helena";
var SI = "Slovenia";
var SJ = "Svalbard and Jan Mayen";
var SK = "Slovakia";
var SL = "Sierra Leone";
var SM = "San Marino";
var SN = "Senegal";
var SO = "Somalia";
var SR = "Suriname";
var SS = "South Sudan";
var ST = "Sao Tome and Principe";
var SV = "El Salvador";
var SX = "Sint Maarten";
var SY = "Syria";
var SZ = "Swaziland";
var TA = "Tristan da Cunha";
var TC = "Turks and Caicos Islands";
var TD = "Chad";
var TF = "French Southern Territories";
var TG = "Togo";
var TH = "Thailand";
var TJ = "Tajikistan";
var TK = "Tokelau";
var TL = "Timor-Leste";
var TM = "Turkmenistan";
var TN = "Tunisia";
var TO = "Tonga";
var TR = "Turkey";
var TT = "Trinidad and Tobago";
var TV = "Tuvalu";
var TW = "Taiwan";
var TZ = "Tanzania";
var UA = "Ukraine";
var UG = "Uganda";
var UM = "United States Minor Outlying Islands";
var US = "United States";
var UY = "Uruguay";
var UZ = "Uzbekistan";
var VA = "Holy See (Vatican City State)";
var VC = "Saint Vincent and the Grenadines";
var VE = "Venezuela";
var VG = "Virgin Islands, British";
var VI = "Virgin Islands, U.S.";
var VN = "Vietnam";
var VU = "Vanuatu";
var WF = "Wallis and Futuna";
var WS = "Samoa";
var XK = "Kosovo";
var YE = "Yemen";
var YT = "Mayotte";
var ZA = "South Africa";
var ZM = "Zambia";
var ZW = "Zimbabwe";
var ZZ = "International";
var labels$1 = {
	ext: ext,
	country: country,
	phone: phone,
	AB: AB,
	AC: AC,
	AD: AD,
	AE: AE,
	AF: AF,
	AG: AG,
	AI: AI,
	AL: AL,
	AM: AM,
	AO: AO,
	AQ: AQ,
	AR: AR,
	AS: AS,
	AT: AT,
	AU: AU,
	AW: AW,
	AX: AX,
	AZ: AZ,
	BA: BA,
	BB: BB,
	BD: BD,
	BE: BE,
	BF: BF,
	BG: BG,
	BH: BH,
	BI: BI,
	BJ: BJ,
	BL: BL,
	BM: BM,
	BN: BN,
	BO: BO,
	BQ: BQ,
	BR: BR,
	BS: BS,
	BT: BT,
	BV: BV,
	BW: BW,
	BY: BY,
	BZ: BZ,
	CA: CA,
	CC: CC,
	CD: CD,
	CF: CF,
	CG: CG,
	CH: CH,
	CI: CI,
	CK: CK,
	CL: CL,
	CM: CM,
	CN: CN,
	CO: CO,
	CR: CR,
	CU: CU,
	CV: CV,
	CW: CW,
	CX: CX,
	CY: CY,
	CZ: CZ,
	DE: DE,
	DJ: DJ,
	DK: DK,
	DM: DM,
	DO: DO,
	DZ: DZ,
	EC: EC,
	EE: EE,
	EG: EG,
	EH: EH,
	ER: ER,
	ES: ES,
	ET: ET,
	FI: FI,
	FJ: FJ,
	FK: FK,
	FM: FM,
	FO: FO,
	FR: FR,
	GA: GA,
	GB: GB,
	GD: GD,
	GE: GE,
	GF: GF,
	GG: GG,
	GH: GH,
	GI: GI,
	GL: GL,
	GM: GM,
	GN: GN,
	GP: GP,
	GQ: GQ,
	GR: GR,
	GS: GS,
	GT: GT,
	GU: GU,
	GW: GW,
	GY: GY,
	HK: HK,
	HM: HM,
	HN: HN,
	HR: HR,
	HT: HT,
	HU: HU,
	ID: ID,
	IE: IE,
	IL: IL,
	IM: IM,
	IN: IN,
	IO: IO,
	IQ: IQ,
	IR: IR,
	IS: IS,
	IT: IT,
	JE: JE,
	JM: JM,
	JO: JO,
	JP: JP,
	KE: KE,
	KG: KG,
	KH: KH,
	KI: KI,
	KM: KM,
	KN: KN,
	KP: KP,
	KR: KR,
	KW: KW,
	KY: KY,
	KZ: KZ,
	LA: LA,
	LB: LB,
	LC: LC,
	LI: LI,
	LK: LK,
	LR: LR,
	LS: LS,
	LT: LT,
	LU: LU,
	LV: LV,
	LY: LY,
	MA: MA,
	MC: MC,
	MD: MD,
	ME: ME,
	MF: MF,
	MG: MG,
	MH: MH,
	MK: MK,
	ML: ML,
	MM: MM,
	MN: MN,
	MO: MO,
	MP: MP,
	MQ: MQ,
	MR: MR,
	MS: MS,
	MT: MT,
	MU: MU,
	MV: MV,
	MW: MW,
	MX: MX,
	MY: MY,
	MZ: MZ,
	NA: NA,
	NC: NC,
	NE: NE,
	NF: NF,
	NG: NG,
	NI: NI,
	NL: NL,
	NO: NO,
	NP: NP,
	NR: NR,
	NU: NU,
	NZ: NZ,
	OM: OM,
	OS: OS,
	PA: PA,
	PE: PE,
	PF: PF,
	PG: PG,
	PH: PH,
	PK: PK,
	PL: PL,
	PM: PM,
	PN: PN,
	PR: PR,
	PS: PS,
	PT: PT,
	PW: PW,
	PY: PY,
	QA: QA,
	RE: RE,
	RO: RO,
	RS: RS,
	RU: RU,
	RW: RW,
	SA: SA,
	SB: SB,
	SC: SC,
	SD: SD,
	SE: SE,
	SG: SG,
	SH: SH,
	SI: SI,
	SJ: SJ,
	SK: SK,
	SL: SL,
	SM: SM,
	SN: SN,
	SO: SO,
	SR: SR,
	SS: SS,
	ST: ST,
	SV: SV,
	SX: SX,
	SY: SY,
	SZ: SZ,
	TA: TA,
	TC: TC,
	TD: TD,
	TF: TF,
	TG: TG,
	TH: TH,
	TJ: TJ,
	TK: TK,
	TL: TL,
	TM: TM,
	TN: TN,
	TO: TO,
	TR: TR,
	TT: TT,
	TV: TV,
	TW: TW,
	TZ: TZ,
	UA: UA,
	UG: UG,
	UM: UM,
	US: US,
	UY: UY,
	UZ: UZ,
	VA: VA,
	VC: VC,
	VE: VE,
	VG: VG,
	VI: VI,
	VN: VN,
	VU: VU,
	WF: WF,
	WS: WS,
	XK: XK,
	YE: YE,
	YT: YT,
	ZA: ZA,
	ZM: ZM,
	ZW: ZW,
	ZZ: ZZ
};

/**
 * Creates Unicode flag from a two-letter ISO country code.
 * https://stackoverflow.com/questions/24050671/how-to-put-japan-flag-character-in-a-string
 * @param  {string} country — A two-letter ISO country code (case-insensitive).
 * @return {string}
 */
function getCountryFlag(country) {
  return getRegionalIndicatorSymbol(country[0]) + getRegionalIndicatorSymbol(country[1]);
}
/**
 * Converts a letter to a Regional Indicator Symbol.
 * @param  {string} letter
 * @return {string}
 */

function getRegionalIndicatorSymbol(letter) {
  return String.fromCodePoint(0x1F1E6 - 65 + letter.toUpperCase().charCodeAt(0));
}

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

function _objectWithoutProperties$6(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$6(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$6(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function CountrySelect(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      options = _ref.options,
      rest = _objectWithoutProperties$6(_ref, ["value", "onChange", "options"]);

  var onChange_ = React.useCallback(function (event) {
    var value = event.target.value;
    onChange(value === 'ZZ' ? undefined : value);
  }, [onChange]);
  var selectedOption = React.useMemo(function () {
    return getSelectedOption(options, value);
  }, [options, value]); // "ZZ" means "International".
  // (HTML requires each `<option/>` have some string `value`).

  return React__default.createElement("select", _extends$6({}, rest, {
    value: value || 'ZZ',
    onChange: onChange_
  }), options.map(function (_ref2) {
    var value = _ref2.value,
        label = _ref2.label,
        divider = _ref2.divider;
    return React__default.createElement("option", {
      key: divider ? '|' : value || 'ZZ',
      value: divider ? '|' : value || 'ZZ',
      disabled: divider ? true : false,
      style: divider ? DIVIDER_STYLE : undefined
    }, label);
  }));
}
CountrySelect.propTypes = {
  /**
   * A two-letter country code.
   * Example: "US", "RU", etc.
   */
  value: index$4.propTypes.string,

  /**
   * Updates the `value`.
   */
  onChange: index$4.propTypes.func.isRequired,
  // `<select/>` options.
  options: index$4.propTypes.arrayOf(index$4.propTypes.shape({
    value: index$4.propTypes.string,
    label: index$4.propTypes.string,
    divider: index$4.propTypes.bool
  })).isRequired
};
var DIVIDER_STYLE = {
  fontSize: '1px',
  backgroundColor: 'currentColor',
  color: 'inherit'
};
function CountrySelectWithIcon(_ref3) {
  var value = _ref3.value,
      options = _ref3.options,
      className = _ref3.className,
      Icon = _ref3.iconComponent,
      getIconAspectRatio = _ref3.getIconAspectRatio,
      Arrow = _ref3.arrowComponent,
      unicodeFlags = _ref3.unicodeFlags,
      rest = _objectWithoutProperties$6(_ref3, ["value", "options", "className", "iconComponent", "getIconAspectRatio", "arrowComponent", "unicodeFlags"]);

  var selectedOption = React.useMemo(function () {
    return getSelectedOption(options, value);
  }, [options, value]);
  return React__default.createElement("div", {
    className: "PhoneInputCountry"
  }, React__default.createElement(CountrySelect, _extends$6({}, rest, {
    value: value,
    options: options,
    className: classnames('PhoneInputCountrySelect', className)
  })), unicodeFlags && value && React__default.createElement("div", {
    className: "PhoneInputCountryIconUnicode"
  }, getCountryFlag(value)), !(unicodeFlags && value) && React__default.createElement(Icon, {
    country: value,
    label: selectedOption && selectedOption.label,
    aspectRatio: unicodeFlags ? 1 : undefined
  }), React__default.createElement(Arrow, null));
}
CountrySelectWithIcon.propTypes = {
  // Country flag component.
  iconComponent: index$4.propTypes.elementType,
  // Select arrow component.
  arrowComponent: index$4.propTypes.elementType.isRequired,
  // Set to `true` to render Unicode flag icons instead of SVG images.
  unicodeFlags: index$4.propTypes.bool
};
CountrySelectWithIcon.defaultProps = {
  // Is "International" icon square?
  arrowComponent: function arrowComponent() {
    return React__default.createElement("div", {
      className: "PhoneInputCountrySelectArrow"
    });
  }
};

function getSelectedOption(options, value) {
  for (var _iterator = options, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref4;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref4 = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref4 = _i.value;
    }

    var option = _ref4;

    if (!option.divider && option.value === value) {
      return option;
    }
  }
}

function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
function createPhoneInput(defaultMetadata) {
  var PhoneInputDefault = React__default.forwardRef(function (props, ref) {
    return React__default.createElement(PhoneNumberInput, _extends$7({
      ref: ref
    }, props));
  });
  PhoneInputDefault.propTypes = {
    metadata: metadata$1.isRequired,
    labels: labels.isRequired,
    countrySelectComponent: index$4.propTypes.elementType.isRequired
  };
  PhoneInputDefault.defaultProps = {
    metadata: defaultMetadata,
    labels: labels$1,
    countrySelectComponent: CountrySelectWithIcon
  };
  return PhoneInputDefault;
}
createPhoneInput();

var PhoneInput = createPhoneInput(metadata);

var PhoneNumberInput$1 = styled__default(PhoneInput)(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  height: 48px;\n  border: 1px solid ", ";\n  padding: 0 16px;\n  background-color: transparent;\n  border-radius: 4px;\n  &.PhoneInput--focus {\n    border-color: ", ";\n    box-shadow: 0px 4px 6px ", ",\n      0px 0px 2px ", ";\n    .PhoneInputInput {\n      border: 0 none;\n      outline: none;\n    }\n  }\n  &:not(.PhoneInput--focus):hover {\n    border-color: ", ";\n  }\n  .PhoneInputInput {\n    border: 0 none;\n    height: 100%;\n    font: 14px/22px ", ";\n    @media only screen and (max-width: 768px) {\n      font-size: 16px;\n    }\n  }\n  ", "\n"], ["\n  height: 48px;\n  border: 1px solid ", ";\n  padding: 0 16px;\n  background-color: transparent;\n  border-radius: 4px;\n  &.PhoneInput--focus {\n    border-color: ", ";\n    box-shadow: 0px 4px 6px ", ",\n      0px 0px 2px ", ";\n    .PhoneInputInput {\n      border: 0 none;\n      outline: none;\n    }\n  }\n  &:not(.PhoneInput--focus):hover {\n    border-color: ", ";\n  }\n  .PhoneInputInput {\n    border: 0 none;\n    height: 100%;\n    font: 14px/22px ", ";\n    @media only screen and (max-width: 768px) {\n      font-size: 16px;\n    }\n  }\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyMedium;
}, function (_a) {
    var theme = _a.theme;
    return theme.defaultColors.primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.colorsRgba.primary_1;
}, function (_a) {
    var theme = _a.theme;
    return theme.colorsRgba.primary_1;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyMediumAlt;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var isErrored = _a.isErrored;
    return isErrored
        && styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n      border-color: ", ";\n      box-shadow: 0px 4px 6px ", ",\n        0px 0px 2px ", ";\n    "], ["\n      border-color: ", ";\n      box-shadow: 0px 4px 6px ", ",\n        0px 0px 2px ", ";\n    "])), function (_a) {
            var theme = _a.theme;
            return theme.defaultColors.admin.pink;
        }, function (_a) {
            var theme = _a.theme;
            return theme.colorsRgba.pink_1;
        }, function (_a) {
            var theme = _a.theme;
            return theme.colorsRgba.pink_1;
        });
});
var StyledExclamationMark = styled__default(exclamationMark.ExclamationMark)(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 14px;\n  bottom: 0;\n  margin: auto;\n"], ["\n  position: absolute;\n  top: 0;\n  right: 14px;\n  bottom: 0;\n  margin: auto;\n"])));
var InputWrapper = styled__default.div(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

var FormPhoneInput = function (_a) {
    var _b;
    var fieldName = _a.fieldName, value = _a.value, onBlur = _a.onBlur, setValue = _a.setValue, isErrored = _a.isErrored, _c = _a.label, label = _c === void 0 ? '' : _c, _d = _a.dataCy, dataCy = _d === void 0 ? '' : _d, _e = _a.required, required = _e === void 0 ? true : _e, _f = _a.placeholder, placeholder = _f === void 0 ? '' : _f, _g = _a.country, country = _g === void 0 ? '' : _g;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(fieldLabel.FieldLabel, { label: label, required: required, dataCy: dataCy + "-label" }),
        React__default.createElement(InputWrapper, null,
            React__default.createElement(PhoneNumberInput$1, { name: fieldName, value: value, onChange: setValue, onBlur: onBlur, placeholder: placeholder, "data-testid": "phone-input", required: required, defaultCountry: (_b = country === null || country === void 0 ? void 0 : country.toUpperCase()) !== null && _b !== void 0 ? _b : 'US', isErrored: isErrored, "aria-label": "phone-number" }),
            isErrored && React__default.createElement(StyledExclamationMark, { "data-testid": "exclamation-mark", variant: "pink" }))));
};
FormPhoneInput.defaultProps = {
    required: true,
    country: 'US',
    isErrored: false,
    label: '',
    dataCy: '',
};

exports.FormPhoneInput = FormPhoneInput;
